// @ts-nocheck
/**
 * THIS FILE IS AUTO-GENERATED by graphql-codegen
 * (graphql-codegen-typescript-validation-schema), then post-processed by
 * apps/hub/scripts/fix-validation-types.js. DO NOT EDIT.
 *
 * Regenerate with `npm run gen:db-types` in apps/hub.
 */
import { z } from "zod";
import type {
  // @ts-nocheck
  Time_Entry_Type, // @ts-nocheck
  Ticket_Status, // @ts-nocheck
  Ticket_Priority, // @ts-nocheck
  Ticket_Category, // @ts-nocheck
  Sync_Status, // @ts-nocheck
  Sequence_Target, // @ts-nocheck
  Sequence_Region_Hint, // @ts-nocheck
  Sequence_Step_Outcome, // @ts-nocheck
  Sequence_Channel, // @ts-nocheck
  Sequence_Enrollment_Status, // @ts-nocheck
  Discount_Type, // @ts-nocheck
  Deal_Status, // @ts-nocheck
  Deal_Stage, // @ts-nocheck
  Task_Status, // @ts-nocheck
  Contact_Status, // @ts-nocheck
  Proposal_Status, // @ts-nocheck
  Note_Type, // @ts-nocheck
  Meeting_Status, // @ts-nocheck
  Project_Health_Status, // @ts-nocheck
  OrderByDirection, // @ts-nocheck
  User_PreferencesOrderBy, // @ts-nocheck
  User_Oauth_ConnectionsOrderBy, // @ts-nocheck
  Time_EntriesOrderBy, // @ts-nocheck
  TicketsOrderBy, // @ts-nocheck
  Ticket_UpdatesOrderBy, // @ts-nocheck
  Ticket_TemplatesOrderBy, // @ts-nocheck
  Ticket_AttachmentsOrderBy, // @ts-nocheck
  Task_NotesOrderBy, // @ts-nocheck
  Social_Media_PostsOrderBy, // @ts-nocheck
  Social_Hashtag_GroupsOrderBy, // @ts-nocheck
  Social_Brand_CredentialsOrderBy, // @ts-nocheck
  Social_Brand_ChannelsOrderBy, // @ts-nocheck
  Slack_Processed_EventsOrderBy, // @ts-nocheck
  Slack_Channel_ProvisioningOrderBy, // @ts-nocheck
  Skills_CatalogOrderBy, // @ts-nocheck
  Secure_LinksOrderBy, // @ts-nocheck
  Scheduled_SmsOrderBy, // @ts-nocheck
  Scheduled_EmailsOrderBy, // @ts-nocheck
  Saved_ViewsOrderBy, // @ts-nocheck
  Saved_View_FavoritesOrderBy, // @ts-nocheck
  Sales_SequencesOrderBy, // @ts-nocheck
  Sales_Sequence_StepsOrderBy, // @ts-nocheck
  Sales_Sequence_Step_EventsOrderBy, // @ts-nocheck
  Sales_Sequence_EnrollmentsOrderBy, // @ts-nocheck
  RolesOrderBy, // @ts-nocheck
  Revenue_TargetsOrderBy, // @ts-nocheck
  Recurring_TransactionsOrderBy, // @ts-nocheck
  Recurring_ChargesOrderBy, // @ts-nocheck
  Rate_Limit_BucketsOrderBy, // @ts-nocheck
  Quickbooks_Realm_LabelsOrderBy, // @ts-nocheck
  Quickbooks_Customer_Link_IgnoresOrderBy, // @ts-nocheck
  Quickbooks_Company_Customer_AcksOrderBy, // @ts-nocheck
  Queue_Event_LogOrderBy, // @ts-nocheck
  Project_Chat_SubscriptionsOrderBy, // @ts-nocheck
  Post_Audit_InvoicesOrderBy, // @ts-nocheck
  Post_Audit_Invoice_FeedbackOrderBy, // @ts-nocheck
  Post_Audit_DocumentsOrderBy, // @ts-nocheck
  Post_Audit_Cron_LogsOrderBy, // @ts-nocheck
  Plaid_TransactionsOrderBy, // @ts-nocheck
  Plaid_Transaction_AttributionsOrderBy, // @ts-nocheck
  Plaid_StatementsOrderBy, // @ts-nocheck
  Plaid_ItemsOrderBy, // @ts-nocheck
  Plaid_AccountsOrderBy, // @ts-nocheck
  Pending_ApprovalsOrderBy, // @ts-nocheck
  OfferingsOrderBy, // @ts-nocheck
  Notification_PreferencesOrderBy, // @ts-nocheck
  Notetaker_Summary_LogOrderBy, // @ts-nocheck
  Msp_DocumentsOrderBy, // @ts-nocheck
  Mrr_SnapshotsOrderBy, // @ts-nocheck
  Meridian_User_MemoriesOrderBy, // @ts-nocheck
  Meridian_Usage_EventsOrderBy, // @ts-nocheck
  Meridian_Tool_RollupsOrderBy, // @ts-nocheck
  Meridian_Tool_ResultsOrderBy, // @ts-nocheck
  Meridian_Tool_IoOrderBy, // @ts-nocheck
  Meridian_Tool_ApprovalsOrderBy, // @ts-nocheck
  Meridian_Tool_Approval_OverridesOrderBy, // @ts-nocheck
  Meridian_Skills_Sync_StateOrderBy, // @ts-nocheck
  Meridian_SkillsOrderBy, // @ts-nocheck
  Meridian_Skill_ActivationsOrderBy, // @ts-nocheck
  Meridian_MessagesOrderBy, // @ts-nocheck
  Meridian_ChatsOrderBy, // @ts-nocheck
  Meridian_Chat_SummariesOrderBy, // @ts-nocheck
  Mcp_Server_ConnectionsOrderBy, // @ts-nocheck
  Marketing_BrandsOrderBy, // @ts-nocheck
  Mail_User_SettingsOrderBy, // @ts-nocheck
  Ios_Metric_PayloadsOrderBy, // @ts-nocheck
  Invoice_Dunning_LogOrderBy, // @ts-nocheck
  Inbound_Sender_RulesOrderBy, // @ts-nocheck
  Google_Group_EnrollmentsOrderBy, // @ts-nocheck
  Google_Drive_Access_GrantsOrderBy, // @ts-nocheck
  Generic_Email_DomainsOrderBy, // @ts-nocheck
  Gemini_Notes_SyncOrderBy, // @ts-nocheck
  Entity_Automation_ConfigOrderBy, // @ts-nocheck
  Employee_Contact_AccessOrderBy, // @ts-nocheck
  Embedding_JobsOrderBy, // @ts-nocheck
  Email_UnsubscribesOrderBy, // @ts-nocheck
  Email_Tracking_TokensOrderBy, // @ts-nocheck
  Email_Tracking_Open_EventsOrderBy, // @ts-nocheck
  Email_TemplatesOrderBy, // @ts-nocheck
  Email_Template_SharesOrderBy, // @ts-nocheck
  Email_Template_FoldersOrderBy, // @ts-nocheck
  Email_Template_FilesOrderBy, // @ts-nocheck
  Email_Template_FavoritesOrderBy, // @ts-nocheck
  Email_SignaturesOrderBy, // @ts-nocheck
  Email_Forwarding_LogOrderBy, // @ts-nocheck
  Email_EventsOrderBy, // @ts-nocheck
  Email_CampaignsOrderBy, // @ts-nocheck
  Email_Campaign_RecipientsOrderBy, // @ts-nocheck
  Email_AudiencesOrderBy, // @ts-nocheck
  Drive_User_RootsOrderBy, // @ts-nocheck
  Drive_NodesOrderBy, // @ts-nocheck
  Document_EmbeddingsOrderBy, // @ts-nocheck
  Device_Push_TokensOrderBy, // @ts-nocheck
  DealsOrderBy, // @ts-nocheck
  Customer_FeedbackOrderBy, // @ts-nocheck
  Cron_Job_RunsOrderBy, // @ts-nocheck
  Crm_Remediation_BackupOrderBy, // @ts-nocheck
  ContractsOrderBy, // @ts-nocheck
  Contract_PreviewsOrderBy, // @ts-nocheck
  ContactsOrderBy, // @ts-nocheck
  Contact_User_AccessOrderBy, // @ts-nocheck
  Contact_TasksOrderBy, // @ts-nocheck
  Contact_ProposalsOrderBy, // @ts-nocheck
  Contact_NotesOrderBy, // @ts-nocheck
  Contact_Method_ClaimsOrderBy, // @ts-nocheck
  Contact_MessagesOrderBy, // @ts-nocheck
  Contact_Merge_IgnoresOrderBy, // @ts-nocheck
  Contact_MeetingsOrderBy, // @ts-nocheck
  Contact_FilesOrderBy, // @ts-nocheck
  Connection_SharesOrderBy, // @ts-nocheck
  Company_User_AccessOrderBy, // @ts-nocheck
  Company_Slack_Channel_Link_IgnoresOrderBy, // @ts-nocheck
  Company_Quickbooks_CustomersOrderBy, // @ts-nocheck
  CompaniesOrderBy, // @ts-nocheck
  CommunicationsOrderBy, // @ts-nocheck
  Communication_TypesOrderBy, // @ts-nocheck
  Calendar_CacheOrderBy, // @ts-nocheck
  Booking_HistoryOrderBy, // @ts-nocheck
  Automation_RulesOrderBy, // @ts-nocheck
  Audit_LogOrderBy, // @ts-nocheck
  App_UsersOrderBy, // @ts-nocheck
  App_User_SkillsOrderBy, // @ts-nocheck
  Address_Geocode_CacheOrderBy, // @ts-nocheck
  IdFilter, // @ts-nocheck
  User_PreferencesUpdateInput, // @ts-nocheck
  User_PreferencesInsertInput, // @ts-nocheck
  User_Oauth_ConnectionsUpdateInput, // @ts-nocheck
  User_Oauth_ConnectionsInsertInput, // @ts-nocheck
  Ticket_UpdatesUpdateInput, // @ts-nocheck
  Ticket_UpdatesInsertInput, // @ts-nocheck
  Task_NotesUpdateInput, // @ts-nocheck
  Task_NotesInsertInput, // @ts-nocheck
  Social_Media_PostsUpdateInput, // @ts-nocheck
  Social_Media_PostsInsertInput, // @ts-nocheck
  Social_Hashtag_GroupsUpdateInput, // @ts-nocheck
  Social_Hashtag_GroupsInsertInput, // @ts-nocheck
  Social_Brand_CredentialsUpdateInput, // @ts-nocheck
  Social_Brand_CredentialsInsertInput, // @ts-nocheck
  Social_Brand_ChannelsUpdateInput, // @ts-nocheck
  Social_Brand_ChannelsInsertInput, // @ts-nocheck
  Slack_Processed_EventsUpdateInput, // @ts-nocheck
  Slack_Processed_EventsInsertInput, // @ts-nocheck
  Slack_Channel_ProvisioningUpdateInput, // @ts-nocheck
  Slack_Channel_ProvisioningInsertInput, // @ts-nocheck
  Skills_CatalogUpdateInput, // @ts-nocheck
  Skills_CatalogInsertInput, // @ts-nocheck
  Secure_LinksUpdateInput, // @ts-nocheck
  Secure_LinksInsertInput, // @ts-nocheck
  Scheduled_SmsUpdateInput, // @ts-nocheck
  Scheduled_SmsInsertInput, // @ts-nocheck
  Scheduled_EmailsUpdateInput, // @ts-nocheck
  Scheduled_EmailsInsertInput, // @ts-nocheck
  Saved_ViewsUpdateInput, // @ts-nocheck
  Saved_ViewsInsertInput, // @ts-nocheck
  Saved_View_FavoritesUpdateInput, // @ts-nocheck
  Saved_View_FavoritesInsertInput, // @ts-nocheck
  Sales_SequencesUpdateInput, // @ts-nocheck
  Sales_SequencesInsertInput, // @ts-nocheck
  Sales_Sequence_StepsUpdateInput, // @ts-nocheck
  Sales_Sequence_StepsInsertInput, // @ts-nocheck
  Sales_Sequence_Step_EventsUpdateInput, // @ts-nocheck
  Sales_Sequence_Step_EventsInsertInput, // @ts-nocheck
  Sales_Sequence_EnrollmentsUpdateInput, // @ts-nocheck
  Sales_Sequence_EnrollmentsInsertInput, // @ts-nocheck
  RolesUpdateInput, // @ts-nocheck
  RolesInsertInput, // @ts-nocheck
  Rate_Limit_BucketsUpdateInput, // @ts-nocheck
  Rate_Limit_BucketsInsertInput, // @ts-nocheck
  Quickbooks_Realm_LabelsUpdateInput, // @ts-nocheck
  Quickbooks_Realm_LabelsInsertInput, // @ts-nocheck
  Quickbooks_Customer_Link_IgnoresUpdateInput, // @ts-nocheck
  Quickbooks_Customer_Link_IgnoresInsertInput, // @ts-nocheck
  Quickbooks_Company_Customer_AcksUpdateInput, // @ts-nocheck
  Quickbooks_Company_Customer_AcksInsertInput, // @ts-nocheck
  Queue_Event_LogUpdateInput, // @ts-nocheck
  Queue_Event_LogInsertInput, // @ts-nocheck
  Project_Chat_SubscriptionsUpdateInput, // @ts-nocheck
  Project_Chat_SubscriptionsInsertInput, // @ts-nocheck
  Post_Audit_Invoice_FeedbackUpdateInput, // @ts-nocheck
  Post_Audit_Invoice_FeedbackInsertInput, // @ts-nocheck
  Post_Audit_DocumentsUpdateInput, // @ts-nocheck
  Post_Audit_DocumentsInsertInput, // @ts-nocheck
  Post_Audit_Cron_LogsUpdateInput, // @ts-nocheck
  Post_Audit_Cron_LogsInsertInput, // @ts-nocheck
  Plaid_Transaction_AttributionsUpdateInput, // @ts-nocheck
  Plaid_Transaction_AttributionsInsertInput, // @ts-nocheck
  Plaid_ItemsUpdateInput, // @ts-nocheck
  Plaid_ItemsInsertInput, // @ts-nocheck
  Pending_ApprovalsUpdateInput, // @ts-nocheck
  Pending_ApprovalsInsertInput, // @ts-nocheck
  Notification_PreferencesUpdateInput, // @ts-nocheck
  Notification_PreferencesInsertInput, // @ts-nocheck
  Notetaker_Summary_LogUpdateInput, // @ts-nocheck
  Notetaker_Summary_LogInsertInput, // @ts-nocheck
  Msp_DocumentsUpdateInput, // @ts-nocheck
  Msp_DocumentsInsertInput, // @ts-nocheck
  Meridian_User_MemoriesUpdateInput, // @ts-nocheck
  Meridian_User_MemoriesInsertInput, // @ts-nocheck
  Meridian_Tool_RollupsUpdateInput, // @ts-nocheck
  Meridian_Tool_RollupsInsertInput, // @ts-nocheck
  Meridian_Tool_ResultsUpdateInput, // @ts-nocheck
  Meridian_Tool_ResultsInsertInput, // @ts-nocheck
  Meridian_Tool_IoUpdateInput, // @ts-nocheck
  Meridian_Tool_IoInsertInput, // @ts-nocheck
  Meridian_Tool_Approval_OverridesUpdateInput, // @ts-nocheck
  Meridian_Tool_Approval_OverridesInsertInput, // @ts-nocheck
  Meridian_Skills_Sync_StateUpdateInput, // @ts-nocheck
  Meridian_Skills_Sync_StateInsertInput, // @ts-nocheck
  Meridian_SkillsUpdateInput, // @ts-nocheck
  Meridian_SkillsInsertInput, // @ts-nocheck
  Meridian_Skill_ActivationsUpdateInput, // @ts-nocheck
  Meridian_Skill_ActivationsInsertInput, // @ts-nocheck
  Meridian_MessagesUpdateInput, // @ts-nocheck
  Meridian_MessagesInsertInput, // @ts-nocheck
  Meridian_ChatsUpdateInput, // @ts-nocheck
  Meridian_ChatsInsertInput, // @ts-nocheck
  Meridian_Chat_SummariesUpdateInput, // @ts-nocheck
  Meridian_Chat_SummariesInsertInput, // @ts-nocheck
  Mcp_Server_ConnectionsUpdateInput, // @ts-nocheck
  Mcp_Server_ConnectionsInsertInput, // @ts-nocheck
  Marketing_BrandsUpdateInput, // @ts-nocheck
  Marketing_BrandsInsertInput, // @ts-nocheck
  Mail_User_SettingsUpdateInput, // @ts-nocheck
  Mail_User_SettingsInsertInput, // @ts-nocheck
  Ios_Metric_PayloadsUpdateInput, // @ts-nocheck
  Ios_Metric_PayloadsInsertInput, // @ts-nocheck
  Inbound_Sender_RulesUpdateInput, // @ts-nocheck
  Inbound_Sender_RulesInsertInput, // @ts-nocheck
  Google_Group_EnrollmentsUpdateInput, // @ts-nocheck
  Google_Group_EnrollmentsInsertInput, // @ts-nocheck
  Google_Drive_Access_GrantsUpdateInput, // @ts-nocheck
  Google_Drive_Access_GrantsInsertInput, // @ts-nocheck
  Generic_Email_DomainsUpdateInput, // @ts-nocheck
  Generic_Email_DomainsInsertInput, // @ts-nocheck
  Gemini_Notes_SyncUpdateInput, // @ts-nocheck
  Gemini_Notes_SyncInsertInput, // @ts-nocheck
  Employee_Contact_AccessUpdateInput, // @ts-nocheck
  Employee_Contact_AccessInsertInput, // @ts-nocheck
  Embedding_JobsUpdateInput, // @ts-nocheck
  Embedding_JobsInsertInput, // @ts-nocheck
  Email_UnsubscribesUpdateInput, // @ts-nocheck
  Email_UnsubscribesInsertInput, // @ts-nocheck
  Email_Tracking_TokensUpdateInput, // @ts-nocheck
  Email_Tracking_TokensInsertInput, // @ts-nocheck
  Email_Tracking_Open_EventsUpdateInput, // @ts-nocheck
  Email_Tracking_Open_EventsInsertInput, // @ts-nocheck
  Email_TemplatesUpdateInput, // @ts-nocheck
  Email_TemplatesInsertInput, // @ts-nocheck
  Email_Template_SharesUpdateInput, // @ts-nocheck
  Email_Template_SharesInsertInput, // @ts-nocheck
  Email_Template_FoldersUpdateInput, // @ts-nocheck
  Email_Template_FoldersInsertInput, // @ts-nocheck
  Email_Template_FilesUpdateInput, // @ts-nocheck
  Email_Template_FilesInsertInput, // @ts-nocheck
  Email_Template_FavoritesUpdateInput, // @ts-nocheck
  Email_Template_FavoritesInsertInput, // @ts-nocheck
  Email_SignaturesUpdateInput, // @ts-nocheck
  Email_SignaturesInsertInput, // @ts-nocheck
  Email_Forwarding_LogUpdateInput, // @ts-nocheck
  Email_Forwarding_LogInsertInput, // @ts-nocheck
  Email_EventsUpdateInput, // @ts-nocheck
  Email_EventsInsertInput, // @ts-nocheck
  Email_CampaignsUpdateInput, // @ts-nocheck
  Email_CampaignsInsertInput, // @ts-nocheck
  Email_Campaign_RecipientsUpdateInput, // @ts-nocheck
  Email_Campaign_RecipientsInsertInput, // @ts-nocheck
  Email_AudiencesUpdateInput, // @ts-nocheck
  Email_AudiencesInsertInput, // @ts-nocheck
  Drive_User_RootsUpdateInput, // @ts-nocheck
  Drive_User_RootsInsertInput, // @ts-nocheck
  Drive_NodesUpdateInput, // @ts-nocheck
  Drive_NodesInsertInput, // @ts-nocheck
  Document_EmbeddingsUpdateInput, // @ts-nocheck
  Document_EmbeddingsInsertInput, // @ts-nocheck
  Device_Push_TokensUpdateInput, // @ts-nocheck
  Device_Push_TokensInsertInput, // @ts-nocheck
  Customer_FeedbackUpdateInput, // @ts-nocheck
  Customer_FeedbackInsertInput, // @ts-nocheck
  Cron_Job_RunsUpdateInput, // @ts-nocheck
  Cron_Job_RunsInsertInput, // @ts-nocheck
  Crm_Remediation_BackupUpdateInput, // @ts-nocheck
  Crm_Remediation_BackupInsertInput, // @ts-nocheck
  Contract_PreviewsUpdateInput, // @ts-nocheck
  Contract_PreviewsInsertInput, // @ts-nocheck
  Contact_User_AccessUpdateInput, // @ts-nocheck
  Contact_User_AccessInsertInput, // @ts-nocheck
  Contact_TasksUpdateInput, // @ts-nocheck
  Contact_TasksInsertInput, // @ts-nocheck
  Contact_NotesUpdateInput, // @ts-nocheck
  Contact_NotesInsertInput, // @ts-nocheck
  Contact_Method_ClaimsUpdateInput, // @ts-nocheck
  Contact_Method_ClaimsInsertInput, // @ts-nocheck
  Contact_MessagesUpdateInput, // @ts-nocheck
  Contact_MessagesInsertInput, // @ts-nocheck
  Contact_Merge_IgnoresUpdateInput, // @ts-nocheck
  Contact_Merge_IgnoresInsertInput, // @ts-nocheck
  Contact_MeetingsUpdateInput, // @ts-nocheck
  Contact_MeetingsInsertInput, // @ts-nocheck
  Connection_SharesUpdateInput, // @ts-nocheck
  Connection_SharesInsertInput, // @ts-nocheck
  Company_User_AccessUpdateInput, // @ts-nocheck
  Company_User_AccessInsertInput, // @ts-nocheck
  Company_Slack_Channel_Link_IgnoresUpdateInput, // @ts-nocheck
  Company_Slack_Channel_Link_IgnoresInsertInput, // @ts-nocheck
  Company_Quickbooks_CustomersUpdateInput, // @ts-nocheck
  Company_Quickbooks_CustomersInsertInput, // @ts-nocheck
  CommunicationsUpdateInput, // @ts-nocheck
  CommunicationsInsertInput, // @ts-nocheck
  Communication_TypesUpdateInput, // @ts-nocheck
  Communication_TypesInsertInput, // @ts-nocheck
  Calendar_CacheUpdateInput, // @ts-nocheck
  Calendar_CacheInsertInput, // @ts-nocheck
  Booking_HistoryUpdateInput, // @ts-nocheck
  Booking_HistoryInsertInput, // @ts-nocheck
  Automation_RulesUpdateInput, // @ts-nocheck
  Automation_RulesInsertInput, // @ts-nocheck
  Audit_LogUpdateInput, // @ts-nocheck
  Audit_LogInsertInput, // @ts-nocheck
  App_User_SkillsUpdateInput, // @ts-nocheck
  App_User_SkillsInsertInput, // @ts-nocheck
  Address_Geocode_CacheUpdateInput, // @ts-nocheck
  Address_Geocode_CacheInsertInput, // @ts-nocheck
  Recurring_ChargesUpdateInput, // @ts-nocheck
  Recurring_ChargesInsertInput, // @ts-nocheck
  Plaid_StatementsUpdateInput, // @ts-nocheck
  Plaid_StatementsInsertInput, // @ts-nocheck
  Entity_Automation_ConfigUpdateInput, // @ts-nocheck
  Entity_Automation_ConfigInsertInput, // @ts-nocheck
  ContractsUpdateInput, // @ts-nocheck
  ContractsInsertInput, // @ts-nocheck
  ContactsUpdateInput, // @ts-nocheck
  ContactsInsertInput, // @ts-nocheck
  Ticket_AttachmentsUpdateInput, // @ts-nocheck
  Ticket_AttachmentsInsertInput, // @ts-nocheck
  Meridian_Tool_ApprovalsUpdateInput, // @ts-nocheck
  Meridian_Tool_ApprovalsInsertInput, // @ts-nocheck
  Contact_FilesUpdateInput, // @ts-nocheck
  Contact_FilesInsertInput, // @ts-nocheck
  FilterIs, // @ts-nocheck
  Time_Entry_TypeFilter, // @ts-nocheck
  Ticket_StatusFilter, // @ts-nocheck
  Ticket_PriorityFilter, // @ts-nocheck
  Ticket_CategoryFilter, // @ts-nocheck
  Task_StatusFilter, // @ts-nocheck
  Sync_StatusFilter, // @ts-nocheck
  Sequence_TargetFilter, // @ts-nocheck
  Sequence_Step_OutcomeFilter, // @ts-nocheck
  Sequence_Region_HintFilter, // @ts-nocheck
  Sequence_Enrollment_StatusFilter, // @ts-nocheck
  Sequence_ChannelFilter, // @ts-nocheck
  Proposal_StatusFilter, // @ts-nocheck
  Project_Health_StatusFilter, // @ts-nocheck
  Note_TypeFilter, // @ts-nocheck
  Meeting_StatusFilter, // @ts-nocheck
  Discount_TypeFilter, // @ts-nocheck
  Deal_StatusFilter, // @ts-nocheck
  Deal_StageFilter, // @ts-nocheck
  Contact_StatusFilter, // @ts-nocheck
  UuidListFilter, // @ts-nocheck
  UuidFilter, // @ts-nocheck
  TimeListFilter, // @ts-nocheck
  TimeFilter, // @ts-nocheck
  StringListFilter, // @ts-nocheck
  StringFilter, // @ts-nocheck
  OpaqueFilter, // @ts-nocheck
  IntListFilter, // @ts-nocheck
  IntFilter, // @ts-nocheck
  FloatListFilter, // @ts-nocheck
  FloatFilter, // @ts-nocheck
  DatetimeListFilter, // @ts-nocheck
  DatetimeFilter, // @ts-nocheck
  User_PreferencesFilter, // @ts-nocheck
  Social_Media_PostsFilter, // @ts-nocheck
  Social_Hashtag_GroupsFilter, // @ts-nocheck
  Social_Brand_CredentialsFilter, // @ts-nocheck
  Social_Brand_ChannelsFilter, // @ts-nocheck
  Slack_Processed_EventsFilter, // @ts-nocheck
  Slack_Channel_ProvisioningFilter, // @ts-nocheck
  Skills_CatalogFilter, // @ts-nocheck
  Secure_LinksFilter, // @ts-nocheck
  Scheduled_SmsFilter, // @ts-nocheck
  Scheduled_EmailsFilter, // @ts-nocheck
  Saved_ViewsFilter, // @ts-nocheck
  Saved_View_FavoritesFilter, // @ts-nocheck
  Sales_Sequence_Step_EventsFilter, // @ts-nocheck
  Sales_Sequence_EnrollmentsFilter, // @ts-nocheck
  Rate_Limit_BucketsFilter, // @ts-nocheck
  Quickbooks_Customer_Link_IgnoresFilter, // @ts-nocheck
  Quickbooks_Company_Customer_AcksFilter, // @ts-nocheck
  Post_Audit_DocumentsFilter, // @ts-nocheck
  Post_Audit_Cron_LogsFilter, // @ts-nocheck
  Pending_ApprovalsFilter, // @ts-nocheck
  Notetaker_Summary_LogFilter, // @ts-nocheck
  Meridian_User_MemoriesFilter, // @ts-nocheck
  Meridian_Tool_RollupsFilter, // @ts-nocheck
  Meridian_Tool_ResultsFilter, // @ts-nocheck
  Meridian_Tool_Approval_OverridesFilter, // @ts-nocheck
  Meridian_Skills_Sync_StateFilter, // @ts-nocheck
  Meridian_Skill_ActivationsFilter, // @ts-nocheck
  Meridian_MessagesFilter, // @ts-nocheck
  Meridian_ChatsFilter, // @ts-nocheck
  Meridian_Chat_SummariesFilter, // @ts-nocheck
  Marketing_BrandsFilter, // @ts-nocheck
  Mail_User_SettingsFilter, // @ts-nocheck
  Ios_Metric_PayloadsFilter, // @ts-nocheck
  Google_Drive_Access_GrantsFilter, // @ts-nocheck
  Gemini_Notes_SyncFilter, // @ts-nocheck
  Employee_Contact_AccessFilter, // @ts-nocheck
  Embedding_JobsFilter, // @ts-nocheck
  Email_UnsubscribesFilter, // @ts-nocheck
  Email_Tracking_TokensFilter, // @ts-nocheck
  Email_Tracking_Open_EventsFilter, // @ts-nocheck
  Email_Template_SharesFilter, // @ts-nocheck
  Email_Template_FoldersFilter, // @ts-nocheck
  Email_Template_FilesFilter, // @ts-nocheck
  Email_Template_FavoritesFilter, // @ts-nocheck
  Email_Forwarding_LogFilter, // @ts-nocheck
  Email_EventsFilter, // @ts-nocheck
  Email_CampaignsFilter, // @ts-nocheck
  Email_Campaign_RecipientsFilter, // @ts-nocheck
  Email_AudiencesFilter, // @ts-nocheck
  Drive_User_RootsFilter, // @ts-nocheck
  Document_EmbeddingsFilter, // @ts-nocheck
  Device_Push_TokensFilter, // @ts-nocheck
  Cron_Job_RunsFilter, // @ts-nocheck
  Contract_PreviewsFilter, // @ts-nocheck
  Contact_TasksFilter, // @ts-nocheck
  Contact_MessagesFilter, // @ts-nocheck
  Contact_Merge_IgnoresFilter, // @ts-nocheck
  Contact_MeetingsFilter, // @ts-nocheck
  Company_Slack_Channel_Link_IgnoresFilter, // @ts-nocheck
  CommunicationsFilter, // @ts-nocheck
  Calendar_CacheFilter, // @ts-nocheck
  Booking_HistoryFilter, // @ts-nocheck
  Audit_LogFilter, // @ts-nocheck
  App_User_SkillsFilter, // @ts-nocheck
  Address_Geocode_CacheFilter, // @ts-nocheck
  DateListFilter, // @ts-nocheck
  DateFilter, // @ts-nocheck
  Recurring_ChargesFilter, // @ts-nocheck
  Plaid_StatementsFilter, // @ts-nocheck
  ContractsFilter, // @ts-nocheck
  BooleanListFilter, // @ts-nocheck
  BooleanFilter, // @ts-nocheck
  User_Oauth_ConnectionsFilter, // @ts-nocheck
  Ticket_UpdatesFilter, // @ts-nocheck
  Task_NotesFilter, // @ts-nocheck
  Sales_SequencesFilter, // @ts-nocheck
  Sales_Sequence_StepsFilter, // @ts-nocheck
  RolesFilter, // @ts-nocheck
  Quickbooks_Realm_LabelsFilter, // @ts-nocheck
  Project_Chat_SubscriptionsFilter, // @ts-nocheck
  Post_Audit_Invoice_FeedbackFilter, // @ts-nocheck
  Plaid_Transaction_AttributionsFilter, // @ts-nocheck
  Plaid_ItemsFilter, // @ts-nocheck
  Notification_PreferencesFilter, // @ts-nocheck
  Msp_DocumentsFilter, // @ts-nocheck
  Meridian_Tool_IoFilter, // @ts-nocheck
  Meridian_SkillsFilter, // @ts-nocheck
  Mcp_Server_ConnectionsFilter, // @ts-nocheck
  Inbound_Sender_RulesFilter, // @ts-nocheck
  Google_Group_EnrollmentsFilter, // @ts-nocheck
  Generic_Email_DomainsFilter, // @ts-nocheck
  Entity_Automation_ConfigFilter, // @ts-nocheck
  Email_TemplatesFilter, // @ts-nocheck
  Email_SignaturesFilter, // @ts-nocheck
  Drive_NodesFilter, // @ts-nocheck
  Customer_FeedbackFilter, // @ts-nocheck
  ContactsFilter, // @ts-nocheck
  Contact_User_AccessFilter, // @ts-nocheck
  Contact_NotesFilter, // @ts-nocheck
  Contact_Method_ClaimsFilter, // @ts-nocheck
  Connection_SharesFilter, // @ts-nocheck
  Company_User_AccessFilter, // @ts-nocheck
  Company_Quickbooks_CustomersFilter, // @ts-nocheck
  Communication_TypesFilter, // @ts-nocheck
  Automation_RulesFilter, // @ts-nocheck
  BigIntListFilter, // @ts-nocheck
  BigIntFilter, // @ts-nocheck
  Ticket_AttachmentsFilter, // @ts-nocheck
  Queue_Event_LogFilter, // @ts-nocheck
  Meridian_Tool_ApprovalsFilter, // @ts-nocheck
  Crm_Remediation_BackupFilter, // @ts-nocheck
  Contact_FilesFilter, // @ts-nocheck
  Time_EntriesUpdateInput, // @ts-nocheck
  Time_EntriesInsertInput, // @ts-nocheck
  TicketsUpdateInput, // @ts-nocheck
  TicketsInsertInput, // @ts-nocheck
  Ticket_TemplatesUpdateInput, // @ts-nocheck
  Ticket_TemplatesInsertInput, // @ts-nocheck
  Revenue_TargetsUpdateInput, // @ts-nocheck
  Revenue_TargetsInsertInput, // @ts-nocheck
  Recurring_TransactionsUpdateInput, // @ts-nocheck
  Recurring_TransactionsInsertInput, // @ts-nocheck
  Post_Audit_InvoicesUpdateInput, // @ts-nocheck
  Post_Audit_InvoicesInsertInput, // @ts-nocheck
  Plaid_TransactionsUpdateInput, // @ts-nocheck
  Plaid_TransactionsInsertInput, // @ts-nocheck
  Plaid_AccountsUpdateInput, // @ts-nocheck
  Plaid_AccountsInsertInput, // @ts-nocheck
  OfferingsUpdateInput, // @ts-nocheck
  OfferingsInsertInput, // @ts-nocheck
  Mrr_SnapshotsUpdateInput, // @ts-nocheck
  Mrr_SnapshotsInsertInput, // @ts-nocheck
  Meridian_Usage_EventsUpdateInput, // @ts-nocheck
  Meridian_Usage_EventsInsertInput, // @ts-nocheck
  Invoice_Dunning_LogUpdateInput, // @ts-nocheck
  Invoice_Dunning_LogInsertInput, // @ts-nocheck
  DealsUpdateInput, // @ts-nocheck
  DealsInsertInput, // @ts-nocheck
  Contact_ProposalsUpdateInput, // @ts-nocheck
  Contact_ProposalsInsertInput, // @ts-nocheck
  CompaniesUpdateInput, // @ts-nocheck
  CompaniesInsertInput, // @ts-nocheck
  App_UsersUpdateInput, // @ts-nocheck
  App_UsersInsertInput, // @ts-nocheck
  BigFloatListFilter, // @ts-nocheck
  BigFloatFilter, // @ts-nocheck
  Time_EntriesFilter, // @ts-nocheck
  TicketsFilter, // @ts-nocheck
  Ticket_TemplatesFilter, // @ts-nocheck
  Revenue_TargetsFilter, // @ts-nocheck
  Recurring_TransactionsFilter, // @ts-nocheck
  Post_Audit_InvoicesFilter, // @ts-nocheck
  Plaid_TransactionsFilter, // @ts-nocheck
  Plaid_AccountsFilter, // @ts-nocheck
  OfferingsFilter, // @ts-nocheck
  Mrr_SnapshotsFilter, // @ts-nocheck
  Meridian_Usage_EventsFilter, // @ts-nocheck
  Invoice_Dunning_LogFilter, // @ts-nocheck
  DealsFilter, // @ts-nocheck
  Contact_ProposalsFilter, // @ts-nocheck
  CompaniesFilter, // @ts-nocheck
  App_UsersFilter,
} from "./graphql";

type Properties<T> = Required<{
  [K in keyof T]: z.ZodType<T[K]>;
}>;

type definedNonNullAny = {};

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny =>
  v !== undefined && v !== null;

export const definedNonNullAnySchema = z.any().refine((v) => isDefinedNonNullAny(v));

export const // @ts-nocheck
  Time_Entry_TypeSchema: z.ZodType<"billable" | "non_billable" | "research" | "travel"> = z.enum([
    "billable",
    "non_billable",
    "research",
    "travel",
  ]);

export const // @ts-nocheck
  Ticket_StatusSchema: z.ZodType<
    | "assigned"
    | "cancelled"
    | "closed"
    | "in_progress"
    | "new"
    | "resolved"
    | "waiting_for_customer"
    | "waiting_for_vendor"
  > = z.enum([
    "assigned",
    "cancelled",
    "closed",
    "in_progress",
    "new",
    "resolved",
    "waiting_for_customer",
    "waiting_for_vendor",
  ]);

export const // @ts-nocheck
  Ticket_PrioritySchema: z.ZodType<"critical" | "high" | "low" | "medium" | "urgent"> = z.enum([
    "critical",
    "high",
    "low",
    "medium",
    "urgent",
  ]);

export const // @ts-nocheck
  Ticket_CategorySchema: z.ZodType<
    | "backup"
    | "cloud"
    | "email"
    | "hardware"
    | "network"
    | "other"
    | "phone"
    | "printer"
    | "security"
    | "software"
  > = z.enum([
    "backup",
    "cloud",
    "email",
    "hardware",
    "network",
    "other",
    "phone",
    "printer",
    "security",
    "software",
  ]);

export const // @ts-nocheck
  Sync_StatusSchema: z.ZodType<"disapproved" | "failed" | "pending" | "synced"> = z.enum([
    "disapproved",
    "failed",
    "pending",
    "synced",
  ]);

export const // @ts-nocheck
  Sequence_TargetSchema: z.ZodType<"company" | "contact"> = z.enum(["company", "contact"]);

export const // @ts-nocheck
  Sequence_Region_HintSchema: z.ZodType<"any" | "local" | "remote"> = z.enum([
    "any",
    "local",
    "remote",
  ]);

export const // @ts-nocheck
  Sequence_Step_OutcomeSchema: z.ZodType<
    "booked" | "bounced" | "done" | "no_answer" | "replied" | "skipped"
  > = z.enum(["booked", "bounced", "done", "no_answer", "replied", "skipped"]);

export const // @ts-nocheck
  Sequence_ChannelSchema: z.ZodType<"call" | "email" | "letter" | "linkedin" | "other" | "sms"> =
    z.enum(["call", "email", "letter", "linkedin", "other", "sms"]);

export const // @ts-nocheck
  Sequence_Enrollment_StatusSchema: z.ZodType<
    "active" | "bailed" | "completed" | "paused" | "replied"
  > = z.enum(["active", "bailed", "completed", "paused", "replied"]);

export const // @ts-nocheck
  Discount_TypeSchema: z.ZodType<"fixed_amount" | "percentage"> = z.enum([
    "fixed_amount",
    "percentage",
  ]);

export const // @ts-nocheck
  Deal_StatusSchema: z.ZodType<"active" | "lost" | "won"> = z.enum(["active", "lost", "won"]);

export const // @ts-nocheck
  Deal_StageSchema: z.ZodType<
    | "completed"
    | "contract_signed"
    | "deal_won"
    | "discovery"
    | "hand_off"
    | "in_progress"
    | "invoiced"
    | "lead"
    | "negotiation"
    | "paid"
    | "proposal"
    | "qualified"
    | "sm_lost_no_savings"
    | "sm_lost_savings_customer_rejected"
    | "started"
    | "wtc_lost_no_budget"
    | "wtc_lost_over_budget"
    | "wtc_lost_solution_rejected"
  > = z.enum([
    "completed",
    "contract_signed",
    "deal_won",
    "discovery",
    "hand_off",
    "in_progress",
    "invoiced",
    "lead",
    "negotiation",
    "paid",
    "proposal",
    "qualified",
    "sm_lost_no_savings",
    "sm_lost_savings_customer_rejected",
    "started",
    "wtc_lost_no_budget",
    "wtc_lost_over_budget",
    "wtc_lost_solution_rejected",
  ]);

export const // @ts-nocheck
  Task_StatusSchema: z.ZodType<"cancelled" | "completed" | "in_progress" | "pending"> = z.enum([
    "cancelled",
    "completed",
    "in_progress",
    "pending",
  ]);

export const // @ts-nocheck
  Contact_StatusSchema: z.ZodType<
    | "churned"
    | "customer"
    | "inactive"
    | "lead"
    | "other_non_revenue"
    | "personal"
    | "prospect"
    | "system_notification"
  > = z.enum([
    "churned",
    "customer",
    "inactive",
    "lead",
    "other_non_revenue",
    "personal",
    "prospect",
    "system_notification",
  ]);

export const // @ts-nocheck
  Proposal_StatusSchema: z.ZodType<
    "accepted" | "draft" | "expired" | "rejected" | "sent" | "viewed"
  > = z.enum(["accepted", "draft", "expired", "rejected", "sent", "viewed"]);

export const // @ts-nocheck
  Note_TypeSchema: z.ZodType<"call" | "email" | "general" | "internal" | "meeting" | "proposal"> =
    z.enum(["call", "email", "general", "internal", "meeting", "proposal"]);

export const // @ts-nocheck
  Meeting_StatusSchema: z.ZodType<"cancelled" | "completed" | "rescheduled" | "scheduled"> = z.enum(
    ["cancelled", "completed", "rescheduled", "scheduled"]
  );

export const // @ts-nocheck
  Project_Health_StatusSchema: z.ZodType<"green" | "red" | "yellow"> = z.enum([
    "green",
    "red",
    "yellow",
  ]);

export const // @ts-nocheck
  OrderByDirectionSchema: z.ZodType<
    "AscNullsFirst" | "AscNullsLast" | "DescNullsFirst" | "DescNullsLast"
  > = z.enum(["AscNullsFirst", "AscNullsLast", "DescNullsFirst", "DescNullsLast"]);

export const // @ts-nocheck
  FilterIsSchema: z.ZodType<"NOT_NULL" | "NULL"> = z.enum(["NOT_NULL", "NULL"]);

export const // @ts-nocheck
  User_PreferencesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      User_PreferencesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    default_meeting_duration: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    timezone: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  User_Oauth_ConnectionsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      User_Oauth_ConnectionsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    access_token_enc: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    access_token_expires_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    auth_user_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    connection_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    end_user_display_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    end_user_email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_refresh_failure_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_refreshed_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    never_expires: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    previous_refresh_token_enc: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    provider_config_key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    refresh_attempts: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    refresh_exhausted: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    refresh_token_enc: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Time_EntriesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Time_EntriesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    approved_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    approved_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    billable_rate: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    date_worked: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    end_time: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    entry_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    hours: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_approved: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_software: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_follow_up_task_created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_customer_ref: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_employee_ref: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    start_time: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sync_status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    synced_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ticket_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ticket_number: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ticket_title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_name: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  TicketsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      TicketsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    actual_hours: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    assigned_to: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    auto_assign: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    auto_escalate: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    billable_hours: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    category: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    closed_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    customer_visible_notes: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description_byte_size: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description_content_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description_preview: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description_s3_key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    discount_amount: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    discount_percentage: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    discount_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    due_date: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    escalation_level: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    estimated_hours: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    has_time_entries: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    hourly_rate: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    internal_notes: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_internal: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_software: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_activity_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_escalation_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_follow_up_task_created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    non_billable_hours: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    priority: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    reminder_sent: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    reminder_sent_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    resolved_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sla_hours: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ticket_number: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    total_billed: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    total_cost: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Ticket_UpdatesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ticket_UpdatesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    content: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_internal: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ticket_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    update_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Ticket_TemplatesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ticket_TemplatesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    category: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description_template: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    estimated_hours: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_active: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sla_hours: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    title_template: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Ticket_AttachmentsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ticket_AttachmentsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    file_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    file_path: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    file_size: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    mime_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ticket_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Task_NotesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Task_NotesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    content: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_internal: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    note_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    task_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Social_Media_PostsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Media_PostsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    body: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    brand: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    drive_file_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    drive_file_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    drive_folder_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    error_summary: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    location: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    media_kind: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    media_url: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    published_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    scheduled_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    thumbnail_url: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Social_Hashtag_GroupsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Hashtag_GroupsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    brand: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Social_Brand_CredentialsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Brand_CredentialsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    api_key_encrypted: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    api_key_env_var: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    brand_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    channel_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    label: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_error: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_verified_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    provider: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Social_Brand_ChannelsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Brand_ChannelsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    brand_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    credential_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    external_channel_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    external_display_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    external_service: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_published_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    platform: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    provider: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    webhook_url: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Slack_Processed_EventsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Slack_Processed_EventsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    dedup_key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    expires_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    payload_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    processed_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Slack_Channel_ProvisioningOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Slack_Channel_ProvisioningOrderBy
    >
  > = z.object({
    // @ts-nocheck
    bookmarks_hash: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    canvas_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    channel_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    content_hash: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_error: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_synced_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    topic_hash: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Skills_CatalogOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Skills_CatalogOrderBy
    >
  > = z.object({
    // @ts-nocheck
    category: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sort_order: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Secure_LinksOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Secure_LinksOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    expires_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_used_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    max_uses: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    public_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    purpose: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    revoked_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    secret_hash: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    use_count: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Scheduled_SmsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Scheduled_SmsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    attempts: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    body: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    error: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    external_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    from_number: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    phone_override: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quick_reply_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    scheduled_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sent_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Scheduled_EmailsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Scheduled_EmailsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    attempts: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    bcc: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    body: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    body_format: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    cc: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    connection_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    error: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    provider: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    scheduled_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sent_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    signature_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    subject: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    template_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    to_email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Saved_ViewsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Saved_ViewsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    resource: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    visibility: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Saved_View_FavoritesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Saved_View_FavoritesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    view_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Sales_SequencesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_SequencesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    deal_stage_trigger: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_active: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_default: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    region_hint: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    target_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Sales_Sequence_StepsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_Sequence_StepsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    channel: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    delay_business_days: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    guidance: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    pause_for_reply: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sequence_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    step_number: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Sales_Sequence_Step_EventsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_Sequence_Step_EventsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    actor: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    channel: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    communication_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    enrollment_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    note: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    occurred_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    outcome: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    step_number: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Sales_Sequence_EnrollmentsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_Sequence_EnrollmentsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    assigned_to: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    completed_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    current_step_number: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    deal_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    enrolled_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    next_action_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    pause_reason: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    paused_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sequence_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  RolesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      RolesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    display_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_active: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Revenue_TargetsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Revenue_TargetsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    currency: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    period_end: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    period_start: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    target_amount: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Recurring_TransactionsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Recurring_TransactionsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    amount: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    customer_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    item: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_error: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_error_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_synced_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_synced_month: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    next_retry_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quantity: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_realm_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    retry_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sync_status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_by: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Recurring_ChargesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Recurring_ChargesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    admin_email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    customer_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_charged_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    next_charge_date: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    realm_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    schedule_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Rate_Limit_BucketsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Rate_Limit_BucketsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    bucket_key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    tokens: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Quickbooks_Realm_LabelsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Quickbooks_Realm_LabelsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    category: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_active: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    label: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    realm_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_channel_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Quickbooks_Customer_Link_IgnoresOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Quickbooks_Customer_Link_IgnoresOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ignored_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    qb_customer_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    qb_customer_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    realm_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    reason: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Quickbooks_Company_Customer_AcksOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Quickbooks_Company_Customer_AcksOrderBy
    >
  > = z.object({
    // @ts-nocheck
    acked_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    realm_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    reason: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Queue_Event_LogOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Queue_Event_LogOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    disposition: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    duration_ms: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    error: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    event_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    message_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    queue_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    receive_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    version: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Project_Chat_SubscriptionsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Project_Chat_SubscriptionsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    channel: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    deal_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    destination: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    display_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_active: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_notified_message_ts: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Post_Audit_InvoicesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_InvoicesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    amount_source: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    approved_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    approved_by_slack_user_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    audit_month: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    category: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    environment: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    final_amount: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ho_reference: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    line_description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    post_audit_document_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    post_audit_number: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    proposed_amount: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    qb_customer_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    qb_customer_ref: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    qb_invoice_doc_number: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    qb_invoice_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    qb_item_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    qb_item_ref: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    qb_sync_token: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    realm_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    savings_figure: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    searched_company_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    send_method: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sent_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Post_Audit_Invoice_FeedbackOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_Invoice_FeedbackOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    issue_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    note: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    post_audit_document_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    post_audit_invoice_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    realm_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    resolved: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_user_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    stage: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Post_Audit_DocumentsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_DocumentsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    attachment_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    completed_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    completed_by_slack_user_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    done_folder_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    drive_file_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    environment: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    message_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    pending_folder_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_channel_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_message_ts: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    source: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Post_Audit_Cron_LogsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_Cron_LogsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    createdAt: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    duration_ms: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    environment: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    month: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    searchDate: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    userEmail: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Plaid_TransactionsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_TransactionsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    account_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    amount: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    counterparty_entity_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    counterparty_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    date: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    iso_currency_code: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    merchant_key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    merchant_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    pending: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    pfc_confidence: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    pfc_detailed: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    pfc_primary: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    plaid_transaction_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    raw_s3_key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Plaid_Transaction_AttributionsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_Transaction_AttributionsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    attributed_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    attributed_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    cost_category: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_net_cost: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    plaid_transaction_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    source: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Plaid_StatementsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_StatementsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    account_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    content_hash: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    date_posted: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    drive_file_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    drive_folder_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    drive_synced_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    drive_web_view_link: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    month: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    plaid_item_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    s3_key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    statement_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    year: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Plaid_ItemsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_ItemsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    access_token_encrypted: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    connected_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    institution_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    item_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    label: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    statements_drive_folder_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    statements_enabled: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    statements_last_error: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    statements_last_synced_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    transactions_cursor: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Plaid_AccountsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_AccountsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    account_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    available_balance: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    balance_updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    current_balance: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    enabled: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    iso_currency_code: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    label: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    mask: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    plaid_item_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    spend_profile: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    spend_profile_set_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    spend_profile_set_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    spend_profile_source: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    statements_drive_folder_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    subtype: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Pending_ApprovalsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Pending_ApprovalsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    approval_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id_column: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    row_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_channel: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_ts: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    table_name: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  OfferingsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      OfferingsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    base_price: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    cta_href: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    cta_text: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    delivery_kit: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    executive_summary: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    image_url: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    linked_project_slug: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    one_pager_pdf_url: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    pricing_display: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    pricing_model: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    total_cost: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    total_hard_costs: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    total_hours: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    website_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Notification_PreferencesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Notification_PreferencesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    email_address: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    email_enabled: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    enabled: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    event_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    phone_number: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    push_enabled: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_channel_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_enabled: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_user_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sms_enabled: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Notetaker_Summary_LogOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Notetaker_Summary_LogOrderBy
    >
  > = z.object({
    // @ts-nocheck
    canvas_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    email_external_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    error: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    mailbox: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    notetaker_source: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sender_email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_channel_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_message_ts: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    subject: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Msp_DocumentsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Msp_DocumentsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    access_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    category: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    client_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    content: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    difficulty: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    estimated_read_time: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    excerpt: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_active: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_featured: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_internal: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_accessed_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_by: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Mrr_SnapshotsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Mrr_SnapshotsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    account_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    amount: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    month: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    source: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Meridian_User_MemoriesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_User_MemoriesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    content: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    embedding: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    importance: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_used_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    memory_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    source: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    use_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Meridian_Usage_EventsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Usage_EventsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    cache_creation_input_tokens: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    cache_read_cost_usd: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    cache_read_input_tokens: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    cache_write_cost_usd: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    canonical_model_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    chat_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    duration_ms: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    feature: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    finish_reason: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    input_cost_usd: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    input_tokens: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    model_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    output_cost_usd: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    output_tokens: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    pricing_unknown: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    provider: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    step_index: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    surface: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    total_cost_usd: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    total_tokens: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Meridian_Tool_RollupsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_RollupsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    chat_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    thread_ts: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Meridian_Tool_ResultsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_ResultsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    chat_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    executed_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    execution_time: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    input_size: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    output_size: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    result_summary: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    result_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    summarized_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    tool_call_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    tool_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Meridian_Tool_IoOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_IoOrderBy
    >
  > = z.object({
    // @ts-nocheck
    cache_hit: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    chat_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    duration_ms: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    error_code: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    error_kind: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ids_requested: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    input_bytes: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_error: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    output_bytes: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    output_items: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    result_truncated: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sections_returned: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    surface: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    tool_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    turn_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    turn_index: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Meridian_Tool_ApprovalsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_ApprovalsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    chat_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    execution_claim_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    execution_claimed_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    execution_completed_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    execution_succeeded: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    expires_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    requested_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    responded_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    responded_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_channel: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_message_ts: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_thread_ts: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_user_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    tool_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Meridian_Tool_Approval_OverridesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_Approval_OverridesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    approval_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Meridian_Skills_Sync_StateOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Skills_Sync_StateOrderBy
    >
  > = z.object({
    // @ts-nocheck
    catalog_etag: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    catalog_generated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    catalog_sha: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_sync_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_sync_error: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_sync_status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    skills_deactivated: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    skills_upserted: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Meridian_SkillsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_SkillsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    argument_hint: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    availability: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    body_chars: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    body_s3_key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    catalog_generated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    category: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    content_sha256: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    disable_model_invocation: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    hitl_required: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    how_to_get: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_active: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    path: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    plugin: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    plugin_version: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    synced_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Meridian_Skill_ActivationsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Skill_ActivationsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    activated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    chat_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    deactivated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    invoked_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    skill_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    surface: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Meridian_MessagesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_MessagesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    chat_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    message_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    model_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    provider: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    role: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    timestamp: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Meridian_ChatsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_ChatsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_message_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    original_owner_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Meridian_Chat_SummariesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Chat_SummariesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    chat_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    summarized_through_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    summary: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Mcp_Server_ConnectionsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Mcp_Server_ConnectionsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    auth_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    enabled: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    header_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_connected_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_error: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    oauth_access_token_encrypted: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    oauth_authorization_server: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    oauth_client_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    oauth_pkce_verifier_encrypted: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    oauth_redirect_uri: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    oauth_refresh_token_encrypted: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    oauth_scope: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    oauth_state: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    oauth_token_expires_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    secret_encrypted: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    server_url: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    tool_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    transport: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Marketing_BrandsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Marketing_BrandsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    display_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    drive_root_folder_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_channel_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sort_order: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Mail_User_SettingsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Mail_User_SettingsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Ios_Metric_PayloadsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ios_Metric_PayloadsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    app_version: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    background_crash_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    background_memory_kill_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    background_task_timeout_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    background_watchdog_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    device_model: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    foreground_crash_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    foreground_memory_kill_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    foreground_watchdog_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    hang_time_p90_ms: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    install_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    kind: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    launch_time_p50_ms: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    launch_time_p90_ms: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    normal_exit_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    os_version: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    period_end: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    period_start: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Invoice_Dunning_LogOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Invoice_Dunning_LogOrderBy
    >
  > = z.object({
    // @ts-nocheck
    action: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    amount: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    channel: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    customer_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    customer_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    cycle: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    days_overdue: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    doc_number: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    invoice_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    realm_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    stage: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Inbound_Sender_RulesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Inbound_Sender_RulesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    active: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    auto_assign_to: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    default_priority: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    domain: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    match_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    notes: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sla_hours: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    subject_pattern: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Google_Group_EnrollmentsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Google_Group_EnrollmentsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    auto_provision_opt_out: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    enabled: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    group_email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    notes: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_channel_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Google_Drive_Access_GrantsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Google_Drive_Access_GrantsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    expires_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    granted_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    grantee_email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    grantor_email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    revoked_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    scope: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Generic_Email_DomainsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Generic_Email_DomainsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    blocked_as_company_domain: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    domain: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    note: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Gemini_Notes_SyncOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Gemini_Notes_SyncOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    doc_created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    doc_modified_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    doc_title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    doc_url: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    file_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    matched_entity_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    matched_entity_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    organizer_email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    posted_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_canvas_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_canvas_url: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_channel_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_ts: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Entity_Automation_ConfigOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Entity_Automation_ConfigOrderBy
    >
  > = z.object({
    // @ts-nocheck
    automation_kind: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    day_of_week: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    enabled: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    entity_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    entity_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    frequency: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    goal_last_evaluated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    goal_last_posted_date: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    goal_last_status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    priority: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    run_on_business_days_only: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    task_description_template: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    task_title_fixed: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    task_title_template: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    use_title_template: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Employee_Contact_AccessOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Employee_Contact_AccessOrderBy
    >
  > = z.object({
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    granted_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Embedding_JobsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Embedding_JobsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    attempts: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    enqueued_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    entity_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    entity_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_error: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    op: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Email_UnsubscribesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_UnsubscribesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    brand: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    campaign_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    unsubscribed_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Email_Tracking_TokensOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Tracking_TokensOrderBy
    >
  > = z.object({
    // @ts-nocheck
    communication_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    direction: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    external_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    first_ip: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    first_user_agent: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_opened_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    open_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    opened_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    provider: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    recipient_email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sent_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    source: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    token: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Email_Tracking_Open_EventsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Tracking_Open_EventsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ip: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    occurred_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    token_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_agent: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Email_TemplatesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_TemplatesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    body: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    folder_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_shared: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    subject: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Email_Template_SharesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_SharesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    template_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Email_Template_FoldersOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_FoldersOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    parent_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Email_Template_FilesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_FilesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    file_category: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    file_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    file_size: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    file_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    storage_path: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    storage_url: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    template_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Email_Template_FavoritesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_FavoritesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    template_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Email_SignaturesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_SignaturesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    connection_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    content: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_default: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    owner_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    provider_config_key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Email_Forwarding_LogOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Forwarding_LogOrderBy
    >
  > = z.object({
    // @ts-nocheck
    canvas_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    email_external_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    error: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    reviewed_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    reviewed_by_slack_user_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    rule_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sender_email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_channel_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_message_ts: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    subject: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Email_EventsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_EventsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    campaign_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ip: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    occurred_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    recipient_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    url: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_agent: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Email_CampaignsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_CampaignsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    audience_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    body_html: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    brand: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    from_email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    from_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    reply_to: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    scheduled_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sent_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    subject: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    template_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Email_Campaign_RecipientsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Campaign_RecipientsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    campaign_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    clicked_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    error: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    opened_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sent_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    tracking_token: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Email_AudiencesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_AudiencesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    brand: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    kind: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Drive_User_RootsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Drive_User_RootsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    root_folder_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    shared_drive_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Drive_NodesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Drive_NodesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    drive_file_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_root: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    kind: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    mime_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    parent_drive_file_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Document_EmbeddingsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Document_EmbeddingsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    content_hash: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    embedding: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    entity_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    entity_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    indexed_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    model_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    source_updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Device_Push_TokensOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Device_Push_TokensOrderBy
    >
  > = z.object({
    // @ts-nocheck
    apns_token: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    app_version: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    environment: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_seen_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  DealsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      DealsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    alignment_status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    budget_status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    chat_link_created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    chat_link_public_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    chat_link_secret_encrypted: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    close_date: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    close_probability: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_search_text: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_search_text: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contract_term_months: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    cost: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    currency: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    estimated_hours: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_committed: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_recurring: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_activity_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_communication_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_follow_up_task_created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    lost_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    margin_percentage: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    monthly_amount: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    notes: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    revenue: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    schedule_status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    scope_status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_channel_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_chat_thread_ts: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    stage: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    won_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Customer_FeedbackOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Customer_FeedbackOrderBy
    >
  > = z.object({
    // @ts-nocheck
    comment: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    entity_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    entity_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    feedback_scope: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_anonymous: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    rating: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    secure_link_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_message_ts: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    source: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ticket_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Cron_Job_RunsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Cron_Job_RunsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    completed_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    duration_ms: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    error_summary: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    job_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    started_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Crm_Remediation_BackupOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Crm_Remediation_BackupOrderBy
    >
  > = z.object({
    // @ts-nocheck
    batch: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    column_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    entity_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    entity_table: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    note: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ran_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  ContractsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      ContractsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    deal_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    decline_reason: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    delivery_mode: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    document_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    esignatures_contract_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    expires_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_event_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    recipient_email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    recipient_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    secure_link_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sent_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sent_by_user_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    signed_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    signed_pdf_url: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    signing_url: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    source: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    template_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    term_months: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Contract_PreviewsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contract_PreviewsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    contract_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    pdf_url: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    secure_link_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  ContactsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      ContactsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    active_deal_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    address: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    avatar_url: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    city: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contract_expires_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    country: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by_backfilled_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    has_active_deals: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    has_signed_contract: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_active: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_company_line: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_contacted_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_enriched_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_follow_up_task_created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    lifecycle_stage: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    notes: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    phone: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    source: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    state: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    trigger_enrichment: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    zip_code: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Contact_User_AccessOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_User_AccessOrderBy
    >
  > = z.object({
    // @ts-nocheck
    access_level: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    expires_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    granted_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    granted_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_active: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Contact_TasksOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_TasksOrderBy
    >
  > = z.object({
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    completed_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    due_date: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    entity_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    entity_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    priority: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Contact_ProposalsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_ProposalsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    amount: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    currency: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    expires_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    file_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    file_size: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    file_url: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    notes: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    responded_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sent_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    terms_and_conditions: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    viewed_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Contact_NotesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_NotesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    content: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_internal: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    note_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Contact_Method_ClaimsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_Method_ClaimsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    claimed_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_legacy_conflict: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_primary: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    kind: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    owner_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    owner_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    source_column: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    value_key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    value_raw: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Contact_MessagesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_MessagesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    body: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    delivered_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    direction: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    external_message_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    message_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    read_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    sent_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    subject: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Contact_Merge_IgnoresOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_Merge_IgnoresOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ignored_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    placeholder_contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    reason: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Contact_MeetingsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_MeetingsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    end_time: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    location: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    meeting_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    notes: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    start_time: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Contact_FilesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_FilesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    size: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    uploaded_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    url: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Connection_SharesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Connection_SharesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    connection_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    drive_access_enabled: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    owner_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    provider_config_key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    shared_with_user_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Company_User_AccessOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Company_User_AccessOrderBy
    >
  > = z.object({
    // @ts-nocheck
    access_level: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    expires_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    granted_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    granted_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_active: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Company_Slack_Channel_Link_IgnoresOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Company_Slack_Channel_Link_IgnoresOrderBy
    >
  > = z.object({
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ignored_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    reason: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Company_Quickbooks_CustomersOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Company_Quickbooks_CustomersOrderBy
    >
  > = z.object({
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    customer_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    customer_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_legacy_conflict: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_secondary: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    linked_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    linked_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    realm_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  CompaniesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      CompaniesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    active_contact_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    active_deal_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    address: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    alignment_status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    budget_status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    city: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contract_expires_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contract_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    country: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by_backfilled_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    domain: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    google_drive_folder_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    google_drive_folder_provisioned_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    has_active_deals: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    has_open_tickets: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    has_signed_contract: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    hourly_rate: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    industry: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_contacted_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_enriched_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_follow_up_task_created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    line_contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    monthly_rate: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    normalized_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    notes: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    open_ticket_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    organization_email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    organization_phone: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    organization_revenue: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    payment_terms: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_customer_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_customer_ref: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_sync_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    schedule_status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    scope_status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_channel_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    state: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    support_link_created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    support_link_public_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    support_link_secret_encrypted: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    tax_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    total_deal_value: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    trigger_enrichment: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    uptime_monitoring_enabled: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    website: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    website_normalized: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    zip_code: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  CommunicationsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      CommunicationsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    attachment_count: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    body: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    body_byte_size: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    body_content_type: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    body_preview: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    body_s3_key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    company_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    contact_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    direction: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    external_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    metadata_s3_key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    occurred_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    type_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    type_label: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Communication_TypesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Communication_TypesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_active: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    label: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Calendar_CacheOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Calendar_CacheOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    end_time: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    event_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_synced: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    provider: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    start_time: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Booking_HistoryOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Booking_HistoryOrderBy
    >
  > = z.object({
    // @ts-nocheck
    bookee_email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    booker_email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    end_time: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    google_event_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    location: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    msft_event_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    start_time: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    status: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    subject: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Automation_RulesOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Automation_RulesOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_by: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    description: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_active: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    priority: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Audit_LogOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Audit_LogOrderBy
    >
  > = z.object({
    // @ts-nocheck
    action: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    ip_address: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    provider: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_agent: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  App_UsersOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      App_UsersOrderBy
    >
  > = z.object({
    // @ts-nocheck
    available_hours: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    email: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    email_signature_title: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    first_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    hourly_rate: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_active: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    is_billable: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    last_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    meridian_default_email_connection_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    meridian_default_email_provider: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    meridian_google_calendar_use_second_account: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_access_token: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_active_realm_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_connected_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_employee_name: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_employee_ref: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_environment: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_last_sync_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_realm_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_refresh_token: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    quickbooks_token_expires_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    role_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    search_vector: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    slack_user_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  App_User_SkillsOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      App_User_SkillsOrderBy
    >
  > = z.object({
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    grade: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    skill_id: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    user_id: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  Address_Geocode_CacheOrderBySchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Address_Geocode_CacheOrderBy
    >
  > = z.object({
    // @ts-nocheck
    address_key: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    created_at: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    formatted_address: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    lat: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    lng: OrderByDirectionSchema.nullish(),
    // @ts-nocheck
    updated_at: OrderByDirectionSchema.nullish(),
  });

export const // @ts-nocheck
  IdFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      IdFilter
    >
  > = z.object({
    eq: z.string().nullish(),
  });

export const // @ts-nocheck
  User_PreferencesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      User_PreferencesUpdateInput
    >
  > = z.object({
    calendar_settings: z.record(z.string(), z.any()).nullish(),
    created_at: z.string().nullish(),
    default_meeting_duration: z.number().nullish(),
    email: z.string().nullish(),
    id: z.string().nullish(),
    timezone: z.string().nullish(),
    updated_at: z.string().nullish(),
    working_hours: z.record(z.string(), z.any()).nullish(),
  });

export const // @ts-nocheck
  User_PreferencesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      User_PreferencesInsertInput
    >
  > = z.object({
    calendar_settings: z.record(z.string(), z.any()).nullish(),
    created_at: z.string().nullish(),
    default_meeting_duration: z.number().nullish(),
    email: z.string().nullish(),
    id: z.string().nullish(),
    timezone: z.string().nullish(),
    updated_at: z.string().nullish(),
    working_hours: z.record(z.string(), z.any()).nullish(),
  });

export const // @ts-nocheck
  User_Oauth_ConnectionsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      User_Oauth_ConnectionsUpdateInput
    >
  > = z.object({
    access_token_enc: z.string().nullish(),
    access_token_expires_at: z.string().nullish(),
    auth_user_id: z.string().nullish(),
    connection_id: z.string().nullish(),
    created_at: z.string().nullish(),
    end_user_display_name: z.string().nullish(),
    end_user_email: z.string().nullish(),
    last_refresh_failure_at: z.string().nullish(),
    last_refreshed_at: z.string().nullish(),
    never_expires: z.boolean().nullish(),
    previous_refresh_token_enc: z.string().nullish(),
    provider_config_key: z.string().nullish(),
    refresh_attempts: z.number().nullish(),
    refresh_exhausted: z.boolean().nullish(),
    refresh_token_enc: z.string().nullish(),
    scopes: z.array(z.string().nullable()).nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  User_Oauth_ConnectionsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      User_Oauth_ConnectionsInsertInput
    >
  > = z.object({
    access_token_enc: z.string().nullish(),
    access_token_expires_at: z.string().nullish(),
    auth_user_id: z.string().nullish(),
    connection_id: z.string().nullish(),
    created_at: z.string().nullish(),
    end_user_display_name: z.string().nullish(),
    end_user_email: z.string().nullish(),
    last_refresh_failure_at: z.string().nullish(),
    last_refreshed_at: z.string().nullish(),
    never_expires: z.boolean().nullish(),
    previous_refresh_token_enc: z.string().nullish(),
    provider_config_key: z.string().nullish(),
    refresh_attempts: z.number().nullish(),
    refresh_exhausted: z.boolean().nullish(),
    refresh_token_enc: z.string().nullish(),
    scopes: z.array(z.string().nullable()).nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Ticket_UpdatesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ticket_UpdatesUpdateInput
    >
  > = z.object({
    content: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    is_internal: z.boolean().nullish(),
    ticket_id: z.string().nullish(),
    update_type: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Ticket_UpdatesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ticket_UpdatesInsertInput
    >
  > = z.object({
    content: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    is_internal: z.boolean().nullish(),
    ticket_id: z.string().nullish(),
    update_type: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Task_NotesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Task_NotesUpdateInput
    >
  > = z.object({
    content: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    is_internal: z.boolean().nullish(),
    note_type: z.string().nullish(),
    task_id: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Task_NotesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Task_NotesInsertInput
    >
  > = z.object({
    content: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    is_internal: z.boolean().nullish(),
    note_type: z.string().nullish(),
    task_id: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Social_Media_PostsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Media_PostsUpdateInput
    >
  > = z.object({
    body: z.string().nullish(),
    brand: z.string().nullish(),
    company_id: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    drive_file_id: z.string().nullish(),
    drive_file_name: z.string().nullish(),
    drive_folder_id: z.string().nullish(),
    error_summary: z.string().nullish(),
    id: z.string().nullish(),
    location: z.string().nullish(),
    media_kind: z.string().nullish(),
    media_url: z.string().nullish(),
    platforms: z.array(z.string().nullable()).nullish(),
    published_at: z.string().nullish(),
    results: z.record(z.string(), z.any()).nullish(),
    scheduled_at: z.string().nullish(),
    status: z.string().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    thumbnail_url: z.string().nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    youtube: z.record(z.string(), z.any()).nullish(),
  });

export const // @ts-nocheck
  Social_Media_PostsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Media_PostsInsertInput
    >
  > = z.object({
    body: z.string().nullish(),
    brand: z.string().nullish(),
    company_id: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    drive_file_id: z.string().nullish(),
    drive_file_name: z.string().nullish(),
    drive_folder_id: z.string().nullish(),
    error_summary: z.string().nullish(),
    id: z.string().nullish(),
    location: z.string().nullish(),
    media_kind: z.string().nullish(),
    media_url: z.string().nullish(),
    platforms: z.array(z.string().nullable()).nullish(),
    published_at: z.string().nullish(),
    results: z.record(z.string(), z.any()).nullish(),
    scheduled_at: z.string().nullish(),
    status: z.string().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    thumbnail_url: z.string().nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    youtube: z.record(z.string(), z.any()).nullish(),
  });

export const // @ts-nocheck
  Social_Hashtag_GroupsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Hashtag_GroupsUpdateInput
    >
  > = z.object({
    brand: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Social_Hashtag_GroupsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Hashtag_GroupsInsertInput
    >
  > = z.object({
    brand: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Social_Brand_CredentialsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Brand_CredentialsUpdateInput
    >
  > = z.object({
    api_key_encrypted: z.string().nullish(),
    api_key_env_var: z.string().nullish(),
    brand_id: z.string().nullish(),
    channel_count: z.number().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    label: z.string().nullish(),
    last_error: z.string().nullish(),
    last_verified_at: z.string().nullish(),
    platforms: z.array(z.string().nullable()).nullish(),
    provider: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Social_Brand_CredentialsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Brand_CredentialsInsertInput
    >
  > = z.object({
    api_key_encrypted: z.string().nullish(),
    api_key_env_var: z.string().nullish(),
    brand_id: z.string().nullish(),
    channel_count: z.number().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    label: z.string().nullish(),
    last_error: z.string().nullish(),
    last_verified_at: z.string().nullish(),
    platforms: z.array(z.string().nullable()).nullish(),
    provider: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Social_Brand_ChannelsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Brand_ChannelsUpdateInput
    >
  > = z.object({
    brand_id: z.string().nullish(),
    created_at: z.string().nullish(),
    credential_id: z.string().nullish(),
    external_channel_id: z.string().nullish(),
    external_display_name: z.string().nullish(),
    external_service: z.string().nullish(),
    id: z.string().nullish(),
    last_published_at: z.string().nullish(),
    platform: z.string().nullish(),
    provider: z.string().nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
    webhook_url: z.string().nullish(),
  });

export const // @ts-nocheck
  Social_Brand_ChannelsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Brand_ChannelsInsertInput
    >
  > = z.object({
    brand_id: z.string().nullish(),
    created_at: z.string().nullish(),
    credential_id: z.string().nullish(),
    external_channel_id: z.string().nullish(),
    external_display_name: z.string().nullish(),
    external_service: z.string().nullish(),
    id: z.string().nullish(),
    last_published_at: z.string().nullish(),
    platform: z.string().nullish(),
    provider: z.string().nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
    webhook_url: z.string().nullish(),
  });

export const // @ts-nocheck
  Slack_Processed_EventsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Slack_Processed_EventsUpdateInput
    >
  > = z.object({
    dedup_key: z.string().nullish(),
    expires_at: z.string().nullish(),
    payload_type: z.string().nullish(),
    processed_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Slack_Processed_EventsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Slack_Processed_EventsInsertInput
    >
  > = z.object({
    dedup_key: z.string().nullish(),
    expires_at: z.string().nullish(),
    payload_type: z.string().nullish(),
    processed_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Slack_Channel_ProvisioningUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Slack_Channel_ProvisioningUpdateInput
    >
  > = z.object({
    bookmarks_hash: z.string().nullish(),
    canvas_id: z.string().nullish(),
    channel_id: z.string().nullish(),
    company_id: z.string().nullish(),
    content_hash: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    last_error: z.string().nullish(),
    last_status: z.string().nullish(),
    last_synced_at: z.string().nullish(),
    topic_hash: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Slack_Channel_ProvisioningInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Slack_Channel_ProvisioningInsertInput
    >
  > = z.object({
    bookmarks_hash: z.string().nullish(),
    canvas_id: z.string().nullish(),
    channel_id: z.string().nullish(),
    company_id: z.string().nullish(),
    content_hash: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    last_error: z.string().nullish(),
    last_status: z.string().nullish(),
    last_synced_at: z.string().nullish(),
    topic_hash: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Skills_CatalogUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Skills_CatalogUpdateInput
    >
  > = z.object({
    category: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    sort_order: z.number().nullish(),
  });

export const // @ts-nocheck
  Skills_CatalogInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Skills_CatalogInsertInput
    >
  > = z.object({
    category: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    sort_order: z.number().nullish(),
  });

export const // @ts-nocheck
  Secure_LinksUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Secure_LinksUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    expires_at: z.string().nullish(),
    id: z.string().nullish(),
    last_used_at: z.string().nullish(),
    max_uses: z.number().nullish(),
    payload: z.record(z.string(), z.any()).nullish(),
    public_id: z.string().nullish(),
    purpose: z.string().nullish(),
    revoked_at: z.string().nullish(),
    secret_hash: z.string().nullish(),
    updated_at: z.string().nullish(),
    use_count: z.number().nullish(),
  });

export const // @ts-nocheck
  Secure_LinksInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Secure_LinksInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    expires_at: z.string().nullish(),
    id: z.string().nullish(),
    last_used_at: z.string().nullish(),
    max_uses: z.number().nullish(),
    payload: z.record(z.string(), z.any()).nullish(),
    public_id: z.string().nullish(),
    purpose: z.string().nullish(),
    revoked_at: z.string().nullish(),
    secret_hash: z.string().nullish(),
    updated_at: z.string().nullish(),
    use_count: z.number().nullish(),
  });

export const // @ts-nocheck
  Scheduled_SmsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Scheduled_SmsUpdateInput
    >
  > = z.object({
    attempts: z.number().nullish(),
    body: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    error: z.string().nullish(),
    external_id: z.string().nullish(),
    from_number: z.string().nullish(),
    id: z.string().nullish(),
    phone_override: z.string().nullish(),
    quick_reply_id: z.string().nullish(),
    scheduled_at: z.string().nullish(),
    sent_at: z.string().nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Scheduled_SmsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Scheduled_SmsInsertInput
    >
  > = z.object({
    attempts: z.number().nullish(),
    body: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    error: z.string().nullish(),
    external_id: z.string().nullish(),
    from_number: z.string().nullish(),
    id: z.string().nullish(),
    phone_override: z.string().nullish(),
    quick_reply_id: z.string().nullish(),
    scheduled_at: z.string().nullish(),
    sent_at: z.string().nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Scheduled_EmailsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Scheduled_EmailsUpdateInput
    >
  > = z.object({
    attempts: z.number().nullish(),
    bcc: z.string().nullish(),
    body: z.string().nullish(),
    body_format: z.string().nullish(),
    cc: z.string().nullish(),
    connection_id: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    error: z.string().nullish(),
    id: z.string().nullish(),
    provider: z.string().nullish(),
    scheduled_at: z.string().nullish(),
    sent_at: z.string().nullish(),
    signature_id: z.string().nullish(),
    status: z.string().nullish(),
    subject: z.string().nullish(),
    template_id: z.string().nullish(),
    to_email: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Scheduled_EmailsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Scheduled_EmailsInsertInput
    >
  > = z.object({
    attempts: z.number().nullish(),
    bcc: z.string().nullish(),
    body: z.string().nullish(),
    body_format: z.string().nullish(),
    cc: z.string().nullish(),
    connection_id: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    error: z.string().nullish(),
    id: z.string().nullish(),
    provider: z.string().nullish(),
    scheduled_at: z.string().nullish(),
    sent_at: z.string().nullish(),
    signature_id: z.string().nullish(),
    status: z.string().nullish(),
    subject: z.string().nullish(),
    template_id: z.string().nullish(),
    to_email: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Saved_ViewsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Saved_ViewsUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    filters: z.record(z.string(), z.any()).nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    resource: z.string().nullish(),
    shared_with_user_ids: z.array(z.string().nullable()).nullish(),
    updated_at: z.string().nullish(),
    visibility: z.string().nullish(),
  });

export const // @ts-nocheck
  Saved_ViewsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Saved_ViewsInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    filters: z.record(z.string(), z.any()).nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    resource: z.string().nullish(),
    shared_with_user_ids: z.array(z.string().nullable()).nullish(),
    updated_at: z.string().nullish(),
    visibility: z.string().nullish(),
  });

export const // @ts-nocheck
  Saved_View_FavoritesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Saved_View_FavoritesUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    user_id: z.string().nullish(),
    view_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Saved_View_FavoritesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Saved_View_FavoritesInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    user_id: z.string().nullish(),
    view_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Sales_SequencesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_SequencesUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    deal_stage_trigger: z.string().nullish(),
    description: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    is_default: z.boolean().nullish(),
    name: z.string().nullish(),
    // @ts-nocheck
    region_hint: Sequence_Region_HintSchema.nullish(),
    // @ts-nocheck
    target_type: Sequence_TargetSchema.nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Sales_SequencesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_SequencesInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    deal_stage_trigger: z.string().nullish(),
    description: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    is_default: z.boolean().nullish(),
    name: z.string().nullish(),
    // @ts-nocheck
    region_hint: Sequence_Region_HintSchema.nullish(),
    // @ts-nocheck
    target_type: Sequence_TargetSchema.nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Sales_Sequence_StepsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_Sequence_StepsUpdateInput
    >
  > = z.object({
    // @ts-nocheck
    channel: Sequence_ChannelSchema.nullish(),
    created_at: z.string().nullish(),
    delay_business_days: z.number().nullish(),
    guidance: z.string().nullish(),
    id: z.string().nullish(),
    pause_for_reply: z.boolean().nullish(),
    sequence_id: z.string().nullish(),
    step_number: z.number().nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Sales_Sequence_StepsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_Sequence_StepsInsertInput
    >
  > = z.object({
    // @ts-nocheck
    channel: Sequence_ChannelSchema.nullish(),
    created_at: z.string().nullish(),
    delay_business_days: z.number().nullish(),
    guidance: z.string().nullish(),
    id: z.string().nullish(),
    pause_for_reply: z.boolean().nullish(),
    sequence_id: z.string().nullish(),
    step_number: z.number().nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Sales_Sequence_Step_EventsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_Sequence_Step_EventsUpdateInput
    >
  > = z.object({
    actor: z.string().nullish(),
    // @ts-nocheck
    channel: Sequence_ChannelSchema.nullish(),
    communication_id: z.string().nullish(),
    created_at: z.string().nullish(),
    enrollment_id: z.string().nullish(),
    id: z.string().nullish(),
    note: z.string().nullish(),
    occurred_at: z.string().nullish(),
    // @ts-nocheck
    outcome: Sequence_Step_OutcomeSchema.nullish(),
    step_number: z.number().nullish(),
  });

export const // @ts-nocheck
  Sales_Sequence_Step_EventsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_Sequence_Step_EventsInsertInput
    >
  > = z.object({
    actor: z.string().nullish(),
    // @ts-nocheck
    channel: Sequence_ChannelSchema.nullish(),
    communication_id: z.string().nullish(),
    created_at: z.string().nullish(),
    enrollment_id: z.string().nullish(),
    id: z.string().nullish(),
    note: z.string().nullish(),
    occurred_at: z.string().nullish(),
    // @ts-nocheck
    outcome: Sequence_Step_OutcomeSchema.nullish(),
    step_number: z.number().nullish(),
  });

export const // @ts-nocheck
  Sales_Sequence_EnrollmentsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_Sequence_EnrollmentsUpdateInput
    >
  > = z.object({
    assigned_to: z.string().nullish(),
    company_id: z.string().nullish(),
    completed_at: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    current_step_number: z.number().nullish(),
    deal_id: z.string().nullish(),
    enrolled_at: z.string().nullish(),
    id: z.string().nullish(),
    next_action_at: z.string().nullish(),
    pause_reason: z.string().nullish(),
    paused_at: z.string().nullish(),
    sequence_id: z.string().nullish(),
    // @ts-nocheck
    status: Sequence_Enrollment_StatusSchema.nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Sales_Sequence_EnrollmentsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_Sequence_EnrollmentsInsertInput
    >
  > = z.object({
    assigned_to: z.string().nullish(),
    company_id: z.string().nullish(),
    completed_at: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    current_step_number: z.number().nullish(),
    deal_id: z.string().nullish(),
    enrolled_at: z.string().nullish(),
    id: z.string().nullish(),
    next_action_at: z.string().nullish(),
    pause_reason: z.string().nullish(),
    paused_at: z.string().nullish(),
    sequence_id: z.string().nullish(),
    // @ts-nocheck
    status: Sequence_Enrollment_StatusSchema.nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  RolesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      RolesUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    display_name: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    name: z.string().nullish(),
    permissions: z.record(z.string(), z.any()).nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  RolesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      RolesInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    display_name: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    name: z.string().nullish(),
    permissions: z.record(z.string(), z.any()).nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Rate_Limit_BucketsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Rate_Limit_BucketsUpdateInput
    >
  > = z.object({
    bucket_key: z.string().nullish(),
    tokens: z.number().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Rate_Limit_BucketsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Rate_Limit_BucketsInsertInput
    >
  > = z.object({
    bucket_key: z.string().nullish(),
    tokens: z.number().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Quickbooks_Realm_LabelsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Quickbooks_Realm_LabelsUpdateInput
    >
  > = z.object({
    category: z.string().nullish(),
    created_at: z.string().nullish(),
    is_active: z.boolean().nullish(),
    label: z.string().nullish(),
    realm_id: z.string().nullish(),
    slack_channel_id: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Quickbooks_Realm_LabelsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Quickbooks_Realm_LabelsInsertInput
    >
  > = z.object({
    category: z.string().nullish(),
    created_at: z.string().nullish(),
    is_active: z.boolean().nullish(),
    label: z.string().nullish(),
    realm_id: z.string().nullish(),
    slack_channel_id: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Quickbooks_Customer_Link_IgnoresUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Quickbooks_Customer_Link_IgnoresUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    ignored_by: z.string().nullish(),
    qb_customer_id: z.string().nullish(),
    qb_customer_name: z.string().nullish(),
    realm_id: z.string().nullish(),
    reason: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Quickbooks_Customer_Link_IgnoresInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Quickbooks_Customer_Link_IgnoresInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    ignored_by: z.string().nullish(),
    qb_customer_id: z.string().nullish(),
    qb_customer_name: z.string().nullish(),
    realm_id: z.string().nullish(),
    reason: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Quickbooks_Company_Customer_AcksUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Quickbooks_Company_Customer_AcksUpdateInput
    >
  > = z.object({
    acked_by: z.string().nullish(),
    company_id: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    realm_id: z.string().nullish(),
    reason: z.string().nullish(),
    secondary_customer_ids: z.array(z.string().nullable()).nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Quickbooks_Company_Customer_AcksInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Quickbooks_Company_Customer_AcksInsertInput
    >
  > = z.object({
    acked_by: z.string().nullish(),
    company_id: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    realm_id: z.string().nullish(),
    reason: z.string().nullish(),
    secondary_customer_ids: z.array(z.string().nullable()).nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Queue_Event_LogUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Queue_Event_LogUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    disposition: z.string().nullish(),
    duration_ms: z.number().nullish(),
    error: z.string().nullish(),
    event_type: z.string().nullish(),
    message_id: z.string().nullish(),
    meta: z.record(z.string(), z.any()).nullish(),
    queue_name: z.string().nullish(),
    receive_count: z.number().nullish(),
    version: z.number().nullish(),
  });

export const // @ts-nocheck
  Queue_Event_LogInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Queue_Event_LogInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    disposition: z.string().nullish(),
    duration_ms: z.number().nullish(),
    error: z.string().nullish(),
    event_type: z.string().nullish(),
    message_id: z.string().nullish(),
    meta: z.record(z.string(), z.any()).nullish(),
    queue_name: z.string().nullish(),
    receive_count: z.number().nullish(),
    version: z.number().nullish(),
  });

export const // @ts-nocheck
  Project_Chat_SubscriptionsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Project_Chat_SubscriptionsUpdateInput
    >
  > = z.object({
    channel: z.string().nullish(),
    created_at: z.string().nullish(),
    deal_id: z.string().nullish(),
    destination: z.string().nullish(),
    display_name: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    last_notified_message_ts: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Project_Chat_SubscriptionsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Project_Chat_SubscriptionsInsertInput
    >
  > = z.object({
    channel: z.string().nullish(),
    created_at: z.string().nullish(),
    deal_id: z.string().nullish(),
    destination: z.string().nullish(),
    display_name: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    last_notified_message_ts: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Post_Audit_Invoice_FeedbackUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_Invoice_FeedbackUpdateInput
    >
  > = z.object({
    ai_value: z.record(z.string(), z.any()).nullish(),
    corrected_value: z.record(z.string(), z.any()).nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    issue_type: z.string().nullish(),
    note: z.string().nullish(),
    post_audit_document_id: z.string().nullish(),
    post_audit_invoice_id: z.string().nullish(),
    realm_id: z.string().nullish(),
    resolved: z.boolean().nullish(),
    slack_user_id: z.string().nullish(),
    stage: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Post_Audit_Invoice_FeedbackInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_Invoice_FeedbackInsertInput
    >
  > = z.object({
    ai_value: z.record(z.string(), z.any()).nullish(),
    corrected_value: z.record(z.string(), z.any()).nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    issue_type: z.string().nullish(),
    note: z.string().nullish(),
    post_audit_document_id: z.string().nullish(),
    post_audit_invoice_id: z.string().nullish(),
    realm_id: z.string().nullish(),
    resolved: z.boolean().nullish(),
    slack_user_id: z.string().nullish(),
    stage: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Post_Audit_DocumentsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_DocumentsUpdateInput
    >
  > = z.object({
    attachment_name: z.string().nullish(),
    card_blocks: z.record(z.string(), z.any()).nullish(),
    completed_at: z.string().nullish(),
    completed_by_slack_user_id: z.string().nullish(),
    created_at: z.string().nullish(),
    done_folder_id: z.string().nullish(),
    drive_file_id: z.string().nullish(),
    environment: z.string().nullish(),
    id: z.string().nullish(),
    message_id: z.string().nullish(),
    pending_folder_id: z.string().nullish(),
    slack_channel_id: z.string().nullish(),
    slack_message_ts: z.string().nullish(),
    source: z.string().nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Post_Audit_DocumentsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_DocumentsInsertInput
    >
  > = z.object({
    attachment_name: z.string().nullish(),
    card_blocks: z.record(z.string(), z.any()).nullish(),
    completed_at: z.string().nullish(),
    completed_by_slack_user_id: z.string().nullish(),
    created_at: z.string().nullish(),
    done_folder_id: z.string().nullish(),
    drive_file_id: z.string().nullish(),
    environment: z.string().nullish(),
    id: z.string().nullish(),
    message_id: z.string().nullish(),
    pending_folder_id: z.string().nullish(),
    slack_channel_id: z.string().nullish(),
    slack_message_ts: z.string().nullish(),
    source: z.string().nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Post_Audit_Cron_LogsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_Cron_LogsUpdateInput
    >
  > = z.object({
    createdAt: z.string().nullish(),
    duration_ms: z.number().nullish(),
    environment: z.string().nullish(),
    id: z.string().nullish(),
    metrics: z.record(z.string(), z.any()).nullish(),
    month: z.string().nullish(),
    results: z.record(z.string(), z.any()).nullish(),
    searchDate: z.string().nullish(),
    userEmail: z.string().nullish(),
  });

export const // @ts-nocheck
  Post_Audit_Cron_LogsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_Cron_LogsInsertInput
    >
  > = z.object({
    createdAt: z.string().nullish(),
    duration_ms: z.number().nullish(),
    environment: z.string().nullish(),
    id: z.string().nullish(),
    metrics: z.record(z.string(), z.any()).nullish(),
    month: z.string().nullish(),
    results: z.record(z.string(), z.any()).nullish(),
    searchDate: z.string().nullish(),
    userEmail: z.string().nullish(),
  });

export const // @ts-nocheck
  Plaid_Transaction_AttributionsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_Transaction_AttributionsUpdateInput
    >
  > = z.object({
    attributed_at: z.string().nullish(),
    attributed_by: z.string().nullish(),
    company_id: z.string().nullish(),
    cost_category: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    is_net_cost: z.boolean().nullish(),
    plaid_transaction_id: z.string().nullish(),
    source: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Plaid_Transaction_AttributionsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_Transaction_AttributionsInsertInput
    >
  > = z.object({
    attributed_at: z.string().nullish(),
    attributed_by: z.string().nullish(),
    company_id: z.string().nullish(),
    cost_category: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    is_net_cost: z.boolean().nullish(),
    plaid_transaction_id: z.string().nullish(),
    source: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Plaid_ItemsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_ItemsUpdateInput
    >
  > = z.object({
    access_token_encrypted: z.string().nullish(),
    company_id: z.string().nullish(),
    connected_by: z.string().nullish(),
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    id: z.string().nullish(),
    institution_name: z.string().nullish(),
    item_id: z.string().nullish(),
    label: z.string().nullish(),
    statements_drive_folder_id: z.string().nullish(),
    statements_enabled: z.boolean().nullish(),
    statements_last_error: z.string().nullish(),
    statements_last_synced_at: z.string().nullish(),
    status: z.string().nullish(),
    transactions_cursor: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Plaid_ItemsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_ItemsInsertInput
    >
  > = z.object({
    access_token_encrypted: z.string().nullish(),
    company_id: z.string().nullish(),
    connected_by: z.string().nullish(),
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    id: z.string().nullish(),
    institution_name: z.string().nullish(),
    item_id: z.string().nullish(),
    label: z.string().nullish(),
    statements_drive_folder_id: z.string().nullish(),
    statements_enabled: z.boolean().nullish(),
    statements_last_error: z.string().nullish(),
    statements_last_synced_at: z.string().nullish(),
    status: z.string().nullish(),
    transactions_cursor: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Pending_ApprovalsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Pending_ApprovalsUpdateInput
    >
  > = z.object({
    approval_id: z.string().nullish(),
    created_at: z.string().nullish(),
    enhanced: z.record(z.string(), z.any()).nullish(),
    id_column: z.string().nullish(),
    row_id: z.string().nullish(),
    slack_channel: z.string().nullish(),
    slack_ts: z.string().nullish(),
    status: z.string().nullish(),
    table_name: z.string().nullish(),
  });

export const // @ts-nocheck
  Pending_ApprovalsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Pending_ApprovalsInsertInput
    >
  > = z.object({
    approval_id: z.string().nullish(),
    created_at: z.string().nullish(),
    enhanced: z.record(z.string(), z.any()).nullish(),
    id_column: z.string().nullish(),
    row_id: z.string().nullish(),
    slack_channel: z.string().nullish(),
    slack_ts: z.string().nullish(),
    status: z.string().nullish(),
    table_name: z.string().nullish(),
  });

export const // @ts-nocheck
  Notification_PreferencesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Notification_PreferencesUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    email_address: z.string().nullish(),
    email_enabled: z.boolean().nullish(),
    enabled: z.boolean().nullish(),
    event_type: z.string().nullish(),
    id: z.string().nullish(),
    phone_number: z.string().nullish(),
    push_enabled: z.boolean().nullish(),
    reminder_config: z.record(z.string(), z.any()).nullish(),
    slack_channel_id: z.string().nullish(),
    slack_enabled: z.boolean().nullish(),
    slack_user_id: z.string().nullish(),
    sms_enabled: z.boolean().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Notification_PreferencesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Notification_PreferencesInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    email_address: z.string().nullish(),
    email_enabled: z.boolean().nullish(),
    enabled: z.boolean().nullish(),
    event_type: z.string().nullish(),
    id: z.string().nullish(),
    phone_number: z.string().nullish(),
    push_enabled: z.boolean().nullish(),
    reminder_config: z.record(z.string(), z.any()).nullish(),
    slack_channel_id: z.string().nullish(),
    slack_enabled: z.boolean().nullish(),
    slack_user_id: z.string().nullish(),
    sms_enabled: z.boolean().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Notetaker_Summary_LogUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Notetaker_Summary_LogUpdateInput
    >
  > = z.object({
    canvas_id: z.string().nullish(),
    created_at: z.string().nullish(),
    email_external_id: z.string().nullish(),
    error: z.string().nullish(),
    id: z.string().nullish(),
    mailbox: z.string().nullish(),
    notetaker_source: z.string().nullish(),
    sender_email: z.string().nullish(),
    slack_channel_id: z.string().nullish(),
    slack_message_ts: z.string().nullish(),
    status: z.string().nullish(),
    subject: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Notetaker_Summary_LogInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Notetaker_Summary_LogInsertInput
    >
  > = z.object({
    canvas_id: z.string().nullish(),
    created_at: z.string().nullish(),
    email_external_id: z.string().nullish(),
    error: z.string().nullish(),
    id: z.string().nullish(),
    mailbox: z.string().nullish(),
    notetaker_source: z.string().nullish(),
    sender_email: z.string().nullish(),
    slack_channel_id: z.string().nullish(),
    slack_message_ts: z.string().nullish(),
    status: z.string().nullish(),
    subject: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Msp_DocumentsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Msp_DocumentsUpdateInput
    >
  > = z.object({
    access_count: z.number().nullish(),
    category: z.string().nullish(),
    client_id: z.string().nullish(),
    company_id: z.string().nullish(),
    content: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    difficulty: z.string().nullish(),
    estimated_read_time: z.number().nullish(),
    excerpt: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    is_featured: z.boolean().nullish(),
    is_internal: z.boolean().nullish(),
    last_accessed_at: z.string().nullish(),
    shared_with_users: z.array(z.string().nullable()).nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    updated_by: z.string().nullish(),
  });

export const // @ts-nocheck
  Msp_DocumentsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Msp_DocumentsInsertInput
    >
  > = z.object({
    access_count: z.number().nullish(),
    category: z.string().nullish(),
    client_id: z.string().nullish(),
    company_id: z.string().nullish(),
    content: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    difficulty: z.string().nullish(),
    estimated_read_time: z.number().nullish(),
    excerpt: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    is_featured: z.boolean().nullish(),
    is_internal: z.boolean().nullish(),
    last_accessed_at: z.string().nullish(),
    shared_with_users: z.array(z.string().nullable()).nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    updated_by: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_User_MemoriesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_User_MemoriesUpdateInput
    >
  > = z.object({
    content: z.string().nullish(),
    created_at: z.string().nullish(),
    embedding: z.any().nullish(),
    id: z.string().nullish(),
    importance: z.number().nullish(),
    key: z.string().nullish(),
    last_used_at: z.string().nullish(),
    memory_type: z.string().nullish(),
    source: z.string().nullish(),
    updated_at: z.string().nullish(),
    use_count: z.number().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_User_MemoriesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_User_MemoriesInsertInput
    >
  > = z.object({
    content: z.string().nullish(),
    created_at: z.string().nullish(),
    embedding: z.any().nullish(),
    id: z.string().nullish(),
    importance: z.number().nullish(),
    key: z.string().nullish(),
    last_used_at: z.string().nullish(),
    memory_type: z.string().nullish(),
    source: z.string().nullish(),
    updated_at: z.string().nullish(),
    use_count: z.number().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Tool_RollupsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_RollupsUpdateInput
    >
  > = z.object({
    chat_id: z.string().nullish(),
    created_at: z.string().nullish(),
    state: z.record(z.string(), z.any()).nullish(),
    thread_ts: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Tool_RollupsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_RollupsInsertInput
    >
  > = z.object({
    chat_id: z.string().nullish(),
    created_at: z.string().nullish(),
    state: z.record(z.string(), z.any()).nullish(),
    thread_ts: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Tool_ResultsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_ResultsUpdateInput
    >
  > = z.object({
    chat_id: z.string().nullish(),
    created_at: z.string().nullish(),
    executed_at: z.string().nullish(),
    execution_time: z.number().nullish(),
    id: z.string().nullish(),
    input_size: z.number().nullish(),
    output_size: z.number().nullish(),
    result_summary: z.string().nullish(),
    result_type: z.string().nullish(),
    summarized_at: z.string().nullish(),
    tool_call_id: z.string().nullish(),
    tool_name: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Tool_ResultsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_ResultsInsertInput
    >
  > = z.object({
    chat_id: z.string().nullish(),
    created_at: z.string().nullish(),
    executed_at: z.string().nullish(),
    execution_time: z.number().nullish(),
    id: z.string().nullish(),
    input_size: z.number().nullish(),
    output_size: z.number().nullish(),
    result_summary: z.string().nullish(),
    result_type: z.string().nullish(),
    summarized_at: z.string().nullish(),
    tool_call_id: z.string().nullish(),
    tool_name: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Tool_IoUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_IoUpdateInput
    >
  > = z.object({
    cache_hit: z.boolean().nullish(),
    chat_id: z.string().nullish(),
    created_at: z.string().nullish(),
    duration_ms: z.number().nullish(),
    error_code: z.string().nullish(),
    error_kind: z.string().nullish(),
    id: z.string().nullish(),
    ids_requested: z.number().nullish(),
    input_bytes: z.number().nullish(),
    is_error: z.boolean().nullish(),
    output_bytes: z.number().nullish(),
    output_items: z.number().nullish(),
    result_truncated: z.boolean().nullish(),
    sections_returned: z.number().nullish(),
    surface: z.string().nullish(),
    tool_name: z.string().nullish(),
    turn_id: z.string().nullish(),
    turn_index: z.number().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Tool_IoInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_IoInsertInput
    >
  > = z.object({
    cache_hit: z.boolean().nullish(),
    chat_id: z.string().nullish(),
    created_at: z.string().nullish(),
    duration_ms: z.number().nullish(),
    error_code: z.string().nullish(),
    error_kind: z.string().nullish(),
    id: z.string().nullish(),
    ids_requested: z.number().nullish(),
    input_bytes: z.number().nullish(),
    is_error: z.boolean().nullish(),
    output_bytes: z.number().nullish(),
    output_items: z.number().nullish(),
    result_truncated: z.boolean().nullish(),
    sections_returned: z.number().nullish(),
    surface: z.string().nullish(),
    tool_name: z.string().nullish(),
    turn_id: z.string().nullish(),
    turn_index: z.number().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Tool_Approval_OverridesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_Approval_OverridesUpdateInput
    >
  > = z.object({
    approval_id: z.string().nullish(),
    created_at: z.string().nullish(),
    override_payload: z.record(z.string(), z.any()).nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Tool_Approval_OverridesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_Approval_OverridesInsertInput
    >
  > = z.object({
    approval_id: z.string().nullish(),
    created_at: z.string().nullish(),
    override_payload: z.record(z.string(), z.any()).nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Skills_Sync_StateUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Skills_Sync_StateUpdateInput
    >
  > = z.object({
    catalog_etag: z.string().nullish(),
    catalog_generated_at: z.string().nullish(),
    catalog_sha: z.string().nullish(),
    id: z.string().nullish(),
    last_sync_at: z.string().nullish(),
    last_sync_error: z.string().nullish(),
    last_sync_status: z.string().nullish(),
    skills_deactivated: z.number().nullish(),
    skills_upserted: z.number().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Skills_Sync_StateInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Skills_Sync_StateInsertInput
    >
  > = z.object({
    catalog_etag: z.string().nullish(),
    catalog_generated_at: z.string().nullish(),
    catalog_sha: z.string().nullish(),
    id: z.string().nullish(),
    last_sync_at: z.string().nullish(),
    last_sync_error: z.string().nullish(),
    last_sync_status: z.string().nullish(),
    skills_deactivated: z.number().nullish(),
    skills_upserted: z.number().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_SkillsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_SkillsUpdateInput
    >
  > = z.object({
    allowed_tools: z.array(z.string().nullable()).nullish(),
    argument_hint: z.string().nullish(),
    availability: z.string().nullish(),
    body_chars: z.number().nullish(),
    body_s3_key: z.string().nullish(),
    catalog_generated_at: z.string().nullish(),
    category: z.string().nullish(),
    content_sha256: z.string().nullish(),
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    disable_model_invocation: z.boolean().nullish(),
    hitl_required: z.boolean().nullish(),
    how_to_get: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    path: z.string().nullish(),
    plugin: z.string().nullish(),
    plugin_version: z.string().nullish(),
    required_capabilities: z.array(z.string().nullable()).nullish(),
    runtimes: z.array(z.string().nullable()).nullish(),
    synced_at: z.string().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_SkillsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_SkillsInsertInput
    >
  > = z.object({
    allowed_tools: z.array(z.string().nullable()).nullish(),
    argument_hint: z.string().nullish(),
    availability: z.string().nullish(),
    body_chars: z.number().nullish(),
    body_s3_key: z.string().nullish(),
    catalog_generated_at: z.string().nullish(),
    category: z.string().nullish(),
    content_sha256: z.string().nullish(),
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    disable_model_invocation: z.boolean().nullish(),
    hitl_required: z.boolean().nullish(),
    how_to_get: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    path: z.string().nullish(),
    plugin: z.string().nullish(),
    plugin_version: z.string().nullish(),
    required_capabilities: z.array(z.string().nullable()).nullish(),
    runtimes: z.array(z.string().nullable()).nullish(),
    synced_at: z.string().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Skill_ActivationsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Skill_ActivationsUpdateInput
    >
  > = z.object({
    activated_at: z.string().nullish(),
    chat_id: z.string().nullish(),
    deactivated_at: z.string().nullish(),
    id: z.string().nullish(),
    invoked_by: z.string().nullish(),
    skill_id: z.string().nullish(),
    surface: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Skill_ActivationsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Skill_ActivationsInsertInput
    >
  > = z.object({
    activated_at: z.string().nullish(),
    chat_id: z.string().nullish(),
    deactivated_at: z.string().nullish(),
    id: z.string().nullish(),
    invoked_by: z.string().nullish(),
    skill_id: z.string().nullish(),
    surface: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_MessagesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_MessagesUpdateInput
    >
  > = z.object({
    chat_id: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    message_id: z.string().nullish(),
    metadata: z.record(z.string(), z.any()).nullish(),
    model_id: z.string().nullish(),
    parts: z.record(z.string(), z.any()).nullish(),
    provider: z.string().nullish(),
    role: z.string().nullish(),
    timestamp: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_MessagesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_MessagesInsertInput
    >
  > = z.object({
    chat_id: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    message_id: z.string().nullish(),
    metadata: z.record(z.string(), z.any()).nullish(),
    model_id: z.string().nullish(),
    parts: z.record(z.string(), z.any()).nullish(),
    provider: z.string().nullish(),
    role: z.string().nullish(),
    timestamp: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_ChatsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_ChatsUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    last_message_at: z.string().nullish(),
    original_owner_id: z.string().nullish(),
    shared_with: z.record(z.string(), z.any()).nullish(),
    status: z.string().nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_ChatsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_ChatsInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    last_message_at: z.string().nullish(),
    original_owner_id: z.string().nullish(),
    shared_with: z.record(z.string(), z.any()).nullish(),
    status: z.string().nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Chat_SummariesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Chat_SummariesUpdateInput
    >
  > = z.object({
    chat_id: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    key_decisions: z.array(z.string().nullable()).nullish(),
    key_entities: z.record(z.string(), z.any()).nullish(),
    key_topics: z.array(z.string().nullable()).nullish(),
    open_threads: z.array(z.string().nullable()).nullish(),
    summarized_through_count: z.number().nullish(),
    summary: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Chat_SummariesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Chat_SummariesInsertInput
    >
  > = z.object({
    chat_id: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    key_decisions: z.array(z.string().nullable()).nullish(),
    key_entities: z.record(z.string(), z.any()).nullish(),
    key_topics: z.array(z.string().nullable()).nullish(),
    open_threads: z.array(z.string().nullable()).nullish(),
    summarized_through_count: z.number().nullish(),
    summary: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Mcp_Server_ConnectionsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Mcp_Server_ConnectionsUpdateInput
    >
  > = z.object({
    auth_type: z.string().nullish(),
    created_at: z.string().nullish(),
    enabled: z.boolean().nullish(),
    header_name: z.string().nullish(),
    id: z.string().nullish(),
    last_connected_at: z.string().nullish(),
    last_error: z.string().nullish(),
    name: z.string().nullish(),
    oauth_access_token_encrypted: z.string().nullish(),
    oauth_authorization_server: z.string().nullish(),
    oauth_client_id: z.string().nullish(),
    oauth_pkce_verifier_encrypted: z.string().nullish(),
    oauth_redirect_uri: z.string().nullish(),
    oauth_refresh_token_encrypted: z.string().nullish(),
    oauth_scope: z.string().nullish(),
    oauth_state: z.string().nullish(),
    oauth_token_expires_at: z.string().nullish(),
    secret_encrypted: z.string().nullish(),
    server_url: z.string().nullish(),
    status: z.string().nullish(),
    tool_count: z.number().nullish(),
    transport: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Mcp_Server_ConnectionsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Mcp_Server_ConnectionsInsertInput
    >
  > = z.object({
    auth_type: z.string().nullish(),
    created_at: z.string().nullish(),
    enabled: z.boolean().nullish(),
    header_name: z.string().nullish(),
    id: z.string().nullish(),
    last_connected_at: z.string().nullish(),
    last_error: z.string().nullish(),
    name: z.string().nullish(),
    oauth_access_token_encrypted: z.string().nullish(),
    oauth_authorization_server: z.string().nullish(),
    oauth_client_id: z.string().nullish(),
    oauth_pkce_verifier_encrypted: z.string().nullish(),
    oauth_redirect_uri: z.string().nullish(),
    oauth_refresh_token_encrypted: z.string().nullish(),
    oauth_scope: z.string().nullish(),
    oauth_state: z.string().nullish(),
    oauth_token_expires_at: z.string().nullish(),
    secret_encrypted: z.string().nullish(),
    server_url: z.string().nullish(),
    status: z.string().nullish(),
    tool_count: z.number().nullish(),
    transport: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Marketing_BrandsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Marketing_BrandsUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    display_name: z.string().nullish(),
    drive_root_folder_id: z.string().nullish(),
    email: z.record(z.string(), z.any()).nullish(),
    id: z.string().nullish(),
    slack_channel_id: z.string().nullish(),
    sort_order: z.number().nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
    voice: z.record(z.string(), z.any()).nullish(),
    zapier: z.record(z.string(), z.any()).nullish(),
  });

export const // @ts-nocheck
  Marketing_BrandsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Marketing_BrandsInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    display_name: z.string().nullish(),
    drive_root_folder_id: z.string().nullish(),
    email: z.record(z.string(), z.any()).nullish(),
    id: z.string().nullish(),
    slack_channel_id: z.string().nullish(),
    sort_order: z.number().nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
    voice: z.record(z.string(), z.any()).nullish(),
    zapier: z.record(z.string(), z.any()).nullish(),
  });

export const // @ts-nocheck
  Mail_User_SettingsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Mail_User_SettingsUpdateInput
    >
  > = z.object({
    away: z.record(z.string(), z.any()).nullish(),
    created_at: z.string().nullish(),
    folders: z.record(z.string(), z.any()).nullish(),
    rules: z.record(z.string(), z.any()).nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Mail_User_SettingsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Mail_User_SettingsInsertInput
    >
  > = z.object({
    away: z.record(z.string(), z.any()).nullish(),
    created_at: z.string().nullish(),
    folders: z.record(z.string(), z.any()).nullish(),
    rules: z.record(z.string(), z.any()).nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Ios_Metric_PayloadsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ios_Metric_PayloadsUpdateInput
    >
  > = z.object({
    app_version: z.string().nullish(),
    background_crash_count: z.number().nullish(),
    background_memory_kill_count: z.number().nullish(),
    background_task_timeout_count: z.number().nullish(),
    background_watchdog_count: z.number().nullish(),
    created_at: z.string().nullish(),
    device_model: z.string().nullish(),
    foreground_crash_count: z.number().nullish(),
    foreground_memory_kill_count: z.number().nullish(),
    foreground_watchdog_count: z.number().nullish(),
    hang_time_p90_ms: z.number().nullish(),
    id: z.string().nullish(),
    install_id: z.string().nullish(),
    kind: z.string().nullish(),
    launch_time_p50_ms: z.number().nullish(),
    launch_time_p90_ms: z.number().nullish(),
    normal_exit_count: z.number().nullish(),
    os_version: z.string().nullish(),
    payload: z.record(z.string(), z.any()).nullish(),
    period_end: z.string().nullish(),
    period_start: z.string().nullish(),
    surface_counts: z.record(z.string(), z.any()).nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Ios_Metric_PayloadsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ios_Metric_PayloadsInsertInput
    >
  > = z.object({
    app_version: z.string().nullish(),
    background_crash_count: z.number().nullish(),
    background_memory_kill_count: z.number().nullish(),
    background_task_timeout_count: z.number().nullish(),
    background_watchdog_count: z.number().nullish(),
    created_at: z.string().nullish(),
    device_model: z.string().nullish(),
    foreground_crash_count: z.number().nullish(),
    foreground_memory_kill_count: z.number().nullish(),
    foreground_watchdog_count: z.number().nullish(),
    hang_time_p90_ms: z.number().nullish(),
    id: z.string().nullish(),
    install_id: z.string().nullish(),
    kind: z.string().nullish(),
    launch_time_p50_ms: z.number().nullish(),
    launch_time_p90_ms: z.number().nullish(),
    normal_exit_count: z.number().nullish(),
    os_version: z.string().nullish(),
    payload: z.record(z.string(), z.any()).nullish(),
    period_end: z.string().nullish(),
    period_start: z.string().nullish(),
    surface_counts: z.record(z.string(), z.any()).nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Inbound_Sender_RulesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Inbound_Sender_RulesUpdateInput
    >
  > = z.object({
    active: z.boolean().nullish(),
    auto_assign_to: z.string().nullish(),
    company_id: z.string().nullish(),
    company_name: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    default_priority: z.string().nullish(),
    domain: z.string().nullish(),
    id: z.string().nullish(),
    match_type: z.string().nullish(),
    notes: z.string().nullish(),
    sla_hours: z.number().nullish(),
    subject_pattern: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Inbound_Sender_RulesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Inbound_Sender_RulesInsertInput
    >
  > = z.object({
    active: z.boolean().nullish(),
    auto_assign_to: z.string().nullish(),
    company_id: z.string().nullish(),
    company_name: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    default_priority: z.string().nullish(),
    domain: z.string().nullish(),
    id: z.string().nullish(),
    match_type: z.string().nullish(),
    notes: z.string().nullish(),
    sla_hours: z.number().nullish(),
    subject_pattern: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Google_Group_EnrollmentsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Google_Group_EnrollmentsUpdateInput
    >
  > = z.object({
    auto_provision_opt_out: z.boolean().nullish(),
    company_id: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    enabled: z.boolean().nullish(),
    group_email: z.string().nullish(),
    id: z.string().nullish(),
    notes: z.string().nullish(),
    slack_channel_id: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Google_Group_EnrollmentsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Google_Group_EnrollmentsInsertInput
    >
  > = z.object({
    auto_provision_opt_out: z.boolean().nullish(),
    company_id: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    enabled: z.boolean().nullish(),
    group_email: z.string().nullish(),
    id: z.string().nullish(),
    notes: z.string().nullish(),
    slack_channel_id: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Google_Drive_Access_GrantsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Google_Drive_Access_GrantsUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    expires_at: z.string().nullish(),
    granted_by: z.string().nullish(),
    grantee_email: z.string().nullish(),
    grantor_email: z.string().nullish(),
    id: z.string().nullish(),
    revoked_at: z.string().nullish(),
    scope: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Google_Drive_Access_GrantsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Google_Drive_Access_GrantsInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    expires_at: z.string().nullish(),
    granted_by: z.string().nullish(),
    grantee_email: z.string().nullish(),
    grantor_email: z.string().nullish(),
    id: z.string().nullish(),
    revoked_at: z.string().nullish(),
    scope: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Generic_Email_DomainsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Generic_Email_DomainsUpdateInput
    >
  > = z.object({
    blocked_as_company_domain: z.boolean().nullish(),
    created_at: z.string().nullish(),
    domain: z.string().nullish(),
    note: z.string().nullish(),
  });

export const // @ts-nocheck
  Generic_Email_DomainsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Generic_Email_DomainsInsertInput
    >
  > = z.object({
    blocked_as_company_domain: z.boolean().nullish(),
    created_at: z.string().nullish(),
    domain: z.string().nullish(),
    note: z.string().nullish(),
  });

export const // @ts-nocheck
  Gemini_Notes_SyncUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Gemini_Notes_SyncUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    doc_created_at: z.string().nullish(),
    doc_modified_at: z.string().nullish(),
    doc_title: z.string().nullish(),
    doc_url: z.string().nullish(),
    file_id: z.string().nullish(),
    matched_entity_id: z.string().nullish(),
    matched_entity_type: z.string().nullish(),
    organizer_email: z.string().nullish(),
    posted_at: z.string().nullish(),
    slack_canvas_id: z.string().nullish(),
    slack_canvas_url: z.string().nullish(),
    slack_channel_id: z.string().nullish(),
    slack_ts: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Gemini_Notes_SyncInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Gemini_Notes_SyncInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    doc_created_at: z.string().nullish(),
    doc_modified_at: z.string().nullish(),
    doc_title: z.string().nullish(),
    doc_url: z.string().nullish(),
    file_id: z.string().nullish(),
    matched_entity_id: z.string().nullish(),
    matched_entity_type: z.string().nullish(),
    organizer_email: z.string().nullish(),
    posted_at: z.string().nullish(),
    slack_canvas_id: z.string().nullish(),
    slack_canvas_url: z.string().nullish(),
    slack_channel_id: z.string().nullish(),
    slack_ts: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Employee_Contact_AccessUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Employee_Contact_AccessUpdateInput
    >
  > = z.object({
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    granted_by: z.string().nullish(),
    id: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Employee_Contact_AccessInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Employee_Contact_AccessInsertInput
    >
  > = z.object({
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    granted_by: z.string().nullish(),
    id: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Embedding_JobsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Embedding_JobsUpdateInput
    >
  > = z.object({
    attempts: z.number().nullish(),
    enqueued_at: z.string().nullish(),
    entity_id: z.string().nullish(),
    entity_type: z.string().nullish(),
    last_error: z.string().nullish(),
    op: z.string().nullish(),
  });

export const // @ts-nocheck
  Embedding_JobsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Embedding_JobsInsertInput
    >
  > = z.object({
    attempts: z.number().nullish(),
    enqueued_at: z.string().nullish(),
    entity_id: z.string().nullish(),
    entity_type: z.string().nullish(),
    last_error: z.string().nullish(),
    op: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_UnsubscribesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_UnsubscribesUpdateInput
    >
  > = z.object({
    brand: z.string().nullish(),
    campaign_id: z.string().nullish(),
    email: z.string().nullish(),
    id: z.string().nullish(),
    unsubscribed_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_UnsubscribesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_UnsubscribesInsertInput
    >
  > = z.object({
    brand: z.string().nullish(),
    campaign_id: z.string().nullish(),
    email: z.string().nullish(),
    id: z.string().nullish(),
    unsubscribed_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_Tracking_TokensUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Tracking_TokensUpdateInput
    >
  > = z.object({
    communication_id: z.string().nullish(),
    company_id: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    direction: z.string().nullish(),
    external_id: z.string().nullish(),
    first_ip: z.string().nullish(),
    first_user_agent: z.string().nullish(),
    id: z.string().nullish(),
    last_opened_at: z.string().nullish(),
    open_count: z.number().nullish(),
    opened_at: z.string().nullish(),
    provider: z.string().nullish(),
    recipient_email: z.string().nullish(),
    sent_by: z.string().nullish(),
    source: z.string().nullish(),
    token: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_Tracking_TokensInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Tracking_TokensInsertInput
    >
  > = z.object({
    communication_id: z.string().nullish(),
    company_id: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    direction: z.string().nullish(),
    external_id: z.string().nullish(),
    first_ip: z.string().nullish(),
    first_user_agent: z.string().nullish(),
    id: z.string().nullish(),
    last_opened_at: z.string().nullish(),
    open_count: z.number().nullish(),
    opened_at: z.string().nullish(),
    provider: z.string().nullish(),
    recipient_email: z.string().nullish(),
    sent_by: z.string().nullish(),
    source: z.string().nullish(),
    token: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_Tracking_Open_EventsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Tracking_Open_EventsUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    ip: z.string().nullish(),
    occurred_at: z.string().nullish(),
    token_id: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_agent: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_Tracking_Open_EventsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Tracking_Open_EventsInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    ip: z.string().nullish(),
    occurred_at: z.string().nullish(),
    token_id: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_agent: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_TemplatesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_TemplatesUpdateInput
    >
  > = z.object({
    body: z.string().nullish(),
    created_at: z.string().nullish(),
    folder_id: z.string().nullish(),
    id: z.string().nullish(),
    is_shared: z.boolean().nullish(),
    name: z.string().nullish(),
    search_vector: z.any().nullish(),
    subject: z.string().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    user_id: z.string().nullish(),
    variables: z.record(z.string(), z.any()).nullish(),
  });

export const // @ts-nocheck
  Email_TemplatesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_TemplatesInsertInput
    >
  > = z.object({
    body: z.string().nullish(),
    created_at: z.string().nullish(),
    folder_id: z.string().nullish(),
    id: z.string().nullish(),
    is_shared: z.boolean().nullish(),
    name: z.string().nullish(),
    search_vector: z.any().nullish(),
    subject: z.string().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    user_id: z.string().nullish(),
    variables: z.record(z.string(), z.any()).nullish(),
  });

export const // @ts-nocheck
  Email_Template_SharesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_SharesUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    template_id: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_Template_SharesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_SharesInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    template_id: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_Template_FoldersUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_FoldersUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    parent_id: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_Template_FoldersInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_FoldersInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    parent_id: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_Template_FilesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_FilesUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    file_category: z.string().nullish(),
    file_name: z.string().nullish(),
    file_size: z.number().nullish(),
    file_type: z.string().nullish(),
    id: z.string().nullish(),
    storage_path: z.string().nullish(),
    storage_url: z.string().nullish(),
    template_id: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_Template_FilesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_FilesInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    file_category: z.string().nullish(),
    file_name: z.string().nullish(),
    file_size: z.number().nullish(),
    file_type: z.string().nullish(),
    id: z.string().nullish(),
    storage_path: z.string().nullish(),
    storage_url: z.string().nullish(),
    template_id: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_Template_FavoritesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_FavoritesUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    template_id: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_Template_FavoritesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_FavoritesInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    template_id: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_SignaturesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_SignaturesUpdateInput
    >
  > = z.object({
    connection_id: z.string().nullish(),
    content: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    is_default: z.boolean().nullish(),
    name: z.string().nullish(),
    owner_id: z.string().nullish(),
    provider_config_key: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_SignaturesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_SignaturesInsertInput
    >
  > = z.object({
    connection_id: z.string().nullish(),
    content: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    is_default: z.boolean().nullish(),
    name: z.string().nullish(),
    owner_id: z.string().nullish(),
    provider_config_key: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_Forwarding_LogUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Forwarding_LogUpdateInput
    >
  > = z.object({
    canvas_id: z.string().nullish(),
    card_blocks: z.record(z.string(), z.any()).nullish(),
    created_at: z.string().nullish(),
    email_external_id: z.string().nullish(),
    error: z.string().nullish(),
    id: z.string().nullish(),
    reviewed_at: z.string().nullish(),
    reviewed_by_slack_user_id: z.string().nullish(),
    rule_id: z.string().nullish(),
    sender_email: z.string().nullish(),
    slack_channel_id: z.string().nullish(),
    slack_message_ts: z.string().nullish(),
    status: z.string().nullish(),
    subject: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_Forwarding_LogInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Forwarding_LogInsertInput
    >
  > = z.object({
    canvas_id: z.string().nullish(),
    card_blocks: z.record(z.string(), z.any()).nullish(),
    created_at: z.string().nullish(),
    email_external_id: z.string().nullish(),
    error: z.string().nullish(),
    id: z.string().nullish(),
    reviewed_at: z.string().nullish(),
    reviewed_by_slack_user_id: z.string().nullish(),
    rule_id: z.string().nullish(),
    sender_email: z.string().nullish(),
    slack_channel_id: z.string().nullish(),
    slack_message_ts: z.string().nullish(),
    status: z.string().nullish(),
    subject: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_EventsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_EventsUpdateInput
    >
  > = z.object({
    campaign_id: z.string().nullish(),
    id: z.string().nullish(),
    ip: z.string().nullish(),
    occurred_at: z.string().nullish(),
    recipient_id: z.string().nullish(),
    type: z.string().nullish(),
    url: z.string().nullish(),
    user_agent: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_EventsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_EventsInsertInput
    >
  > = z.object({
    campaign_id: z.string().nullish(),
    id: z.string().nullish(),
    ip: z.string().nullish(),
    occurred_at: z.string().nullish(),
    recipient_id: z.string().nullish(),
    type: z.string().nullish(),
    url: z.string().nullish(),
    user_agent: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_CampaignsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_CampaignsUpdateInput
    >
  > = z.object({
    audience_id: z.string().nullish(),
    body_html: z.string().nullish(),
    brand: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    from_email: z.string().nullish(),
    from_name: z.string().nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    reply_to: z.string().nullish(),
    scheduled_at: z.string().nullish(),
    sent_at: z.string().nullish(),
    stats: z.record(z.string(), z.any()).nullish(),
    status: z.string().nullish(),
    subject: z.string().nullish(),
    template_id: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_CampaignsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_CampaignsInsertInput
    >
  > = z.object({
    audience_id: z.string().nullish(),
    body_html: z.string().nullish(),
    brand: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    from_email: z.string().nullish(),
    from_name: z.string().nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    reply_to: z.string().nullish(),
    scheduled_at: z.string().nullish(),
    sent_at: z.string().nullish(),
    stats: z.record(z.string(), z.any()).nullish(),
    status: z.string().nullish(),
    subject: z.string().nullish(),
    template_id: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_Campaign_RecipientsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Campaign_RecipientsUpdateInput
    >
  > = z.object({
    campaign_id: z.string().nullish(),
    clicked_at: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    email: z.string().nullish(),
    error: z.string().nullish(),
    id: z.string().nullish(),
    opened_at: z.string().nullish(),
    sent_at: z.string().nullish(),
    status: z.string().nullish(),
    tracking_token: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_Campaign_RecipientsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Campaign_RecipientsInsertInput
    >
  > = z.object({
    campaign_id: z.string().nullish(),
    clicked_at: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    email: z.string().nullish(),
    error: z.string().nullish(),
    id: z.string().nullish(),
    opened_at: z.string().nullish(),
    sent_at: z.string().nullish(),
    status: z.string().nullish(),
    tracking_token: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_AudiencesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_AudiencesUpdateInput
    >
  > = z.object({
    brand: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    id: z.string().nullish(),
    kind: z.string().nullish(),
    member_emails: z.array(z.string().nullable()).nullish(),
    name: z.string().nullish(),
    segment_definition: z.record(z.string(), z.any()).nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Email_AudiencesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_AudiencesInsertInput
    >
  > = z.object({
    brand: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    id: z.string().nullish(),
    kind: z.string().nullish(),
    member_emails: z.array(z.string().nullable()).nullish(),
    name: z.string().nullish(),
    segment_definition: z.record(z.string(), z.any()).nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Drive_User_RootsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Drive_User_RootsUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    root_folder_id: z.string().nullish(),
    shared_drive_id: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Drive_User_RootsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Drive_User_RootsInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    root_folder_id: z.string().nullish(),
    shared_drive_id: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Drive_NodesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Drive_NodesUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    drive_file_id: z.string().nullish(),
    id: z.string().nullish(),
    is_root: z.boolean().nullish(),
    kind: z.string().nullish(),
    mime_type: z.string().nullish(),
    name: z.string().nullish(),
    parent_drive_file_id: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Drive_NodesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Drive_NodesInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    drive_file_id: z.string().nullish(),
    id: z.string().nullish(),
    is_root: z.boolean().nullish(),
    kind: z.string().nullish(),
    mime_type: z.string().nullish(),
    name: z.string().nullish(),
    parent_drive_file_id: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Document_EmbeddingsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Document_EmbeddingsUpdateInput
    >
  > = z.object({
    content_hash: z.string().nullish(),
    created_at: z.string().nullish(),
    embedding: z.any().nullish(),
    entity_id: z.string().nullish(),
    entity_type: z.string().nullish(),
    id: z.string().nullish(),
    indexed_at: z.string().nullish(),
    model_id: z.string().nullish(),
    source_updated_at: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Document_EmbeddingsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Document_EmbeddingsInsertInput
    >
  > = z.object({
    content_hash: z.string().nullish(),
    created_at: z.string().nullish(),
    embedding: z.any().nullish(),
    entity_id: z.string().nullish(),
    entity_type: z.string().nullish(),
    id: z.string().nullish(),
    indexed_at: z.string().nullish(),
    model_id: z.string().nullish(),
    source_updated_at: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Device_Push_TokensUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Device_Push_TokensUpdateInput
    >
  > = z.object({
    apns_token: z.string().nullish(),
    app_version: z.string().nullish(),
    created_at: z.string().nullish(),
    environment: z.string().nullish(),
    id: z.string().nullish(),
    last_seen_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Device_Push_TokensInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Device_Push_TokensInsertInput
    >
  > = z.object({
    apns_token: z.string().nullish(),
    app_version: z.string().nullish(),
    created_at: z.string().nullish(),
    environment: z.string().nullish(),
    id: z.string().nullish(),
    last_seen_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Customer_FeedbackUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Customer_FeedbackUpdateInput
    >
  > = z.object({
    comment: z.string().nullish(),
    company_id: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    entity_id: z.string().nullish(),
    entity_type: z.string().nullish(),
    feedback_scope: z.string().nullish(),
    id: z.string().nullish(),
    is_anonymous: z.boolean().nullish(),
    metadata: z.record(z.string(), z.any()).nullish(),
    rating: z.number().nullish(),
    secure_link_id: z.string().nullish(),
    slack_message_ts: z.string().nullish(),
    source: z.string().nullish(),
    ticket_id: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Customer_FeedbackInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Customer_FeedbackInsertInput
    >
  > = z.object({
    comment: z.string().nullish(),
    company_id: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    entity_id: z.string().nullish(),
    entity_type: z.string().nullish(),
    feedback_scope: z.string().nullish(),
    id: z.string().nullish(),
    is_anonymous: z.boolean().nullish(),
    metadata: z.record(z.string(), z.any()).nullish(),
    rating: z.number().nullish(),
    secure_link_id: z.string().nullish(),
    slack_message_ts: z.string().nullish(),
    source: z.string().nullish(),
    ticket_id: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Cron_Job_RunsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Cron_Job_RunsUpdateInput
    >
  > = z.object({
    completed_at: z.string().nullish(),
    created_at: z.string().nullish(),
    duration_ms: z.number().nullish(),
    error_summary: z.string().nullish(),
    id: z.string().nullish(),
    job_id: z.string().nullish(),
    metadata: z.record(z.string(), z.any()).nullish(),
    metrics: z.record(z.string(), z.any()).nullish(),
    started_at: z.string().nullish(),
    status: z.string().nullish(),
  });

export const // @ts-nocheck
  Cron_Job_RunsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Cron_Job_RunsInsertInput
    >
  > = z.object({
    completed_at: z.string().nullish(),
    created_at: z.string().nullish(),
    duration_ms: z.number().nullish(),
    error_summary: z.string().nullish(),
    id: z.string().nullish(),
    job_id: z.string().nullish(),
    metadata: z.record(z.string(), z.any()).nullish(),
    metrics: z.record(z.string(), z.any()).nullish(),
    started_at: z.string().nullish(),
    status: z.string().nullish(),
  });

export const // @ts-nocheck
  Crm_Remediation_BackupUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Crm_Remediation_BackupUpdateInput
    >
  > = z.object({
    batch: z.string().nullish(),
    column_name: z.string().nullish(),
    entity_id: z.string().nullish(),
    entity_table: z.string().nullish(),
    note: z.string().nullish(),
    old_value: z.record(z.string(), z.any()).nullish(),
    ran_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Crm_Remediation_BackupInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Crm_Remediation_BackupInsertInput
    >
  > = z.object({
    batch: z.string().nullish(),
    column_name: z.string().nullish(),
    entity_id: z.string().nullish(),
    entity_table: z.string().nullish(),
    note: z.string().nullish(),
    old_value: z.record(z.string(), z.any()).nullish(),
    ran_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Contract_PreviewsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contract_PreviewsUpdateInput
    >
  > = z.object({
    contract_id: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    id: z.string().nullish(),
    pdf_url: z.string().nullish(),
    secure_link_id: z.string().nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Contract_PreviewsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contract_PreviewsInsertInput
    >
  > = z.object({
    contract_id: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    id: z.string().nullish(),
    pdf_url: z.string().nullish(),
    secure_link_id: z.string().nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_User_AccessUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_User_AccessUpdateInput
    >
  > = z.object({
    access_level: z.string().nullish(),
    contact_id: z.string().nullish(),
    expires_at: z.string().nullish(),
    granted_at: z.string().nullish(),
    granted_by: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_User_AccessInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_User_AccessInsertInput
    >
  > = z.object({
    access_level: z.string().nullish(),
    contact_id: z.string().nullish(),
    expires_at: z.string().nullish(),
    granted_at: z.string().nullish(),
    granted_by: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_TasksUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_TasksUpdateInput
    >
  > = z.object({
    assigned_users: z.array(z.string().nullable()).nullish(),
    company_id: z.string().nullish(),
    completed_at: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    due_date: z.string().nullish(),
    entity_id: z.string().nullish(),
    entity_type: z.string().nullish(),
    id: z.string().nullish(),
    priority: z.string().nullish(),
    search_vector: z.any().nullish(),
    // @ts-nocheck
    status: Task_StatusSchema.nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_TasksInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_TasksInsertInput
    >
  > = z.object({
    assigned_users: z.array(z.string().nullable()).nullish(),
    company_id: z.string().nullish(),
    completed_at: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    due_date: z.string().nullish(),
    entity_id: z.string().nullish(),
    entity_type: z.string().nullish(),
    id: z.string().nullish(),
    priority: z.string().nullish(),
    search_vector: z.any().nullish(),
    // @ts-nocheck
    status: Task_StatusSchema.nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_NotesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_NotesUpdateInput
    >
  > = z.object({
    contact_id: z.string().nullish(),
    content: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    is_internal: z.boolean().nullish(),
    // @ts-nocheck
    note_type: Note_TypeSchema.nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_NotesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_NotesInsertInput
    >
  > = z.object({
    contact_id: z.string().nullish(),
    content: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    is_internal: z.boolean().nullish(),
    // @ts-nocheck
    note_type: Note_TypeSchema.nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_Method_ClaimsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_Method_ClaimsUpdateInput
    >
  > = z.object({
    claimed_at: z.string().nullish(),
    is_legacy_conflict: z.boolean().nullish(),
    is_primary: z.boolean().nullish(),
    kind: z.string().nullish(),
    owner_id: z.string().nullish(),
    owner_type: z.string().nullish(),
    source_column: z.string().nullish(),
    value_key: z.string().nullish(),
    value_raw: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_Method_ClaimsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_Method_ClaimsInsertInput
    >
  > = z.object({
    claimed_at: z.string().nullish(),
    is_legacy_conflict: z.boolean().nullish(),
    is_primary: z.boolean().nullish(),
    kind: z.string().nullish(),
    owner_id: z.string().nullish(),
    owner_type: z.string().nullish(),
    source_column: z.string().nullish(),
    value_key: z.string().nullish(),
    value_raw: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_MessagesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_MessagesUpdateInput
    >
  > = z.object({
    body: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    delivered_at: z.string().nullish(),
    direction: z.string().nullish(),
    external_message_id: z.string().nullish(),
    id: z.string().nullish(),
    message_type: z.string().nullish(),
    read_at: z.string().nullish(),
    sent_at: z.string().nullish(),
    status: z.string().nullish(),
    subject: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_MessagesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_MessagesInsertInput
    >
  > = z.object({
    body: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    delivered_at: z.string().nullish(),
    direction: z.string().nullish(),
    external_message_id: z.string().nullish(),
    id: z.string().nullish(),
    message_type: z.string().nullish(),
    read_at: z.string().nullish(),
    sent_at: z.string().nullish(),
    status: z.string().nullish(),
    subject: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_Merge_IgnoresUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_Merge_IgnoresUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    ignored_by: z.string().nullish(),
    placeholder_contact_id: z.string().nullish(),
    reason: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_Merge_IgnoresInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_Merge_IgnoresInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    ignored_by: z.string().nullish(),
    placeholder_contact_id: z.string().nullish(),
    reason: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_MeetingsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_MeetingsUpdateInput
    >
  > = z.object({
    attendees: z.array(z.string().nullable()).nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    end_time: z.string().nullish(),
    id: z.string().nullish(),
    location: z.string().nullish(),
    meeting_type: z.string().nullish(),
    notes: z.string().nullish(),
    start_time: z.string().nullish(),
    // @ts-nocheck
    status: Meeting_StatusSchema.nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_MeetingsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_MeetingsInsertInput
    >
  > = z.object({
    attendees: z.array(z.string().nullable()).nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    end_time: z.string().nullish(),
    id: z.string().nullish(),
    location: z.string().nullish(),
    meeting_type: z.string().nullish(),
    notes: z.string().nullish(),
    start_time: z.string().nullish(),
    // @ts-nocheck
    status: Meeting_StatusSchema.nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Connection_SharesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Connection_SharesUpdateInput
    >
  > = z.object({
    connection_id: z.string().nullish(),
    created_at: z.string().nullish(),
    drive_access_enabled: z.boolean().nullish(),
    id: z.string().nullish(),
    owner_id: z.string().nullish(),
    provider_config_key: z.string().nullish(),
    shared_with_user_id: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Connection_SharesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Connection_SharesInsertInput
    >
  > = z.object({
    connection_id: z.string().nullish(),
    created_at: z.string().nullish(),
    drive_access_enabled: z.boolean().nullish(),
    id: z.string().nullish(),
    owner_id: z.string().nullish(),
    provider_config_key: z.string().nullish(),
    shared_with_user_id: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Company_User_AccessUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Company_User_AccessUpdateInput
    >
  > = z.object({
    access_level: z.string().nullish(),
    company_id: z.string().nullish(),
    created_at: z.string().nullish(),
    expires_at: z.string().nullish(),
    granted_at: z.string().nullish(),
    granted_by: z.string().nullish(),
    is_active: z.boolean().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Company_User_AccessInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Company_User_AccessInsertInput
    >
  > = z.object({
    access_level: z.string().nullish(),
    company_id: z.string().nullish(),
    created_at: z.string().nullish(),
    expires_at: z.string().nullish(),
    granted_at: z.string().nullish(),
    granted_by: z.string().nullish(),
    is_active: z.boolean().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Company_Slack_Channel_Link_IgnoresUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Company_Slack_Channel_Link_IgnoresUpdateInput
    >
  > = z.object({
    company_id: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    ignored_by: z.string().nullish(),
    reason: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Company_Slack_Channel_Link_IgnoresInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Company_Slack_Channel_Link_IgnoresInsertInput
    >
  > = z.object({
    company_id: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    ignored_by: z.string().nullish(),
    reason: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Company_Quickbooks_CustomersUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Company_Quickbooks_CustomersUpdateInput
    >
  > = z.object({
    company_id: z.string().nullish(),
    customer_id: z.string().nullish(),
    customer_name: z.string().nullish(),
    is_legacy_conflict: z.boolean().nullish(),
    is_secondary: z.boolean().nullish(),
    linked_at: z.string().nullish(),
    linked_by: z.string().nullish(),
    realm_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Company_Quickbooks_CustomersInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Company_Quickbooks_CustomersInsertInput
    >
  > = z.object({
    company_id: z.string().nullish(),
    customer_id: z.string().nullish(),
    customer_name: z.string().nullish(),
    is_legacy_conflict: z.boolean().nullish(),
    is_secondary: z.boolean().nullish(),
    linked_at: z.string().nullish(),
    linked_by: z.string().nullish(),
    realm_id: z.string().nullish(),
  });

export const // @ts-nocheck
  CommunicationsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      CommunicationsUpdateInput
    >
  > = z.object({
    attachment_count: z.number().nullish(),
    attachments: z.record(z.string(), z.any()).nullish(),
    body: z.string().nullish(),
    body_byte_size: z.number().nullish(),
    body_content_type: z.string().nullish(),
    body_preview: z.string().nullish(),
    body_s3_key: z.string().nullish(),
    company_id: z.string().nullish(),
    company_name: z.string().nullish(),
    contact_id: z.string().nullish(),
    contact_name: z.string().nullish(),
    created_at: z.string().nullish(),
    direction: z.string().nullish(),
    external_id: z.string().nullish(),
    id: z.string().nullish(),
    metadata: z.record(z.string(), z.any()).nullish(),
    metadata_s3_key: z.string().nullish(),
    occurred_at: z.string().nullish(),
    search_vector: z.any().nullish(),
    status: z.string().nullish(),
    title: z.string().nullish(),
    type_id: z.string().nullish(),
    type_label: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  CommunicationsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      CommunicationsInsertInput
    >
  > = z.object({
    attachment_count: z.number().nullish(),
    attachments: z.record(z.string(), z.any()).nullish(),
    body: z.string().nullish(),
    body_byte_size: z.number().nullish(),
    body_content_type: z.string().nullish(),
    body_preview: z.string().nullish(),
    body_s3_key: z.string().nullish(),
    company_id: z.string().nullish(),
    company_name: z.string().nullish(),
    contact_id: z.string().nullish(),
    contact_name: z.string().nullish(),
    created_at: z.string().nullish(),
    direction: z.string().nullish(),
    external_id: z.string().nullish(),
    id: z.string().nullish(),
    metadata: z.record(z.string(), z.any()).nullish(),
    metadata_s3_key: z.string().nullish(),
    occurred_at: z.string().nullish(),
    search_vector: z.any().nullish(),
    status: z.string().nullish(),
    title: z.string().nullish(),
    type_id: z.string().nullish(),
    type_label: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Communication_TypesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Communication_TypesUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    key: z.string().nullish(),
    label: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Communication_TypesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Communication_TypesInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    key: z.string().nullish(),
    label: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Calendar_CacheUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Calendar_CacheUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    email: z.string().nullish(),
    end_time: z.string().nullish(),
    event_data: z.record(z.string(), z.any()).nullish(),
    event_id: z.string().nullish(),
    id: z.string().nullish(),
    last_synced: z.string().nullish(),
    provider: z.string().nullish(),
    start_time: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Calendar_CacheInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Calendar_CacheInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    email: z.string().nullish(),
    end_time: z.string().nullish(),
    event_data: z.record(z.string(), z.any()).nullish(),
    event_id: z.string().nullish(),
    id: z.string().nullish(),
    last_synced: z.string().nullish(),
    provider: z.string().nullish(),
    start_time: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Booking_HistoryUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Booking_HistoryUpdateInput
    >
  > = z.object({
    attendees: z.record(z.string(), z.any()).nullish(),
    bookee_email: z.string().nullish(),
    booker_email: z.string().nullish(),
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    end_time: z.string().nullish(),
    google_event_id: z.string().nullish(),
    id: z.string().nullish(),
    location: z.string().nullish(),
    msft_event_id: z.string().nullish(),
    start_time: z.string().nullish(),
    status: z.string().nullish(),
    subject: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Booking_HistoryInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Booking_HistoryInsertInput
    >
  > = z.object({
    attendees: z.record(z.string(), z.any()).nullish(),
    bookee_email: z.string().nullish(),
    booker_email: z.string().nullish(),
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    end_time: z.string().nullish(),
    google_event_id: z.string().nullish(),
    id: z.string().nullish(),
    location: z.string().nullish(),
    msft_event_id: z.string().nullish(),
    start_time: z.string().nullish(),
    status: z.string().nullish(),
    subject: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Automation_RulesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Automation_RulesUpdateInput
    >
  > = z.object({
    actions: z.record(z.string(), z.any()).nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    description: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    name: z.string().nullish(),
    priority: z.number().nullish(),
    trigger_condition: z.record(z.string(), z.any()).nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Automation_RulesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Automation_RulesInsertInput
    >
  > = z.object({
    actions: z.record(z.string(), z.any()).nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    description: z.string().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    name: z.string().nullish(),
    priority: z.number().nullish(),
    trigger_condition: z.record(z.string(), z.any()).nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Audit_LogUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Audit_LogUpdateInput
    >
  > = z.object({
    action: z.string().nullish(),
    created_at: z.string().nullish(),
    details: z.record(z.string(), z.any()).nullish(),
    email: z.string().nullish(),
    id: z.string().nullish(),
    ip_address: z.any().nullish(),
    provider: z.string().nullish(),
    user_agent: z.string().nullish(),
  });

export const // @ts-nocheck
  Audit_LogInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Audit_LogInsertInput
    >
  > = z.object({
    action: z.string().nullish(),
    created_at: z.string().nullish(),
    details: z.record(z.string(), z.any()).nullish(),
    email: z.string().nullish(),
    id: z.string().nullish(),
    ip_address: z.any().nullish(),
    provider: z.string().nullish(),
    user_agent: z.string().nullish(),
  });

export const // @ts-nocheck
  App_User_SkillsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      App_User_SkillsUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    grade: z.number().nullish(),
    skill_id: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  App_User_SkillsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      App_User_SkillsInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    grade: z.number().nullish(),
    skill_id: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Address_Geocode_CacheUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Address_Geocode_CacheUpdateInput
    >
  > = z.object({
    address_key: z.string().nullish(),
    created_at: z.string().nullish(),
    formatted_address: z.string().nullish(),
    lat: z.number().nullish(),
    lng: z.number().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Address_Geocode_CacheInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Address_Geocode_CacheInsertInput
    >
  > = z.object({
    address_key: z.string().nullish(),
    created_at: z.string().nullish(),
    formatted_address: z.string().nullish(),
    lat: z.number().nullish(),
    lng: z.number().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Recurring_ChargesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Recurring_ChargesUpdateInput
    >
  > = z.object({
    admin_email: z.string().nullish(),
    company_id: z.string().nullish(),
    created_at: z.string().nullish(),
    customer_id: z.string().nullish(),
    id: z.string().nullish(),
    last_charged_at: z.string().nullish(),
    metadata: z.record(z.string(), z.any()).nullish(),
    next_charge_date: z.string().nullish(),
    realm_id: z.string().nullish(),
    schedule_type: z.string().nullish(),
    search_vector: z.any().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Recurring_ChargesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Recurring_ChargesInsertInput
    >
  > = z.object({
    admin_email: z.string().nullish(),
    company_id: z.string().nullish(),
    created_at: z.string().nullish(),
    customer_id: z.string().nullish(),
    id: z.string().nullish(),
    last_charged_at: z.string().nullish(),
    metadata: z.record(z.string(), z.any()).nullish(),
    next_charge_date: z.string().nullish(),
    realm_id: z.string().nullish(),
    schedule_type: z.string().nullish(),
    search_vector: z.any().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Plaid_StatementsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_StatementsUpdateInput
    >
  > = z.object({
    account_id: z.string().nullish(),
    content_hash: z.string().nullish(),
    created_at: z.string().nullish(),
    date_posted: z.string().nullish(),
    drive_file_id: z.string().nullish(),
    drive_folder_id: z.string().nullish(),
    drive_synced_at: z.string().nullish(),
    drive_web_view_link: z.string().nullish(),
    id: z.string().nullish(),
    month: z.number().nullish(),
    plaid_item_id: z.string().nullish(),
    s3_key: z.string().nullish(),
    statement_id: z.string().nullish(),
    updated_at: z.string().nullish(),
    year: z.number().nullish(),
  });

export const // @ts-nocheck
  Plaid_StatementsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_StatementsInsertInput
    >
  > = z.object({
    account_id: z.string().nullish(),
    content_hash: z.string().nullish(),
    created_at: z.string().nullish(),
    date_posted: z.string().nullish(),
    drive_file_id: z.string().nullish(),
    drive_folder_id: z.string().nullish(),
    drive_synced_at: z.string().nullish(),
    drive_web_view_link: z.string().nullish(),
    id: z.string().nullish(),
    month: z.number().nullish(),
    plaid_item_id: z.string().nullish(),
    s3_key: z.string().nullish(),
    statement_id: z.string().nullish(),
    updated_at: z.string().nullish(),
    year: z.number().nullish(),
  });

export const // @ts-nocheck
  Entity_Automation_ConfigUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Entity_Automation_ConfigUpdateInput
    >
  > = z.object({
    assigned_user_ids: z.array(z.string().nullable()).nullish(),
    automation_kind: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    day_of_week: z.number().nullish(),
    enabled: z.boolean().nullish(),
    entity_id: z.string().nullish(),
    entity_type: z.string().nullish(),
    frequency: z.string().nullish(),
    goal_config: z.record(z.string(), z.any()).nullish(),
    goal_last_evaluated_at: z.string().nullish(),
    goal_last_posted_date: z.string().nullish(),
    goal_last_status: z.string().nullish(),
    id: z.string().nullish(),
    priority: z.string().nullish(),
    run_on_business_days_only: z.boolean().nullish(),
    selected_days_of_week: z.array(z.number().nullable()).nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    task_description_template: z.string().nullish(),
    task_title_fixed: z.string().nullish(),
    task_title_template: z.string().nullish(),
    updated_at: z.string().nullish(),
    use_title_template: z.boolean().nullish(),
  });

export const // @ts-nocheck
  Entity_Automation_ConfigInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Entity_Automation_ConfigInsertInput
    >
  > = z.object({
    assigned_user_ids: z.array(z.string().nullable()).nullish(),
    automation_kind: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    day_of_week: z.number().nullish(),
    enabled: z.boolean().nullish(),
    entity_id: z.string().nullish(),
    entity_type: z.string().nullish(),
    frequency: z.string().nullish(),
    goal_config: z.record(z.string(), z.any()).nullish(),
    goal_last_evaluated_at: z.string().nullish(),
    goal_last_posted_date: z.string().nullish(),
    goal_last_status: z.string().nullish(),
    id: z.string().nullish(),
    priority: z.string().nullish(),
    run_on_business_days_only: z.boolean().nullish(),
    selected_days_of_week: z.array(z.number().nullable()).nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    task_description_template: z.string().nullish(),
    task_title_fixed: z.string().nullish(),
    task_title_template: z.string().nullish(),
    updated_at: z.string().nullish(),
    use_title_template: z.boolean().nullish(),
  });

export const // @ts-nocheck
  ContractsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      ContractsUpdateInput
    >
  > = z.object({
    company_id: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    deal_id: z.string().nullish(),
    decline_reason: z.string().nullish(),
    delivery_mode: z.string().nullish(),
    document_name: z.string().nullish(),
    esignatures_contract_id: z.string().nullish(),
    expires_at: z.string().nullish(),
    id: z.string().nullish(),
    last_event_at: z.string().nullish(),
    metadata: z.record(z.string(), z.any()).nullish(),
    recipient_email: z.string().nullish(),
    recipient_name: z.string().nullish(),
    search_vector: z.any().nullish(),
    secure_link_id: z.string().nullish(),
    sent_at: z.string().nullish(),
    sent_by_user_id: z.string().nullish(),
    signed_at: z.string().nullish(),
    signed_pdf_url: z.string().nullish(),
    signing_url: z.string().nullish(),
    source: z.string().nullish(),
    status: z.string().nullish(),
    template_name: z.string().nullish(),
    term_months: z.number().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  ContractsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      ContractsInsertInput
    >
  > = z.object({
    company_id: z.string().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    deal_id: z.string().nullish(),
    decline_reason: z.string().nullish(),
    delivery_mode: z.string().nullish(),
    document_name: z.string().nullish(),
    esignatures_contract_id: z.string().nullish(),
    expires_at: z.string().nullish(),
    id: z.string().nullish(),
    last_event_at: z.string().nullish(),
    metadata: z.record(z.string(), z.any()).nullish(),
    recipient_email: z.string().nullish(),
    recipient_name: z.string().nullish(),
    search_vector: z.any().nullish(),
    secure_link_id: z.string().nullish(),
    sent_at: z.string().nullish(),
    sent_by_user_id: z.string().nullish(),
    signed_at: z.string().nullish(),
    signed_pdf_url: z.string().nullish(),
    signing_url: z.string().nullish(),
    source: z.string().nullish(),
    status: z.string().nullish(),
    template_name: z.string().nullish(),
    term_months: z.number().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  ContactsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      ContactsUpdateInput
    >
  > = z.object({
    accessible_by_user_ids: z.array(z.string().nullable()).nullish(),
    active_deal_count: z.number().nullish(),
    address: z.string().nullish(),
    avatar_url: z.string().nullish(),
    city: z.string().nullish(),
    company_id: z.string().nullish(),
    company_name: z.string().nullish(),
    contract_expires_at: z.string().nullish(),
    country: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    created_by_backfilled_at: z.string().nullish(),
    custom_fields: z.record(z.string(), z.any()).nullish(),
    email: z.string().nullish(),
    email_aliases: z.array(z.string().nullable()).nullish(),
    has_active_deals: z.boolean().nullish(),
    has_signed_contract: z.boolean().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    is_company_line: z.boolean().nullish(),
    last_contacted_at: z.string().nullish(),
    last_enriched_at: z.string().nullish(),
    last_follow_up_task_created_at: z.string().nullish(),
    lifecycle_stage: z.string().nullish(),
    name: z.string().nullish(),
    notes: z.string().nullish(),
    phone: z.string().nullish(),
    phone_aliases: z.array(z.string().nullable()).nullish(),
    search_vector: z.any().nullish(),
    social_links: z.record(z.string(), z.any()).nullish(),
    source: z.string().nullish(),
    state: z.string().nullish(),
    // @ts-nocheck
    status: Contact_StatusSchema.nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    title: z.string().nullish(),
    trigger_enrichment: z.boolean().nullish(),
    updated_at: z.string().nullish(),
    updated_by: z.string().nullish(),
    zip_code: z.string().nullish(),
  });

export const // @ts-nocheck
  ContactsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      ContactsInsertInput
    >
  > = z.object({
    accessible_by_user_ids: z.array(z.string().nullable()).nullish(),
    active_deal_count: z.number().nullish(),
    address: z.string().nullish(),
    avatar_url: z.string().nullish(),
    city: z.string().nullish(),
    company_id: z.string().nullish(),
    company_name: z.string().nullish(),
    contract_expires_at: z.string().nullish(),
    country: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    created_by_backfilled_at: z.string().nullish(),
    custom_fields: z.record(z.string(), z.any()).nullish(),
    email: z.string().nullish(),
    email_aliases: z.array(z.string().nullable()).nullish(),
    has_active_deals: z.boolean().nullish(),
    has_signed_contract: z.boolean().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    is_company_line: z.boolean().nullish(),
    last_contacted_at: z.string().nullish(),
    last_enriched_at: z.string().nullish(),
    last_follow_up_task_created_at: z.string().nullish(),
    lifecycle_stage: z.string().nullish(),
    name: z.string().nullish(),
    notes: z.string().nullish(),
    phone: z.string().nullish(),
    phone_aliases: z.array(z.string().nullable()).nullish(),
    search_vector: z.any().nullish(),
    social_links: z.record(z.string(), z.any()).nullish(),
    source: z.string().nullish(),
    state: z.string().nullish(),
    // @ts-nocheck
    status: Contact_StatusSchema.nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    title: z.string().nullish(),
    trigger_enrichment: z.boolean().nullish(),
    updated_at: z.string().nullish(),
    updated_by: z.string().nullish(),
    zip_code: z.string().nullish(),
  });

export const // @ts-nocheck
  Ticket_AttachmentsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ticket_AttachmentsUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    file_name: z.string().nullish(),
    file_path: z.string().nullish(),
    file_size: z.string().nullish(),
    id: z.string().nullish(),
    mime_type: z.string().nullish(),
    ticket_id: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Ticket_AttachmentsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ticket_AttachmentsInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    description: z.string().nullish(),
    file_name: z.string().nullish(),
    file_path: z.string().nullish(),
    file_size: z.string().nullish(),
    id: z.string().nullish(),
    mime_type: z.string().nullish(),
    ticket_id: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Tool_ApprovalsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_ApprovalsUpdateInput
    >
  > = z.object({
    chat_id: z.string().nullish(),
    created_at: z.string().nullish(),
    execution_claim_id: z.string().nullish(),
    execution_claimed_at: z.string().nullish(),
    execution_completed_at: z.string().nullish(),
    execution_succeeded: z.boolean().nullish(),
    expires_at: z.string().nullish(),
    id: z.string().nullish(),
    parameters: z.record(z.string(), z.any()).nullish(),
    requested_at: z.string().nullish(),
    responded_at: z.string().nullish(),
    responded_by: z.string().nullish(),
    slack_channel: z.string().nullish(),
    slack_message_ts: z.string().nullish(),
    slack_thread_ts: z.string().nullish(),
    slack_user_id: z.string().nullish(),
    status: z.string().nullish(),
    tool_name: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Tool_ApprovalsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_ApprovalsInsertInput
    >
  > = z.object({
    chat_id: z.string().nullish(),
    created_at: z.string().nullish(),
    execution_claim_id: z.string().nullish(),
    execution_claimed_at: z.string().nullish(),
    execution_completed_at: z.string().nullish(),
    execution_succeeded: z.boolean().nullish(),
    expires_at: z.string().nullish(),
    id: z.string().nullish(),
    parameters: z.record(z.string(), z.any()).nullish(),
    requested_at: z.string().nullish(),
    responded_at: z.string().nullish(),
    responded_by: z.string().nullish(),
    slack_channel: z.string().nullish(),
    slack_message_ts: z.string().nullish(),
    slack_thread_ts: z.string().nullish(),
    slack_user_id: z.string().nullish(),
    status: z.string().nullish(),
    tool_name: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_FilesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_FilesUpdateInput
    >
  > = z.object({
    contact_id: z.string().nullish(),
    description: z.string().nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    size: z.string().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    type: z.string().nullish(),
    updated_at: z.string().nullish(),
    uploaded_at: z.string().nullish(),
    url: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_FilesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_FilesInsertInput
    >
  > = z.object({
    contact_id: z.string().nullish(),
    description: z.string().nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    size: z.string().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    type: z.string().nullish(),
    updated_at: z.string().nullish(),
    uploaded_at: z.string().nullish(),
    url: z.string().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Time_Entry_TypeFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Time_Entry_TypeFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Time_Entry_TypeSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Time_Entry_TypeSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Time_Entry_TypeSchema.nullish(),
  });

export const // @ts-nocheck
  Ticket_StatusFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ticket_StatusFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Ticket_StatusSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Ticket_StatusSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Ticket_StatusSchema.nullish(),
  });

export const // @ts-nocheck
  Ticket_PriorityFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ticket_PriorityFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Ticket_PrioritySchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Ticket_PrioritySchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Ticket_PrioritySchema.nullish(),
  });

export const // @ts-nocheck
  Ticket_CategoryFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ticket_CategoryFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Ticket_CategorySchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Ticket_CategorySchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Ticket_CategorySchema.nullish(),
  });

export const // @ts-nocheck
  Task_StatusFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Task_StatusFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Task_StatusSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Task_StatusSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Task_StatusSchema.nullish(),
  });

export const // @ts-nocheck
  Sync_StatusFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sync_StatusFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Sync_StatusSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Sync_StatusSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Sync_StatusSchema.nullish(),
  });

export const // @ts-nocheck
  Sequence_TargetFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sequence_TargetFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Sequence_TargetSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Sequence_TargetSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Sequence_TargetSchema.nullish(),
  });

export const // @ts-nocheck
  Sequence_Step_OutcomeFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sequence_Step_OutcomeFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Sequence_Step_OutcomeSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Sequence_Step_OutcomeSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Sequence_Step_OutcomeSchema.nullish(),
  });

export const // @ts-nocheck
  Sequence_Region_HintFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sequence_Region_HintFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Sequence_Region_HintSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Sequence_Region_HintSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Sequence_Region_HintSchema.nullish(),
  });

export const // @ts-nocheck
  Sequence_Enrollment_StatusFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sequence_Enrollment_StatusFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Sequence_Enrollment_StatusSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Sequence_Enrollment_StatusSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Sequence_Enrollment_StatusSchema.nullish(),
  });

export const // @ts-nocheck
  Sequence_ChannelFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sequence_ChannelFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Sequence_ChannelSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Sequence_ChannelSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Sequence_ChannelSchema.nullish(),
  });

export const // @ts-nocheck
  Proposal_StatusFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Proposal_StatusFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Proposal_StatusSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Proposal_StatusSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Proposal_StatusSchema.nullish(),
  });

export const // @ts-nocheck
  Project_Health_StatusFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Project_Health_StatusFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Project_Health_StatusSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Project_Health_StatusSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Project_Health_StatusSchema.nullish(),
  });

export const // @ts-nocheck
  Note_TypeFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Note_TypeFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Note_TypeSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Note_TypeSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Note_TypeSchema.nullish(),
  });

export const // @ts-nocheck
  Meeting_StatusFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meeting_StatusFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Meeting_StatusSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Meeting_StatusSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Meeting_StatusSchema.nullish(),
  });

export const // @ts-nocheck
  Discount_TypeFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Discount_TypeFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Discount_TypeSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Discount_TypeSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Discount_TypeSchema.nullish(),
  });

export const // @ts-nocheck
  Deal_StatusFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Deal_StatusFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Deal_StatusSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Deal_StatusSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Deal_StatusSchema.nullish(),
  });

export const // @ts-nocheck
  Deal_StageFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Deal_StageFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Deal_StageSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Deal_StageSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Deal_StageSchema.nullish(),
  });

export const // @ts-nocheck
  Contact_StatusFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_StatusFilter
    >
  > = z.object({
    // @ts-nocheck
    eq: Contact_StatusSchema.nullish(),
    in: z
      .array(
        // @ts-nocheck
        Contact_StatusSchema
      )
      .nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    // @ts-nocheck
    neq: Contact_StatusSchema.nullish(),
  });

export const // @ts-nocheck
  UuidListFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      UuidListFilter
    >
  > = z.object({
    containedBy: z.array(z.string()).nullish(),
    contains: z.array(z.string()).nullish(),
    eq: z.array(z.string()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    overlaps: z.array(z.string()).nullish(),
  });

export const // @ts-nocheck
  UuidFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      UuidFilter
    >
  > = z.object({
    eq: z.string().nullish(),
    in: z.array(z.string()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    neq: z.string().nullish(),
  });

export const // @ts-nocheck
  TimeListFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      TimeListFilter
    >
  > = z.object({
    containedBy: z.array(z.string()).nullish(),
    contains: z.array(z.string()).nullish(),
    eq: z.array(z.string()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    overlaps: z.array(z.string()).nullish(),
  });

export const // @ts-nocheck
  TimeFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      TimeFilter
    >
  > = z.object({
    eq: z.string().nullish(),
    gt: z.string().nullish(),
    gte: z.string().nullish(),
    in: z.array(z.string()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    lt: z.string().nullish(),
    lte: z.string().nullish(),
    neq: z.string().nullish(),
  });

export const // @ts-nocheck
  StringListFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      StringListFilter
    >
  > = z.object({
    containedBy: z.array(z.string()).nullish(),
    contains: z.array(z.string()).nullish(),
    eq: z.array(z.string()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    overlaps: z.array(z.string()).nullish(),
  });

export const // @ts-nocheck
  StringFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      StringFilter
    >
  > = z.object({
    eq: z.string().nullish(),
    gt: z.string().nullish(),
    gte: z.string().nullish(),
    ilike: z.string().nullish(),
    in: z.array(z.string()).nullish(),
    iregex: z.string().nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    like: z.string().nullish(),
    lt: z.string().nullish(),
    lte: z.string().nullish(),
    neq: z.string().nullish(),
    regex: z.string().nullish(),
    startsWith: z.string().nullish(),
  });

export const // @ts-nocheck
  OpaqueFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      OpaqueFilter
    >
  > = z.object({
    eq: z.any().nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
  });

export const // @ts-nocheck
  IntListFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      IntListFilter
    >
  > = z.object({
    containedBy: z.array(z.number()).nullish(),
    contains: z.array(z.number()).nullish(),
    eq: z.array(z.number()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    overlaps: z.array(z.number()).nullish(),
  });

export const // @ts-nocheck
  IntFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      IntFilter
    >
  > = z.object({
    eq: z.number().nullish(),
    gt: z.number().nullish(),
    gte: z.number().nullish(),
    in: z.array(z.number()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    lt: z.number().nullish(),
    lte: z.number().nullish(),
    neq: z.number().nullish(),
  });

export const // @ts-nocheck
  FloatListFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      FloatListFilter
    >
  > = z.object({
    containedBy: z.array(z.number()).nullish(),
    contains: z.array(z.number()).nullish(),
    eq: z.array(z.number()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    overlaps: z.array(z.number()).nullish(),
  });

export const // @ts-nocheck
  FloatFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      FloatFilter
    >
  > = z.object({
    eq: z.number().nullish(),
    gt: z.number().nullish(),
    gte: z.number().nullish(),
    in: z.array(z.number()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    lt: z.number().nullish(),
    lte: z.number().nullish(),
    neq: z.number().nullish(),
  });

export const // @ts-nocheck
  DatetimeListFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      DatetimeListFilter
    >
  > = z.object({
    containedBy: z.array(z.string()).nullish(),
    contains: z.array(z.string()).nullish(),
    eq: z.array(z.string()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    overlaps: z.array(z.string()).nullish(),
  });

export const // @ts-nocheck
  DatetimeFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      DatetimeFilter
    >
  > = z.object({
    eq: z.string().nullish(),
    gt: z.string().nullish(),
    gte: z.string().nullish(),
    in: z.array(z.string()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    lt: z.string().nullish(),
    lte: z.string().nullish(),
    neq: z.string().nullish(),
  });

export const // @ts-nocheck
  User_PreferencesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      User_PreferencesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            User_PreferencesFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    default_meeting_duration: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      User_PreferencesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            User_PreferencesFilterSchema
        )
      )
      .nullish(),
    timezone: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Social_Media_PostsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Media_PostsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Social_Media_PostsFilterSchema
        )
      )
      .nullish(),
    body: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    brand: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    drive_file_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    drive_file_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    drive_folder_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    error_summary: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    location: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    media_kind: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    media_url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Social_Media_PostsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Social_Media_PostsFilterSchema
        )
      )
      .nullish(),
    platforms: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    published_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    scheduled_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    thumbnail_url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Social_Hashtag_GroupsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Hashtag_GroupsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Social_Hashtag_GroupsFilterSchema
        )
      )
      .nullish(),
    brand: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Social_Hashtag_GroupsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Social_Hashtag_GroupsFilterSchema
        )
      )
      .nullish(),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Social_Brand_CredentialsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Brand_CredentialsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Social_Brand_CredentialsFilterSchema
        )
      )
      .nullish(),
    api_key_encrypted: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    api_key_env_var: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    brand_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    channel_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    label: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    last_error: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    last_verified_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Social_Brand_CredentialsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Social_Brand_CredentialsFilterSchema
        )
      )
      .nullish(),
    platforms: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    provider: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Social_Brand_ChannelsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Social_Brand_ChannelsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Social_Brand_ChannelsFilterSchema
        )
      )
      .nullish(),
    brand_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    credential_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    external_channel_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    external_display_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    external_service: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    last_published_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Social_Brand_ChannelsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Social_Brand_ChannelsFilterSchema
        )
      )
      .nullish(),
    platform: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    provider: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    webhook_url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Slack_Processed_EventsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Slack_Processed_EventsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Slack_Processed_EventsFilterSchema
        )
      )
      .nullish(),
    dedup_key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    expires_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Slack_Processed_EventsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Slack_Processed_EventsFilterSchema
        )
      )
      .nullish(),
    payload_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    processed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Slack_Channel_ProvisioningFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Slack_Channel_ProvisioningFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Slack_Channel_ProvisioningFilterSchema
        )
      )
      .nullish(),
    bookmarks_hash: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    canvas_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    channel_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    content_hash: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    last_error: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    last_status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    last_synced_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Slack_Channel_ProvisioningFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Slack_Channel_ProvisioningFilterSchema
        )
      )
      .nullish(),
    topic_hash: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Skills_CatalogFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Skills_CatalogFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Skills_CatalogFilterSchema
        )
      )
      .nullish(),
    category: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Skills_CatalogFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Skills_CatalogFilterSchema
        )
      )
      .nullish(),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    sort_order: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Secure_LinksFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Secure_LinksFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Secure_LinksFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    expires_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    last_used_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    max_uses: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Secure_LinksFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Secure_LinksFilterSchema
        )
      )
      .nullish(),
    public_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    purpose: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    revoked_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    secret_hash: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    use_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Scheduled_SmsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Scheduled_SmsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Scheduled_SmsFilterSchema
        )
      )
      .nullish(),
    attempts: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    body: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    error: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    external_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    from_number: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Scheduled_SmsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Scheduled_SmsFilterSchema
        )
      )
      .nullish(),
    phone_override: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    quick_reply_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    scheduled_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    sent_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Scheduled_EmailsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Scheduled_EmailsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Scheduled_EmailsFilterSchema
        )
      )
      .nullish(),
    attempts: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    bcc: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    body: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    body_format: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    cc: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    connection_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    error: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Scheduled_EmailsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Scheduled_EmailsFilterSchema
        )
      )
      .nullish(),
    provider: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    scheduled_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    sent_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    signature_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    subject: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    template_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    to_email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Saved_ViewsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Saved_ViewsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Saved_ViewsFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Saved_ViewsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Saved_ViewsFilterSchema
        )
      )
      .nullish(),
    resource: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    shared_with_user_ids: z.lazy(() =>
      // @ts-nocheck
      UuidListFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    visibility: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Saved_View_FavoritesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Saved_View_FavoritesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Saved_View_FavoritesFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Saved_View_FavoritesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Saved_View_FavoritesFilterSchema
        )
      )
      .nullish(),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    view_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Sales_Sequence_Step_EventsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_Sequence_Step_EventsFilter
    >
  > = z.object({
    actor: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Sales_Sequence_Step_EventsFilterSchema
        )
      )
      .nullish(),
    channel: z.lazy(() =>
      // @ts-nocheck
      Sequence_ChannelFilterSchema.nullish()
    ),
    communication_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    enrollment_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Sales_Sequence_Step_EventsFilterSchema.nullish()
    ),
    note: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    occurred_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Sales_Sequence_Step_EventsFilterSchema
        )
      )
      .nullish(),
    outcome: z.lazy(() =>
      // @ts-nocheck
      Sequence_Step_OutcomeFilterSchema.nullish()
    ),
    step_number: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Sales_Sequence_EnrollmentsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_Sequence_EnrollmentsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Sales_Sequence_EnrollmentsFilterSchema
        )
      )
      .nullish(),
    assigned_to: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    completed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    current_step_number: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    deal_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    enrolled_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    next_action_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Sales_Sequence_EnrollmentsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Sales_Sequence_EnrollmentsFilterSchema
        )
      )
      .nullish(),
    pause_reason: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    paused_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    sequence_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      Sequence_Enrollment_StatusFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Rate_Limit_BucketsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Rate_Limit_BucketsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Rate_Limit_BucketsFilterSchema
        )
      )
      .nullish(),
    bucket_key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Rate_Limit_BucketsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Rate_Limit_BucketsFilterSchema
        )
      )
      .nullish(),
    tokens: z.lazy(() =>
      // @ts-nocheck
      FloatFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Quickbooks_Customer_Link_IgnoresFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Quickbooks_Customer_Link_IgnoresFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Quickbooks_Customer_Link_IgnoresFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    ignored_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Quickbooks_Customer_Link_IgnoresFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Quickbooks_Customer_Link_IgnoresFilterSchema
        )
      )
      .nullish(),
    qb_customer_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    qb_customer_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    realm_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    reason: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Quickbooks_Company_Customer_AcksFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Quickbooks_Company_Customer_AcksFilter
    >
  > = z.object({
    acked_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Quickbooks_Company_Customer_AcksFilterSchema
        )
      )
      .nullish(),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Quickbooks_Company_Customer_AcksFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Quickbooks_Company_Customer_AcksFilterSchema
        )
      )
      .nullish(),
    realm_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    reason: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    secondary_customer_ids: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Post_Audit_DocumentsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_DocumentsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Post_Audit_DocumentsFilterSchema
        )
      )
      .nullish(),
    attachment_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    completed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    completed_by_slack_user_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    done_folder_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    drive_file_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    environment: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    message_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Post_Audit_DocumentsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Post_Audit_DocumentsFilterSchema
        )
      )
      .nullish(),
    pending_folder_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_channel_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_message_ts: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    source: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Post_Audit_Cron_LogsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_Cron_LogsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Post_Audit_Cron_LogsFilterSchema
        )
      )
      .nullish(),
    createdAt: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    duration_ms: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    environment: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    month: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Post_Audit_Cron_LogsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Post_Audit_Cron_LogsFilterSchema
        )
      )
      .nullish(),
    searchDate: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    userEmail: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Pending_ApprovalsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Pending_ApprovalsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Pending_ApprovalsFilterSchema
        )
      )
      .nullish(),
    approval_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id_column: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Pending_ApprovalsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Pending_ApprovalsFilterSchema
        )
      )
      .nullish(),
    row_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_channel: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_ts: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    table_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Notetaker_Summary_LogFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Notetaker_Summary_LogFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Notetaker_Summary_LogFilterSchema
        )
      )
      .nullish(),
    canvas_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    email_external_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    error: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    mailbox: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Notetaker_Summary_LogFilterSchema.nullish()
    ),
    notetaker_source: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Notetaker_Summary_LogFilterSchema
        )
      )
      .nullish(),
    sender_email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_channel_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_message_ts: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    subject: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Meridian_User_MemoriesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_User_MemoriesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_User_MemoriesFilterSchema
        )
      )
      .nullish(),
    content: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    embedding: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    importance: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    last_used_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    memory_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Meridian_User_MemoriesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_User_MemoriesFilterSchema
        )
      )
      .nullish(),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    source: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    use_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Meridian_Tool_RollupsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_RollupsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Tool_RollupsFilterSchema
        )
      )
      .nullish(),
    chat_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Meridian_Tool_RollupsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Tool_RollupsFilterSchema
        )
      )
      .nullish(),
    thread_ts: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Meridian_Tool_ResultsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_ResultsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Tool_ResultsFilterSchema
        )
      )
      .nullish(),
    chat_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    executed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    execution_time: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    input_size: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Meridian_Tool_ResultsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Tool_ResultsFilterSchema
        )
      )
      .nullish(),
    output_size: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    result_summary: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    result_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    summarized_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    tool_call_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    tool_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Meridian_Tool_Approval_OverridesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_Approval_OverridesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Tool_Approval_OverridesFilterSchema
        )
      )
      .nullish(),
    approval_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Meridian_Tool_Approval_OverridesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Tool_Approval_OverridesFilterSchema
        )
      )
      .nullish(),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Meridian_Skills_Sync_StateFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Skills_Sync_StateFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Skills_Sync_StateFilterSchema
        )
      )
      .nullish(),
    catalog_etag: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    catalog_generated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    catalog_sha: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    last_sync_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    last_sync_error: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    last_sync_status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Meridian_Skills_Sync_StateFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Skills_Sync_StateFilterSchema
        )
      )
      .nullish(),
    skills_deactivated: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    skills_upserted: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Meridian_Skill_ActivationsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Skill_ActivationsFilter
    >
  > = z.object({
    activated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Skill_ActivationsFilterSchema
        )
      )
      .nullish(),
    chat_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    deactivated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    invoked_by: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Meridian_Skill_ActivationsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Skill_ActivationsFilterSchema
        )
      )
      .nullish(),
    skill_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    surface: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Meridian_MessagesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_MessagesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_MessagesFilterSchema
        )
      )
      .nullish(),
    chat_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    message_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    model_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Meridian_MessagesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_MessagesFilterSchema
        )
      )
      .nullish(),
    provider: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    role: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    timestamp: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Meridian_ChatsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_ChatsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_ChatsFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    last_message_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Meridian_ChatsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_ChatsFilterSchema
        )
      )
      .nullish(),
    original_owner_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Meridian_Chat_SummariesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Chat_SummariesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Chat_SummariesFilterSchema
        )
      )
      .nullish(),
    chat_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    key_decisions: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    key_topics: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Meridian_Chat_SummariesFilterSchema.nullish()
    ),
    open_threads: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Chat_SummariesFilterSchema
        )
      )
      .nullish(),
    summarized_through_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    summary: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Marketing_BrandsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Marketing_BrandsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Marketing_BrandsFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    display_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    drive_root_folder_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Marketing_BrandsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Marketing_BrandsFilterSchema
        )
      )
      .nullish(),
    slack_channel_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    sort_order: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Mail_User_SettingsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Mail_User_SettingsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Mail_User_SettingsFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Mail_User_SettingsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Mail_User_SettingsFilterSchema
        )
      )
      .nullish(),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Ios_Metric_PayloadsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ios_Metric_PayloadsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Ios_Metric_PayloadsFilterSchema
        )
      )
      .nullish(),
    app_version: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    background_crash_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    background_memory_kill_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    background_task_timeout_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    background_watchdog_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    device_model: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    foreground_crash_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    foreground_memory_kill_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    foreground_watchdog_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    hang_time_p90_ms: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    install_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    kind: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    launch_time_p50_ms: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    launch_time_p90_ms: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    normal_exit_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Ios_Metric_PayloadsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Ios_Metric_PayloadsFilterSchema
        )
      )
      .nullish(),
    os_version: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    period_end: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    period_start: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Google_Drive_Access_GrantsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Google_Drive_Access_GrantsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Google_Drive_Access_GrantsFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    expires_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    granted_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    grantee_email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    grantor_email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Google_Drive_Access_GrantsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Google_Drive_Access_GrantsFilterSchema
        )
      )
      .nullish(),
    revoked_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    scope: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Gemini_Notes_SyncFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Gemini_Notes_SyncFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Gemini_Notes_SyncFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    doc_created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    doc_modified_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    doc_title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    doc_url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    file_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    matched_entity_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    matched_entity_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Gemini_Notes_SyncFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Gemini_Notes_SyncFilterSchema
        )
      )
      .nullish(),
    organizer_email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    posted_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    slack_canvas_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_canvas_url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_channel_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_ts: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Employee_Contact_AccessFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Employee_Contact_AccessFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Employee_Contact_AccessFilterSchema
        )
      )
      .nullish(),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    granted_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Employee_Contact_AccessFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Employee_Contact_AccessFilterSchema
        )
      )
      .nullish(),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Embedding_JobsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Embedding_JobsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Embedding_JobsFilterSchema
        )
      )
      .nullish(),
    attempts: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    enqueued_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    entity_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    entity_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    last_error: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Embedding_JobsFilterSchema.nullish()
    ),
    op: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Embedding_JobsFilterSchema
        )
      )
      .nullish(),
  });

export const // @ts-nocheck
  Email_UnsubscribesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_UnsubscribesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_UnsubscribesFilterSchema
        )
      )
      .nullish(),
    brand: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    campaign_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Email_UnsubscribesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_UnsubscribesFilterSchema
        )
      )
      .nullish(),
    unsubscribed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Email_Tracking_TokensFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Tracking_TokensFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Tracking_TokensFilterSchema
        )
      )
      .nullish(),
    communication_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    direction: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    external_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    first_ip: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    first_user_agent: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    last_opened_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Email_Tracking_TokensFilterSchema.nullish()
    ),
    open_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    opened_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Tracking_TokensFilterSchema
        )
      )
      .nullish(),
    provider: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    recipient_email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    sent_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    source: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    token: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Email_Tracking_Open_EventsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Tracking_Open_EventsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Tracking_Open_EventsFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    ip: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Email_Tracking_Open_EventsFilterSchema.nullish()
    ),
    occurred_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Tracking_Open_EventsFilterSchema
        )
      )
      .nullish(),
    token_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_agent: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Email_Template_SharesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_SharesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Template_SharesFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Email_Template_SharesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Template_SharesFilterSchema
        )
      )
      .nullish(),
    template_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Email_Template_FoldersFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_FoldersFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Template_FoldersFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Email_Template_FoldersFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Template_FoldersFilterSchema
        )
      )
      .nullish(),
    parent_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Email_Template_FilesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_FilesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Template_FilesFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    file_category: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    file_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    file_size: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    file_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Email_Template_FilesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Template_FilesFilterSchema
        )
      )
      .nullish(),
    storage_path: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    storage_url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    template_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Email_Template_FavoritesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Template_FavoritesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Template_FavoritesFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Email_Template_FavoritesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Template_FavoritesFilterSchema
        )
      )
      .nullish(),
    template_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Email_Forwarding_LogFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Forwarding_LogFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Forwarding_LogFilterSchema
        )
      )
      .nullish(),
    canvas_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    email_external_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    error: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Email_Forwarding_LogFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Forwarding_LogFilterSchema
        )
      )
      .nullish(),
    reviewed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    reviewed_by_slack_user_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    rule_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    sender_email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_channel_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_message_ts: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    subject: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Email_EventsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_EventsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_EventsFilterSchema
        )
      )
      .nullish(),
    campaign_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    ip: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Email_EventsFilterSchema.nullish()
    ),
    occurred_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_EventsFilterSchema
        )
      )
      .nullish(),
    recipient_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    user_agent: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Email_CampaignsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_CampaignsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_CampaignsFilterSchema
        )
      )
      .nullish(),
    audience_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    body_html: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    brand: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    from_email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    from_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Email_CampaignsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_CampaignsFilterSchema
        )
      )
      .nullish(),
    reply_to: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    scheduled_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    sent_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    subject: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    template_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Email_Campaign_RecipientsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_Campaign_RecipientsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Campaign_RecipientsFilterSchema
        )
      )
      .nullish(),
    campaign_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    clicked_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    error: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Email_Campaign_RecipientsFilterSchema.nullish()
    ),
    opened_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_Campaign_RecipientsFilterSchema
        )
      )
      .nullish(),
    sent_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    tracking_token: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Email_AudiencesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_AudiencesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_AudiencesFilterSchema
        )
      )
      .nullish(),
    brand: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    kind: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    member_emails: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Email_AudiencesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_AudiencesFilterSchema
        )
      )
      .nullish(),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Drive_User_RootsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Drive_User_RootsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Drive_User_RootsFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Drive_User_RootsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Drive_User_RootsFilterSchema
        )
      )
      .nullish(),
    root_folder_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    shared_drive_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Document_EmbeddingsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Document_EmbeddingsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Document_EmbeddingsFilterSchema
        )
      )
      .nullish(),
    content_hash: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    embedding: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    entity_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    entity_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    indexed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    model_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Document_EmbeddingsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Document_EmbeddingsFilterSchema
        )
      )
      .nullish(),
    source_updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Device_Push_TokensFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Device_Push_TokensFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Device_Push_TokensFilterSchema
        )
      )
      .nullish(),
    apns_token: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    app_version: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    environment: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    last_seen_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Device_Push_TokensFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Device_Push_TokensFilterSchema
        )
      )
      .nullish(),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Cron_Job_RunsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Cron_Job_RunsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Cron_Job_RunsFilterSchema
        )
      )
      .nullish(),
    completed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    duration_ms: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    error_summary: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    job_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Cron_Job_RunsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Cron_Job_RunsFilterSchema
        )
      )
      .nullish(),
    started_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Contract_PreviewsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contract_PreviewsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contract_PreviewsFilterSchema
        )
      )
      .nullish(),
    contract_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Contract_PreviewsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contract_PreviewsFilterSchema
        )
      )
      .nullish(),
    pdf_url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    secure_link_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Contact_TasksFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_TasksFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_TasksFilterSchema
        )
      )
      .nullish(),
    assigned_users: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    completed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    due_date: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    entity_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    entity_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Contact_TasksFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_TasksFilterSchema
        )
      )
      .nullish(),
    priority: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      Task_StatusFilterSchema.nullish()
    ),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Contact_MessagesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_MessagesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_MessagesFilterSchema
        )
      )
      .nullish(),
    body: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    delivered_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    direction: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    external_message_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    message_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Contact_MessagesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_MessagesFilterSchema
        )
      )
      .nullish(),
    read_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    sent_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    subject: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Contact_Merge_IgnoresFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_Merge_IgnoresFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_Merge_IgnoresFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    ignored_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Contact_Merge_IgnoresFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_Merge_IgnoresFilterSchema
        )
      )
      .nullish(),
    placeholder_contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    reason: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Contact_MeetingsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_MeetingsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_MeetingsFilterSchema
        )
      )
      .nullish(),
    attendees: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    end_time: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    location: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    meeting_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Contact_MeetingsFilterSchema.nullish()
    ),
    notes: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_MeetingsFilterSchema
        )
      )
      .nullish(),
    start_time: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      Meeting_StatusFilterSchema.nullish()
    ),
    title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Company_Slack_Channel_Link_IgnoresFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Company_Slack_Channel_Link_IgnoresFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Company_Slack_Channel_Link_IgnoresFilterSchema
        )
      )
      .nullish(),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    ignored_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Company_Slack_Channel_Link_IgnoresFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Company_Slack_Channel_Link_IgnoresFilterSchema
        )
      )
      .nullish(),
    reason: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  CommunicationsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      CommunicationsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            CommunicationsFilterSchema
        )
      )
      .nullish(),
    attachment_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    body: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    body_byte_size: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    body_content_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    body_preview: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    body_s3_key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    company_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    contact_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    direction: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    external_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    metadata_s3_key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      CommunicationsFilterSchema.nullish()
    ),
    occurred_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            CommunicationsFilterSchema
        )
      )
      .nullish(),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    type_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    type_label: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Calendar_CacheFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Calendar_CacheFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Calendar_CacheFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    end_time: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    event_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    last_synced: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Calendar_CacheFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Calendar_CacheFilterSchema
        )
      )
      .nullish(),
    provider: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    start_time: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Booking_HistoryFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Booking_HistoryFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Booking_HistoryFilterSchema
        )
      )
      .nullish(),
    bookee_email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    booker_email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    end_time: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    google_event_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    location: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    msft_event_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Booking_HistoryFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Booking_HistoryFilterSchema
        )
      )
      .nullish(),
    start_time: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    subject: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Audit_LogFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Audit_LogFilter
    >
  > = z.object({
    action: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Audit_LogFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    ip_address: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Audit_LogFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Audit_LogFilterSchema
        )
      )
      .nullish(),
    provider: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    user_agent: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  App_User_SkillsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      App_User_SkillsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            App_User_SkillsFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    grade: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      App_User_SkillsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            App_User_SkillsFilterSchema
        )
      )
      .nullish(),
    skill_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Address_Geocode_CacheFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Address_Geocode_CacheFilter
    >
  > = z.object({
    address_key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Address_Geocode_CacheFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    formatted_address: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    lat: z.lazy(() =>
      // @ts-nocheck
      FloatFilterSchema.nullish()
    ),
    lng: z.lazy(() =>
      // @ts-nocheck
      FloatFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Address_Geocode_CacheFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Address_Geocode_CacheFilterSchema
        )
      )
      .nullish(),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  DateListFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      DateListFilter
    >
  > = z.object({
    containedBy: z.array(z.string()).nullish(),
    contains: z.array(z.string()).nullish(),
    eq: z.array(z.string()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    overlaps: z.array(z.string()).nullish(),
  });

export const // @ts-nocheck
  DateFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      DateFilter
    >
  > = z.object({
    eq: z.string().nullish(),
    gt: z.string().nullish(),
    gte: z.string().nullish(),
    in: z.array(z.string()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    lt: z.string().nullish(),
    lte: z.string().nullish(),
    neq: z.string().nullish(),
  });

export const // @ts-nocheck
  Recurring_ChargesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Recurring_ChargesFilter
    >
  > = z.object({
    admin_email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Recurring_ChargesFilterSchema
        )
      )
      .nullish(),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    customer_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    last_charged_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    next_charge_date: z.lazy(() =>
      // @ts-nocheck
      DateFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Recurring_ChargesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Recurring_ChargesFilterSchema
        )
      )
      .nullish(),
    realm_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    schedule_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Plaid_StatementsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_StatementsFilter
    >
  > = z.object({
    account_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Plaid_StatementsFilterSchema
        )
      )
      .nullish(),
    content_hash: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    date_posted: z.lazy(() =>
      // @ts-nocheck
      DateFilterSchema.nullish()
    ),
    drive_file_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    drive_folder_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    drive_synced_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    drive_web_view_link: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    month: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Plaid_StatementsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Plaid_StatementsFilterSchema
        )
      )
      .nullish(),
    plaid_item_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    s3_key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    statement_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    year: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  ContractsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      ContractsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            ContractsFilterSchema
        )
      )
      .nullish(),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    deal_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    decline_reason: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    delivery_mode: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    document_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    esignatures_contract_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    expires_at: z.lazy(() =>
      // @ts-nocheck
      DateFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    last_event_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      ContractsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            ContractsFilterSchema
        )
      )
      .nullish(),
    recipient_email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    recipient_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    secure_link_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    sent_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    sent_by_user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    signed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    signed_pdf_url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    signing_url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    source: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    template_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    term_months: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  BooleanListFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      BooleanListFilter
    >
  > = z.object({
    containedBy: z.array(z.boolean()).nullish(),
    contains: z.array(z.boolean()).nullish(),
    eq: z.array(z.boolean()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    overlaps: z.array(z.boolean()).nullish(),
  });

export const // @ts-nocheck
  BooleanFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      BooleanFilter
    >
  > = z.object({
    eq: z.boolean().nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
  });

export const // @ts-nocheck
  User_Oauth_ConnectionsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      User_Oauth_ConnectionsFilter
    >
  > = z.object({
    access_token_enc: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    access_token_expires_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            User_Oauth_ConnectionsFilterSchema
        )
      )
      .nullish(),
    auth_user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    connection_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    end_user_display_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    end_user_email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    last_refresh_failure_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    last_refreshed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    never_expires: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      User_Oauth_ConnectionsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            User_Oauth_ConnectionsFilterSchema
        )
      )
      .nullish(),
    previous_refresh_token_enc: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    provider_config_key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    refresh_attempts: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    refresh_exhausted: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    refresh_token_enc: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    scopes: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Ticket_UpdatesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ticket_UpdatesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Ticket_UpdatesFilterSchema
        )
      )
      .nullish(),
    content: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_internal: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Ticket_UpdatesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Ticket_UpdatesFilterSchema
        )
      )
      .nullish(),
    ticket_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    update_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Task_NotesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Task_NotesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Task_NotesFilterSchema
        )
      )
      .nullish(),
    content: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_internal: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Task_NotesFilterSchema.nullish()
    ),
    note_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Task_NotesFilterSchema
        )
      )
      .nullish(),
    task_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Sales_SequencesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_SequencesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Sales_SequencesFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    deal_stage_trigger: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_active: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    is_default: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Sales_SequencesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Sales_SequencesFilterSchema
        )
      )
      .nullish(),
    region_hint: z.lazy(() =>
      // @ts-nocheck
      Sequence_Region_HintFilterSchema.nullish()
    ),
    target_type: z.lazy(() =>
      // @ts-nocheck
      Sequence_TargetFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Sales_Sequence_StepsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Sales_Sequence_StepsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Sales_Sequence_StepsFilterSchema
        )
      )
      .nullish(),
    channel: z.lazy(() =>
      // @ts-nocheck
      Sequence_ChannelFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    delay_business_days: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    guidance: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Sales_Sequence_StepsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Sales_Sequence_StepsFilterSchema
        )
      )
      .nullish(),
    pause_for_reply: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    sequence_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    step_number: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  RolesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      RolesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            RolesFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    display_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_active: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      RolesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            RolesFilterSchema
        )
      )
      .nullish(),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Quickbooks_Realm_LabelsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Quickbooks_Realm_LabelsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Quickbooks_Realm_LabelsFilterSchema
        )
      )
      .nullish(),
    category: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    is_active: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    label: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Quickbooks_Realm_LabelsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Quickbooks_Realm_LabelsFilterSchema
        )
      )
      .nullish(),
    realm_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_channel_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Project_Chat_SubscriptionsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Project_Chat_SubscriptionsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Project_Chat_SubscriptionsFilterSchema
        )
      )
      .nullish(),
    channel: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    deal_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    destination: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    display_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_active: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    last_notified_message_ts: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Project_Chat_SubscriptionsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Project_Chat_SubscriptionsFilterSchema
        )
      )
      .nullish(),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Post_Audit_Invoice_FeedbackFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_Invoice_FeedbackFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Post_Audit_Invoice_FeedbackFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    issue_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Post_Audit_Invoice_FeedbackFilterSchema.nullish()
    ),
    note: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Post_Audit_Invoice_FeedbackFilterSchema
        )
      )
      .nullish(),
    post_audit_document_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    post_audit_invoice_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    realm_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    resolved: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    slack_user_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    stage: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Plaid_Transaction_AttributionsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_Transaction_AttributionsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Plaid_Transaction_AttributionsFilterSchema
        )
      )
      .nullish(),
    attributed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    attributed_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    cost_category: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_net_cost: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Plaid_Transaction_AttributionsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Plaid_Transaction_AttributionsFilterSchema
        )
      )
      .nullish(),
    plaid_transaction_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    source: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Plaid_ItemsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_ItemsFilter
    >
  > = z.object({
    access_token_encrypted: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Plaid_ItemsFilterSchema
        )
      )
      .nullish(),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    connected_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    institution_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    item_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    label: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Plaid_ItemsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Plaid_ItemsFilterSchema
        )
      )
      .nullish(),
    statements_drive_folder_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    statements_enabled: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    statements_last_error: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    statements_last_synced_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    transactions_cursor: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Notification_PreferencesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Notification_PreferencesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Notification_PreferencesFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    email_address: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    email_enabled: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    enabled: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    event_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Notification_PreferencesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Notification_PreferencesFilterSchema
        )
      )
      .nullish(),
    phone_number: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    push_enabled: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    slack_channel_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_enabled: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    slack_user_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    sms_enabled: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Msp_DocumentsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Msp_DocumentsFilter
    >
  > = z.object({
    access_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Msp_DocumentsFilterSchema
        )
      )
      .nullish(),
    category: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    client_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    content: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    difficulty: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    estimated_read_time: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    excerpt: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_active: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    is_featured: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    is_internal: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    last_accessed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Msp_DocumentsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Msp_DocumentsFilterSchema
        )
      )
      .nullish(),
    shared_with_users: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    updated_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Meridian_Tool_IoFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_IoFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Tool_IoFilterSchema
        )
      )
      .nullish(),
    cache_hit: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    chat_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    duration_ms: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    error_code: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    error_kind: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    ids_requested: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    input_bytes: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    is_error: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Meridian_Tool_IoFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Tool_IoFilterSchema
        )
      )
      .nullish(),
    output_bytes: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    output_items: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    result_truncated: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    sections_returned: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    surface: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    tool_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    turn_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    turn_index: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Meridian_SkillsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_SkillsFilter
    >
  > = z.object({
    allowed_tools: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_SkillsFilterSchema
        )
      )
      .nullish(),
    argument_hint: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    availability: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    body_chars: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    body_s3_key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    catalog_generated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    category: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    content_sha256: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    disable_model_invocation: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    hitl_required: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    how_to_get: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    is_active: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Meridian_SkillsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_SkillsFilterSchema
        )
      )
      .nullish(),
    path: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    plugin: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    plugin_version: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    required_capabilities: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    runtimes: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    synced_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Mcp_Server_ConnectionsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Mcp_Server_ConnectionsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Mcp_Server_ConnectionsFilterSchema
        )
      )
      .nullish(),
    auth_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    enabled: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    header_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    last_connected_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    last_error: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Mcp_Server_ConnectionsFilterSchema.nullish()
    ),
    oauth_access_token_encrypted: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    oauth_authorization_server: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    oauth_client_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    oauth_pkce_verifier_encrypted: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    oauth_redirect_uri: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    oauth_refresh_token_encrypted: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    oauth_scope: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    oauth_state: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    oauth_token_expires_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Mcp_Server_ConnectionsFilterSchema
        )
      )
      .nullish(),
    secret_encrypted: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    server_url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    tool_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    transport: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Inbound_Sender_RulesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Inbound_Sender_RulesFilter
    >
  > = z.object({
    active: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Inbound_Sender_RulesFilterSchema
        )
      )
      .nullish(),
    auto_assign_to: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    company_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    default_priority: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    domain: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    match_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Inbound_Sender_RulesFilterSchema.nullish()
    ),
    notes: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Inbound_Sender_RulesFilterSchema
        )
      )
      .nullish(),
    sla_hours: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    subject_pattern: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Google_Group_EnrollmentsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Google_Group_EnrollmentsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Google_Group_EnrollmentsFilterSchema
        )
      )
      .nullish(),
    auto_provision_opt_out: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    enabled: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    group_email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Google_Group_EnrollmentsFilterSchema.nullish()
    ),
    notes: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Google_Group_EnrollmentsFilterSchema
        )
      )
      .nullish(),
    slack_channel_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Generic_Email_DomainsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Generic_Email_DomainsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Generic_Email_DomainsFilterSchema
        )
      )
      .nullish(),
    blocked_as_company_domain: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    domain: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Generic_Email_DomainsFilterSchema.nullish()
    ),
    note: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Generic_Email_DomainsFilterSchema
        )
      )
      .nullish(),
  });

export const // @ts-nocheck
  Entity_Automation_ConfigFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Entity_Automation_ConfigFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Entity_Automation_ConfigFilterSchema
        )
      )
      .nullish(),
    assigned_user_ids: z.lazy(() =>
      // @ts-nocheck
      UuidListFilterSchema.nullish()
    ),
    automation_kind: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    day_of_week: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    enabled: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    entity_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    entity_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    frequency: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    goal_last_evaluated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    goal_last_posted_date: z.lazy(() =>
      // @ts-nocheck
      DateFilterSchema.nullish()
    ),
    goal_last_status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Entity_Automation_ConfigFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Entity_Automation_ConfigFilterSchema
        )
      )
      .nullish(),
    priority: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    run_on_business_days_only: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    selected_days_of_week: z.lazy(() =>
      // @ts-nocheck
      IntListFilterSchema.nullish()
    ),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    task_description_template: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    task_title_fixed: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    task_title_template: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    use_title_template: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Email_TemplatesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_TemplatesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_TemplatesFilterSchema
        )
      )
      .nullish(),
    body: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    folder_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_shared: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Email_TemplatesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_TemplatesFilterSchema
        )
      )
      .nullish(),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    subject: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Email_SignaturesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Email_SignaturesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_SignaturesFilterSchema
        )
      )
      .nullish(),
    connection_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    content: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_default: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Email_SignaturesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Email_SignaturesFilterSchema
        )
      )
      .nullish(),
    owner_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    provider_config_key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Drive_NodesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Drive_NodesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Drive_NodesFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    drive_file_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_root: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    kind: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    mime_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Drive_NodesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Drive_NodesFilterSchema
        )
      )
      .nullish(),
    parent_drive_file_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Customer_FeedbackFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Customer_FeedbackFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Customer_FeedbackFilterSchema
        )
      )
      .nullish(),
    comment: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    entity_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    entity_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    feedback_scope: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_anonymous: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Customer_FeedbackFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Customer_FeedbackFilterSchema
        )
      )
      .nullish(),
    rating: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    secure_link_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    slack_message_ts: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    source: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    ticket_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  ContactsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      ContactsFilter
    >
  > = z.object({
    accessible_by_user_ids: z.lazy(() =>
      // @ts-nocheck
      UuidListFilterSchema.nullish()
    ),
    active_deal_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    address: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            ContactsFilterSchema
        )
      )
      .nullish(),
    avatar_url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    city: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    company_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    contract_expires_at: z.lazy(() =>
      // @ts-nocheck
      DateFilterSchema.nullish()
    ),
    country: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_by_backfilled_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    email_aliases: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    has_active_deals: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    has_signed_contract: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_active: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    is_company_line: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    last_contacted_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    last_enriched_at: z.lazy(() =>
      // @ts-nocheck
      DateFilterSchema.nullish()
    ),
    last_follow_up_task_created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    lifecycle_stage: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      ContactsFilterSchema.nullish()
    ),
    notes: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            ContactsFilterSchema
        )
      )
      .nullish(),
    phone: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    phone_aliases: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    source: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    state: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      Contact_StatusFilterSchema.nullish()
    ),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    trigger_enrichment: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    updated_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    zip_code: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Contact_User_AccessFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_User_AccessFilter
    >
  > = z.object({
    access_level: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_User_AccessFilterSchema
        )
      )
      .nullish(),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    expires_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    granted_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    granted_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_active: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Contact_User_AccessFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_User_AccessFilterSchema
        )
      )
      .nullish(),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Contact_NotesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_NotesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_NotesFilterSchema
        )
      )
      .nullish(),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    content: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_internal: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Contact_NotesFilterSchema.nullish()
    ),
    note_type: z.lazy(() =>
      // @ts-nocheck
      Note_TypeFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_NotesFilterSchema
        )
      )
      .nullish(),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Contact_Method_ClaimsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_Method_ClaimsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_Method_ClaimsFilterSchema
        )
      )
      .nullish(),
    claimed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    is_legacy_conflict: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    is_primary: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    kind: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Contact_Method_ClaimsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_Method_ClaimsFilterSchema
        )
      )
      .nullish(),
    owner_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    owner_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    source_column: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    value_key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    value_raw: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Connection_SharesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Connection_SharesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Connection_SharesFilterSchema
        )
      )
      .nullish(),
    connection_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    drive_access_enabled: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Connection_SharesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Connection_SharesFilterSchema
        )
      )
      .nullish(),
    owner_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    provider_config_key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    shared_with_user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Company_User_AccessFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Company_User_AccessFilter
    >
  > = z.object({
    access_level: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Company_User_AccessFilterSchema
        )
      )
      .nullish(),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    expires_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    granted_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    granted_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_active: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Company_User_AccessFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Company_User_AccessFilterSchema
        )
      )
      .nullish(),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Company_Quickbooks_CustomersFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Company_Quickbooks_CustomersFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Company_Quickbooks_CustomersFilterSchema
        )
      )
      .nullish(),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    customer_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    customer_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    is_legacy_conflict: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    is_secondary: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    linked_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    linked_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Company_Quickbooks_CustomersFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Company_Quickbooks_CustomersFilterSchema
        )
      )
      .nullish(),
    realm_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Communication_TypesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Communication_TypesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Communication_TypesFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_active: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    label: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Communication_TypesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Communication_TypesFilterSchema
        )
      )
      .nullish(),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Automation_RulesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Automation_RulesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Automation_RulesFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_active: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Automation_RulesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Automation_RulesFilterSchema
        )
      )
      .nullish(),
    priority: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  BigIntListFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      BigIntListFilter
    >
  > = z.object({
    containedBy: z.array(z.string()).nullish(),
    contains: z.array(z.string()).nullish(),
    eq: z.array(z.string()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    overlaps: z.array(z.string()).nullish(),
  });

export const // @ts-nocheck
  BigIntFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      BigIntFilter
    >
  > = z.object({
    eq: z.string().nullish(),
    gt: z.string().nullish(),
    gte: z.string().nullish(),
    in: z.array(z.string()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    lt: z.string().nullish(),
    lte: z.string().nullish(),
    neq: z.string().nullish(),
  });

export const // @ts-nocheck
  Ticket_AttachmentsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ticket_AttachmentsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Ticket_AttachmentsFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    file_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    file_path: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    file_size: z.lazy(() =>
      // @ts-nocheck
      BigIntFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    mime_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Ticket_AttachmentsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Ticket_AttachmentsFilterSchema
        )
      )
      .nullish(),
    ticket_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Queue_Event_LogFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Queue_Event_LogFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Queue_Event_LogFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    disposition: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    duration_ms: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    error: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    event_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      BigIntFilterSchema.nullish()
    ),
    message_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Queue_Event_LogFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Queue_Event_LogFilterSchema
        )
      )
      .nullish(),
    queue_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    receive_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    version: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Meridian_Tool_ApprovalsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Tool_ApprovalsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Tool_ApprovalsFilterSchema
        )
      )
      .nullish(),
    chat_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    execution_claim_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    execution_claimed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    execution_completed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    execution_succeeded: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    expires_at: z.lazy(() =>
      // @ts-nocheck
      BigIntFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Meridian_Tool_ApprovalsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Tool_ApprovalsFilterSchema
        )
      )
      .nullish(),
    requested_at: z.lazy(() =>
      // @ts-nocheck
      BigIntFilterSchema.nullish()
    ),
    responded_at: z.lazy(() =>
      // @ts-nocheck
      BigIntFilterSchema.nullish()
    ),
    responded_by: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_channel: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_message_ts: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_thread_ts: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_user_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    tool_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Crm_Remediation_BackupFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Crm_Remediation_BackupFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Crm_Remediation_BackupFilterSchema
        )
      )
      .nullish(),
    batch: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    column_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    entity_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    entity_table: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      BigIntFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Crm_Remediation_BackupFilterSchema.nullish()
    ),
    note: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Crm_Remediation_BackupFilterSchema
        )
      )
      .nullish(),
    ran_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Contact_FilesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_FilesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_FilesFilterSchema
        )
      )
      .nullish(),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Contact_FilesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_FilesFilterSchema
        )
      )
      .nullish(),
    size: z.lazy(() =>
      // @ts-nocheck
      BigIntFilterSchema.nullish()
    ),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    uploaded_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Time_EntriesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Time_EntriesUpdateInput
    >
  > = z.object({
    approved_at: z.string().nullish(),
    approved_by: z.string().nullish(),
    billable_rate: z.number().nullish(),
    company_id: z.string().nullish(),
    company_name: z.string().nullish(),
    contact_name: z.string().nullish(),
    created_at: z.string().nullish(),
    date_worked: z.string().nullish(),
    description: z.string().nullish(),
    end_time: z.string().nullish(),
    // @ts-nocheck
    entry_type: Time_Entry_TypeSchema.nullish(),
    hours: z.number().nullish(),
    id: z.string().nullish(),
    is_approved: z.boolean().nullish(),
    is_software: z.boolean().nullish(),
    last_follow_up_task_created_at: z.string().nullish(),
    quickbooks_customer_ref: z.string().nullish(),
    quickbooks_employee_ref: z.string().nullish(),
    quickbooks_id: z.string().nullish(),
    search_vector: z.any().nullish(),
    start_time: z.string().nullish(),
    // @ts-nocheck
    sync_status: Sync_StatusSchema.nullish(),
    synced_at: z.string().nullish(),
    ticket_id: z.string().nullish(),
    ticket_number: z.number().nullish(),
    ticket_title: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
    user_name: z.string().nullish(),
  });

export const // @ts-nocheck
  Time_EntriesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Time_EntriesInsertInput
    >
  > = z.object({
    approved_at: z.string().nullish(),
    approved_by: z.string().nullish(),
    billable_rate: z.number().nullish(),
    company_id: z.string().nullish(),
    company_name: z.string().nullish(),
    contact_name: z.string().nullish(),
    created_at: z.string().nullish(),
    date_worked: z.string().nullish(),
    description: z.string().nullish(),
    end_time: z.string().nullish(),
    // @ts-nocheck
    entry_type: Time_Entry_TypeSchema.nullish(),
    hours: z.number().nullish(),
    id: z.string().nullish(),
    is_approved: z.boolean().nullish(),
    is_software: z.boolean().nullish(),
    last_follow_up_task_created_at: z.string().nullish(),
    quickbooks_customer_ref: z.string().nullish(),
    quickbooks_employee_ref: z.string().nullish(),
    quickbooks_id: z.string().nullish(),
    search_vector: z.any().nullish(),
    start_time: z.string().nullish(),
    // @ts-nocheck
    sync_status: Sync_StatusSchema.nullish(),
    synced_at: z.string().nullish(),
    ticket_id: z.string().nullish(),
    ticket_number: z.number().nullish(),
    ticket_title: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
    user_name: z.string().nullish(),
  });

export const // @ts-nocheck
  TicketsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      TicketsUpdateInput
    >
  > = z.object({
    actual_hours: z.number().nullish(),
    assigned_to: z.string().nullish(),
    auto_assign: z.boolean().nullish(),
    auto_escalate: z.boolean().nullish(),
    billable_hours: z.number().nullish(),
    // @ts-nocheck
    category: Ticket_CategorySchema.nullish(),
    closed_at: z.string().nullish(),
    company_id: z.string().nullish(),
    company_name: z.string().nullish(),
    contact_id: z.string().nullish(),
    contact_name: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    customer_visible_notes: z.string().nullish(),
    description: z.string().nullish(),
    description_byte_size: z.number().nullish(),
    description_content_type: z.string().nullish(),
    description_preview: z.string().nullish(),
    description_s3_key: z.string().nullish(),
    discount_amount: z.number().nullish(),
    discount_percentage: z.number().nullish(),
    // @ts-nocheck
    discount_type: Discount_TypeSchema.nullish(),
    due_date: z.string().nullish(),
    escalation_level: z.number().nullish(),
    estimated_hours: z.number().nullish(),
    has_time_entries: z.boolean().nullish(),
    hourly_rate: z.number().nullish(),
    id: z.string().nullish(),
    internal_notes: z.string().nullish(),
    is_internal: z.boolean().nullish(),
    is_software: z.boolean().nullish(),
    last_activity_at: z.string().nullish(),
    last_escalation_at: z.string().nullish(),
    last_follow_up_task_created_at: z.string().nullish(),
    non_billable_hours: z.number().nullish(),
    // @ts-nocheck
    priority: Ticket_PrioritySchema.nullish(),
    reminder_sent: z.boolean().nullish(),
    reminder_sent_at: z.string().nullish(),
    resolved_at: z.string().nullish(),
    search_vector: z.any().nullish(),
    sla_hours: z.number().nullish(),
    // @ts-nocheck
    status: Ticket_StatusSchema.nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    ticket_number: z.number().nullish(),
    title: z.string().nullish(),
    total_billed: z.number().nullish(),
    total_cost: z.number().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  TicketsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      TicketsInsertInput
    >
  > = z.object({
    actual_hours: z.number().nullish(),
    assigned_to: z.string().nullish(),
    auto_assign: z.boolean().nullish(),
    auto_escalate: z.boolean().nullish(),
    billable_hours: z.number().nullish(),
    // @ts-nocheck
    category: Ticket_CategorySchema.nullish(),
    closed_at: z.string().nullish(),
    company_id: z.string().nullish(),
    company_name: z.string().nullish(),
    contact_id: z.string().nullish(),
    contact_name: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    customer_visible_notes: z.string().nullish(),
    description: z.string().nullish(),
    description_byte_size: z.number().nullish(),
    description_content_type: z.string().nullish(),
    description_preview: z.string().nullish(),
    description_s3_key: z.string().nullish(),
    discount_amount: z.number().nullish(),
    discount_percentage: z.number().nullish(),
    // @ts-nocheck
    discount_type: Discount_TypeSchema.nullish(),
    due_date: z.string().nullish(),
    escalation_level: z.number().nullish(),
    estimated_hours: z.number().nullish(),
    has_time_entries: z.boolean().nullish(),
    hourly_rate: z.number().nullish(),
    id: z.string().nullish(),
    internal_notes: z.string().nullish(),
    is_internal: z.boolean().nullish(),
    is_software: z.boolean().nullish(),
    last_activity_at: z.string().nullish(),
    last_escalation_at: z.string().nullish(),
    last_follow_up_task_created_at: z.string().nullish(),
    non_billable_hours: z.number().nullish(),
    // @ts-nocheck
    priority: Ticket_PrioritySchema.nullish(),
    reminder_sent: z.boolean().nullish(),
    reminder_sent_at: z.string().nullish(),
    resolved_at: z.string().nullish(),
    search_vector: z.any().nullish(),
    sla_hours: z.number().nullish(),
    // @ts-nocheck
    status: Ticket_StatusSchema.nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    ticket_number: z.number().nullish(),
    title: z.string().nullish(),
    total_billed: z.number().nullish(),
    total_cost: z.number().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Ticket_TemplatesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ticket_TemplatesUpdateInput
    >
  > = z.object({
    // @ts-nocheck
    category: Ticket_CategorySchema.nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    description: z.string().nullish(),
    description_template: z.string().nullish(),
    estimated_hours: z.number().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    name: z.string().nullish(),
    sla_hours: z.number().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    title_template: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Ticket_TemplatesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ticket_TemplatesInsertInput
    >
  > = z.object({
    // @ts-nocheck
    category: Ticket_CategorySchema.nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    description: z.string().nullish(),
    description_template: z.string().nullish(),
    estimated_hours: z.number().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    name: z.string().nullish(),
    sla_hours: z.number().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    title_template: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Revenue_TargetsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Revenue_TargetsUpdateInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    currency: z.string().nullish(),
    id: z.string().nullish(),
    period_end: z.string().nullish(),
    period_start: z.string().nullish(),
    target_amount: z.number().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Revenue_TargetsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Revenue_TargetsInsertInput
    >
  > = z.object({
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    currency: z.string().nullish(),
    id: z.string().nullish(),
    period_end: z.string().nullish(),
    period_start: z.string().nullish(),
    target_amount: z.number().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Recurring_TransactionsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Recurring_TransactionsUpdateInput
    >
  > = z.object({
    amount: z.number().nullish(),
    company_id: z.string().nullish(),
    company_name: z.string().nullish(),
    contact_name: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    customer_id: z.string().nullish(),
    description: z.string().nullish(),
    id: z.string().nullish(),
    item: z.string().nullish(),
    last_error: z.string().nullish(),
    last_error_at: z.string().nullish(),
    last_synced_at: z.string().nullish(),
    last_synced_month: z.string().nullish(),
    next_retry_at: z.string().nullish(),
    quantity: z.number().nullish(),
    quickbooks_id: z.string().nullish(),
    quickbooks_realm_id: z.string().nullish(),
    retry_count: z.number().nullish(),
    search_vector: z.any().nullish(),
    sync_status: z.string().nullish(),
    updated_at: z.string().nullish(),
    updated_by: z.string().nullish(),
  });

export const // @ts-nocheck
  Recurring_TransactionsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Recurring_TransactionsInsertInput
    >
  > = z.object({
    amount: z.number().nullish(),
    company_id: z.string().nullish(),
    company_name: z.string().nullish(),
    contact_name: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    customer_id: z.string().nullish(),
    description: z.string().nullish(),
    id: z.string().nullish(),
    item: z.string().nullish(),
    last_error: z.string().nullish(),
    last_error_at: z.string().nullish(),
    last_synced_at: z.string().nullish(),
    last_synced_month: z.string().nullish(),
    next_retry_at: z.string().nullish(),
    quantity: z.number().nullish(),
    quickbooks_id: z.string().nullish(),
    quickbooks_realm_id: z.string().nullish(),
    retry_count: z.number().nullish(),
    search_vector: z.any().nullish(),
    sync_status: z.string().nullish(),
    updated_at: z.string().nullish(),
    updated_by: z.string().nullish(),
  });

export const // @ts-nocheck
  Post_Audit_InvoicesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_InvoicesUpdateInput
    >
  > = z.object({
    amount_source: z.string().nullish(),
    approved_at: z.string().nullish(),
    approved_by_slack_user_id: z.string().nullish(),
    audit_month: z.string().nullish(),
    category: z.string().nullish(),
    created_at: z.string().nullish(),
    environment: z.string().nullish(),
    final_amount: z.number().nullish(),
    ho_reference: z.string().nullish(),
    id: z.string().nullish(),
    line_description: z.string().nullish(),
    post_audit_document_id: z.string().nullish(),
    post_audit_number: z.string().nullish(),
    proposed_amount: z.number().nullish(),
    qb_customer_name: z.string().nullish(),
    qb_customer_ref: z.string().nullish(),
    qb_invoice_doc_number: z.string().nullish(),
    qb_invoice_id: z.string().nullish(),
    qb_item_name: z.string().nullish(),
    qb_item_ref: z.string().nullish(),
    qb_sync_token: z.string().nullish(),
    realm_id: z.string().nullish(),
    savings_figure: z.number().nullish(),
    searched_company_name: z.string().nullish(),
    send_method: z.string().nullish(),
    sent_at: z.string().nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Post_Audit_InvoicesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_InvoicesInsertInput
    >
  > = z.object({
    amount_source: z.string().nullish(),
    approved_at: z.string().nullish(),
    approved_by_slack_user_id: z.string().nullish(),
    audit_month: z.string().nullish(),
    category: z.string().nullish(),
    created_at: z.string().nullish(),
    environment: z.string().nullish(),
    final_amount: z.number().nullish(),
    ho_reference: z.string().nullish(),
    id: z.string().nullish(),
    line_description: z.string().nullish(),
    post_audit_document_id: z.string().nullish(),
    post_audit_number: z.string().nullish(),
    proposed_amount: z.number().nullish(),
    qb_customer_name: z.string().nullish(),
    qb_customer_ref: z.string().nullish(),
    qb_invoice_doc_number: z.string().nullish(),
    qb_invoice_id: z.string().nullish(),
    qb_item_name: z.string().nullish(),
    qb_item_ref: z.string().nullish(),
    qb_sync_token: z.string().nullish(),
    realm_id: z.string().nullish(),
    savings_figure: z.number().nullish(),
    searched_company_name: z.string().nullish(),
    send_method: z.string().nullish(),
    sent_at: z.string().nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Plaid_TransactionsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_TransactionsUpdateInput
    >
  > = z.object({
    account_id: z.string().nullish(),
    amount: z.number().nullish(),
    counterparties: z.record(z.string(), z.any()).nullish(),
    counterparty_entity_id: z.string().nullish(),
    counterparty_name: z.string().nullish(),
    created_at: z.string().nullish(),
    date: z.string().nullish(),
    id: z.string().nullish(),
    iso_currency_code: z.string().nullish(),
    merchant_key: z.string().nullish(),
    merchant_name: z.string().nullish(),
    name: z.string().nullish(),
    pending: z.boolean().nullish(),
    pfc_confidence: z.string().nullish(),
    pfc_detailed: z.string().nullish(),
    pfc_primary: z.string().nullish(),
    plaid_transaction_id: z.string().nullish(),
    raw_s3_key: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Plaid_TransactionsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_TransactionsInsertInput
    >
  > = z.object({
    account_id: z.string().nullish(),
    amount: z.number().nullish(),
    counterparties: z.record(z.string(), z.any()).nullish(),
    counterparty_entity_id: z.string().nullish(),
    counterparty_name: z.string().nullish(),
    created_at: z.string().nullish(),
    date: z.string().nullish(),
    id: z.string().nullish(),
    iso_currency_code: z.string().nullish(),
    merchant_key: z.string().nullish(),
    merchant_name: z.string().nullish(),
    name: z.string().nullish(),
    pending: z.boolean().nullish(),
    pfc_confidence: z.string().nullish(),
    pfc_detailed: z.string().nullish(),
    pfc_primary: z.string().nullish(),
    plaid_transaction_id: z.string().nullish(),
    raw_s3_key: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Plaid_AccountsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_AccountsUpdateInput
    >
  > = z.object({
    account_id: z.string().nullish(),
    available_balance: z.number().nullish(),
    balance_updated_at: z.string().nullish(),
    created_at: z.string().nullish(),
    current_balance: z.number().nullish(),
    description: z.string().nullish(),
    enabled: z.boolean().nullish(),
    id: z.string().nullish(),
    iso_currency_code: z.string().nullish(),
    label: z.string().nullish(),
    mask: z.string().nullish(),
    name: z.string().nullish(),
    plaid_item_id: z.string().nullish(),
    spend_profile: z.string().nullish(),
    spend_profile_set_at: z.string().nullish(),
    spend_profile_set_by: z.string().nullish(),
    spend_profile_source: z.string().nullish(),
    statements_drive_folder_id: z.string().nullish(),
    subtype: z.string().nullish(),
    type: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Plaid_AccountsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_AccountsInsertInput
    >
  > = z.object({
    account_id: z.string().nullish(),
    available_balance: z.number().nullish(),
    balance_updated_at: z.string().nullish(),
    created_at: z.string().nullish(),
    current_balance: z.number().nullish(),
    description: z.string().nullish(),
    enabled: z.boolean().nullish(),
    id: z.string().nullish(),
    iso_currency_code: z.string().nullish(),
    label: z.string().nullish(),
    mask: z.string().nullish(),
    name: z.string().nullish(),
    plaid_item_id: z.string().nullish(),
    spend_profile: z.string().nullish(),
    spend_profile_set_at: z.string().nullish(),
    spend_profile_set_by: z.string().nullish(),
    spend_profile_source: z.string().nullish(),
    statements_drive_folder_id: z.string().nullish(),
    subtype: z.string().nullish(),
    type: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  OfferingsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      OfferingsUpdateInput
    >
  > = z.object({
    base_price: z.number().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    cta_href: z.string().nullish(),
    cta_text: z.string().nullish(),
    delivery_kit: z.string().nullish(),
    description: z.string().nullish(),
    executive_summary: z.string().nullish(),
    hard_cost_line_items: z.record(z.string(), z.any()).nullish(),
    id: z.string().nullish(),
    image_url: z.string().nullish(),
    linked_project_slug: z.string().nullish(),
    one_pager_pdf_url: z.string().nullish(),
    pricing_display: z.string().nullish(),
    pricing_model: z.string().nullish(),
    search_vector: z.any().nullish(),
    staff_line_items: z.record(z.string(), z.any()).nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    title: z.string().nullish(),
    total_cost: z.number().nullish(),
    total_hard_costs: z.number().nullish(),
    total_hours: z.number().nullish(),
    updated_at: z.string().nullish(),
    website_id: z.string().nullish(),
  });

export const // @ts-nocheck
  OfferingsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      OfferingsInsertInput
    >
  > = z.object({
    base_price: z.number().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    cta_href: z.string().nullish(),
    cta_text: z.string().nullish(),
    delivery_kit: z.string().nullish(),
    description: z.string().nullish(),
    executive_summary: z.string().nullish(),
    hard_cost_line_items: z.record(z.string(), z.any()).nullish(),
    id: z.string().nullish(),
    image_url: z.string().nullish(),
    linked_project_slug: z.string().nullish(),
    one_pager_pdf_url: z.string().nullish(),
    pricing_display: z.string().nullish(),
    pricing_model: z.string().nullish(),
    search_vector: z.any().nullish(),
    staff_line_items: z.record(z.string(), z.any()).nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    title: z.string().nullish(),
    total_cost: z.number().nullish(),
    total_hard_costs: z.number().nullish(),
    total_hours: z.number().nullish(),
    updated_at: z.string().nullish(),
    website_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Mrr_SnapshotsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Mrr_SnapshotsUpdateInput
    >
  > = z.object({
    account_id: z.string().nullish(),
    amount: z.number().nullish(),
    company_id: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    month: z.string().nullish(),
    source: z.string().nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Mrr_SnapshotsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Mrr_SnapshotsInsertInput
    >
  > = z.object({
    account_id: z.string().nullish(),
    amount: z.number().nullish(),
    company_id: z.string().nullish(),
    created_at: z.string().nullish(),
    id: z.string().nullish(),
    month: z.string().nullish(),
    source: z.string().nullish(),
    status: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Usage_EventsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Usage_EventsUpdateInput
    >
  > = z.object({
    cache_creation_input_tokens: z.number().nullish(),
    cache_read_cost_usd: z.number().nullish(),
    cache_read_input_tokens: z.number().nullish(),
    cache_write_cost_usd: z.number().nullish(),
    canonical_model_id: z.string().nullish(),
    chat_id: z.string().nullish(),
    created_at: z.string().nullish(),
    duration_ms: z.number().nullish(),
    feature: z.string().nullish(),
    finish_reason: z.string().nullish(),
    id: z.string().nullish(),
    input_cost_usd: z.number().nullish(),
    input_tokens: z.number().nullish(),
    model_id: z.string().nullish(),
    output_cost_usd: z.number().nullish(),
    output_tokens: z.number().nullish(),
    pricing_unknown: z.boolean().nullish(),
    provider: z.string().nullish(),
    step_index: z.number().nullish(),
    surface: z.string().nullish(),
    tools: z.record(z.string(), z.any()).nullish(),
    total_cost_usd: z.number().nullish(),
    total_tokens: z.number().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Meridian_Usage_EventsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Usage_EventsInsertInput
    >
  > = z.object({
    cache_creation_input_tokens: z.number().nullish(),
    cache_read_cost_usd: z.number().nullish(),
    cache_read_input_tokens: z.number().nullish(),
    cache_write_cost_usd: z.number().nullish(),
    canonical_model_id: z.string().nullish(),
    chat_id: z.string().nullish(),
    created_at: z.string().nullish(),
    duration_ms: z.number().nullish(),
    feature: z.string().nullish(),
    finish_reason: z.string().nullish(),
    id: z.string().nullish(),
    input_cost_usd: z.number().nullish(),
    input_tokens: z.number().nullish(),
    model_id: z.string().nullish(),
    output_cost_usd: z.number().nullish(),
    output_tokens: z.number().nullish(),
    pricing_unknown: z.boolean().nullish(),
    provider: z.string().nullish(),
    step_index: z.number().nullish(),
    surface: z.string().nullish(),
    tools: z.record(z.string(), z.any()).nullish(),
    total_cost_usd: z.number().nullish(),
    total_tokens: z.number().nullish(),
    user_id: z.string().nullish(),
  });

export const // @ts-nocheck
  Invoice_Dunning_LogUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Invoice_Dunning_LogUpdateInput
    >
  > = z.object({
    action: z.string().nullish(),
    amount: z.number().nullish(),
    channel: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    customer_id: z.string().nullish(),
    customer_name: z.string().nullish(),
    cycle: z.number().nullish(),
    days_overdue: z.number().nullish(),
    doc_number: z.string().nullish(),
    id: z.string().nullish(),
    invoice_id: z.string().nullish(),
    metadata: z.record(z.string(), z.any()).nullish(),
    realm_id: z.string().nullish(),
    stage: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Invoice_Dunning_LogInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Invoice_Dunning_LogInsertInput
    >
  > = z.object({
    action: z.string().nullish(),
    amount: z.number().nullish(),
    channel: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    customer_id: z.string().nullish(),
    customer_name: z.string().nullish(),
    cycle: z.number().nullish(),
    days_overdue: z.number().nullish(),
    doc_number: z.string().nullish(),
    id: z.string().nullish(),
    invoice_id: z.string().nullish(),
    metadata: z.record(z.string(), z.any()).nullish(),
    realm_id: z.string().nullish(),
    stage: z.string().nullish(),
    updated_at: z.string().nullish(),
  });

export const // @ts-nocheck
  DealsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      DealsUpdateInput
    >
  > = z.object({
    // @ts-nocheck
    alignment_status: Project_Health_StatusSchema.nullish(),
    assigned_users: z.array(z.string().nullable()).nullish(),
    // @ts-nocheck
    budget_status: Project_Health_StatusSchema.nullish(),
    chat_link_created_at: z.string().nullish(),
    chat_link_public_id: z.string().nullish(),
    chat_link_secret_encrypted: z.string().nullish(),
    close_date: z.string().nullish(),
    close_probability: z.number().nullish(),
    company_id: z.string().nullish(),
    company_name: z.string().nullish(),
    company_search_text: z.string().nullish(),
    contact_search_text: z.string().nullish(),
    contract_term_months: z.number().nullish(),
    cost: z.number().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    currency: z.string().nullish(),
    description: z.string().nullish(),
    engineer_ids: z.array(z.string().nullable()).nullish(),
    estimated_hours: z.number().nullish(),
    id: z.string().nullish(),
    is_committed: z.boolean().nullish(),
    is_recurring: z.boolean().nullish(),
    last_activity_at: z.string().nullish(),
    last_communication_at: z.string().nullish(),
    last_follow_up_task_created_at: z.string().nullish(),
    lost_at: z.string().nullish(),
    margin_percentage: z.number().nullish(),
    monthly_amount: z.number().nullish(),
    notes: z.string().nullish(),
    revenue: z.number().nullish(),
    // @ts-nocheck
    schedule_status: Project_Health_StatusSchema.nullish(),
    // @ts-nocheck
    scope_status: Project_Health_StatusSchema.nullish(),
    search_vector: z.any().nullish(),
    slack_channel_id: z.string().nullish(),
    slack_chat_thread_ts: z.string().nullish(),
    // @ts-nocheck
    stage: Deal_StageSchema.nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    won_at: z.string().nullish(),
  });

export const // @ts-nocheck
  DealsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      DealsInsertInput
    >
  > = z.object({
    // @ts-nocheck
    alignment_status: Project_Health_StatusSchema.nullish(),
    assigned_users: z.array(z.string().nullable()).nullish(),
    // @ts-nocheck
    budget_status: Project_Health_StatusSchema.nullish(),
    chat_link_created_at: z.string().nullish(),
    chat_link_public_id: z.string().nullish(),
    chat_link_secret_encrypted: z.string().nullish(),
    close_date: z.string().nullish(),
    close_probability: z.number().nullish(),
    company_id: z.string().nullish(),
    company_name: z.string().nullish(),
    company_search_text: z.string().nullish(),
    contact_search_text: z.string().nullish(),
    contract_term_months: z.number().nullish(),
    cost: z.number().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    currency: z.string().nullish(),
    description: z.string().nullish(),
    engineer_ids: z.array(z.string().nullable()).nullish(),
    estimated_hours: z.number().nullish(),
    id: z.string().nullish(),
    is_committed: z.boolean().nullish(),
    is_recurring: z.boolean().nullish(),
    last_activity_at: z.string().nullish(),
    last_communication_at: z.string().nullish(),
    last_follow_up_task_created_at: z.string().nullish(),
    lost_at: z.string().nullish(),
    margin_percentage: z.number().nullish(),
    monthly_amount: z.number().nullish(),
    notes: z.string().nullish(),
    revenue: z.number().nullish(),
    // @ts-nocheck
    schedule_status: Project_Health_StatusSchema.nullish(),
    // @ts-nocheck
    scope_status: Project_Health_StatusSchema.nullish(),
    search_vector: z.any().nullish(),
    slack_channel_id: z.string().nullish(),
    slack_chat_thread_ts: z.string().nullish(),
    // @ts-nocheck
    stage: Deal_StageSchema.nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    won_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_ProposalsUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_ProposalsUpdateInput
    >
  > = z.object({
    amount: z.number().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    currency: z.string().nullish(),
    description: z.string().nullish(),
    expires_at: z.string().nullish(),
    file_name: z.string().nullish(),
    file_size: z.string().nullish(),
    file_url: z.string().nullish(),
    id: z.string().nullish(),
    notes: z.string().nullish(),
    responded_at: z.string().nullish(),
    sent_at: z.string().nullish(),
    // @ts-nocheck
    status: Proposal_StatusSchema.nullish(),
    terms_and_conditions: z.string().nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
    viewed_at: z.string().nullish(),
  });

export const // @ts-nocheck
  Contact_ProposalsInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_ProposalsInsertInput
    >
  > = z.object({
    amount: z.number().nullish(),
    contact_id: z.string().nullish(),
    created_at: z.string().nullish(),
    currency: z.string().nullish(),
    description: z.string().nullish(),
    expires_at: z.string().nullish(),
    file_name: z.string().nullish(),
    file_size: z.string().nullish(),
    file_url: z.string().nullish(),
    id: z.string().nullish(),
    notes: z.string().nullish(),
    responded_at: z.string().nullish(),
    sent_at: z.string().nullish(),
    // @ts-nocheck
    status: Proposal_StatusSchema.nullish(),
    terms_and_conditions: z.string().nullish(),
    title: z.string().nullish(),
    updated_at: z.string().nullish(),
    user_id: z.string().nullish(),
    viewed_at: z.string().nullish(),
  });

export const // @ts-nocheck
  CompaniesUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      CompaniesUpdateInput
    >
  > = z.object({
    active_contact_count: z.number().nullish(),
    active_deal_count: z.number().nullish(),
    address: z.string().nullish(),
    // @ts-nocheck
    alignment_status: Project_Health_StatusSchema.nullish(),
    // @ts-nocheck
    budget_status: Project_Health_StatusSchema.nullish(),
    city: z.string().nullish(),
    contract_expires_at: z.string().nullish(),
    contract_type: z.string().nullish(),
    country: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    created_by_backfilled_at: z.string().nullish(),
    current_technologies: z.record(z.string(), z.any()).nullish(),
    description: z.string().nullish(),
    domain: z.string().nullish(),
    email_aliases: z.array(z.string().nullable()).nullish(),
    employee_size: z.record(z.string(), z.any()).nullish(),
    google_drive_folder_id: z.string().nullish(),
    google_drive_folder_provisioned_at: z.string().nullish(),
    has_active_deals: z.boolean().nullish(),
    has_open_tickets: z.boolean().nullish(),
    has_signed_contract: z.boolean().nullish(),
    hourly_rate: z.number().nullish(),
    id: z.string().nullish(),
    industry: z.string().nullish(),
    last_contacted_at: z.string().nullish(),
    last_enriched_at: z.string().nullish(),
    last_follow_up_task_created_at: z.string().nullish(),
    line_contact_id: z.string().nullish(),
    monthly_rate: z.number().nullish(),
    name: z.string().nullish(),
    notes: z.string().nullish(),
    open_ticket_count: z.number().nullish(),
    organization_email: z.string().nullish(),
    organization_phone: z.string().nullish(),
    organization_revenue: z.number().nullish(),
    payment_terms: z.string().nullish(),
    phone_aliases: z.array(z.string().nullable()).nullish(),
    quickbooks_customer_name: z.string().nullish(),
    quickbooks_customer_ref: z.string().nullish(),
    quickbooks_sync_at: z.string().nullish(),
    // @ts-nocheck
    schedule_status: Project_Health_StatusSchema.nullish(),
    // @ts-nocheck
    scope_status: Project_Health_StatusSchema.nullish(),
    search_vector: z.any().nullish(),
    slack_channel_id: z.string().nullish(),
    social_links: z.record(z.string(), z.any()).nullish(),
    state: z.string().nullish(),
    status: z.string().nullish(),
    support_link_created_at: z.string().nullish(),
    support_link_public_id: z.string().nullish(),
    support_link_secret_encrypted: z.string().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    tax_id: z.string().nullish(),
    technical_identifiers: z.record(z.string(), z.any()).nullish(),
    total_deal_value: z.number().nullish(),
    trigger_enrichment: z.boolean().nullish(),
    updated_at: z.string().nullish(),
    uptime_monitoring_enabled: z.boolean().nullish(),
    website: z.string().nullish(),
    zip_code: z.string().nullish(),
  });

export const // @ts-nocheck
  CompaniesInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      CompaniesInsertInput
    >
  > = z.object({
    active_contact_count: z.number().nullish(),
    active_deal_count: z.number().nullish(),
    address: z.string().nullish(),
    // @ts-nocheck
    alignment_status: Project_Health_StatusSchema.nullish(),
    // @ts-nocheck
    budget_status: Project_Health_StatusSchema.nullish(),
    city: z.string().nullish(),
    contract_expires_at: z.string().nullish(),
    contract_type: z.string().nullish(),
    country: z.string().nullish(),
    created_at: z.string().nullish(),
    created_by: z.string().nullish(),
    created_by_backfilled_at: z.string().nullish(),
    current_technologies: z.record(z.string(), z.any()).nullish(),
    description: z.string().nullish(),
    domain: z.string().nullish(),
    email_aliases: z.array(z.string().nullable()).nullish(),
    employee_size: z.record(z.string(), z.any()).nullish(),
    google_drive_folder_id: z.string().nullish(),
    google_drive_folder_provisioned_at: z.string().nullish(),
    has_active_deals: z.boolean().nullish(),
    has_open_tickets: z.boolean().nullish(),
    has_signed_contract: z.boolean().nullish(),
    hourly_rate: z.number().nullish(),
    id: z.string().nullish(),
    industry: z.string().nullish(),
    last_contacted_at: z.string().nullish(),
    last_enriched_at: z.string().nullish(),
    last_follow_up_task_created_at: z.string().nullish(),
    line_contact_id: z.string().nullish(),
    monthly_rate: z.number().nullish(),
    name: z.string().nullish(),
    notes: z.string().nullish(),
    open_ticket_count: z.number().nullish(),
    organization_email: z.string().nullish(),
    organization_phone: z.string().nullish(),
    organization_revenue: z.number().nullish(),
    payment_terms: z.string().nullish(),
    phone_aliases: z.array(z.string().nullable()).nullish(),
    quickbooks_customer_name: z.string().nullish(),
    quickbooks_customer_ref: z.string().nullish(),
    quickbooks_sync_at: z.string().nullish(),
    // @ts-nocheck
    schedule_status: Project_Health_StatusSchema.nullish(),
    // @ts-nocheck
    scope_status: Project_Health_StatusSchema.nullish(),
    search_vector: z.any().nullish(),
    slack_channel_id: z.string().nullish(),
    social_links: z.record(z.string(), z.any()).nullish(),
    state: z.string().nullish(),
    status: z.string().nullish(),
    support_link_created_at: z.string().nullish(),
    support_link_public_id: z.string().nullish(),
    support_link_secret_encrypted: z.string().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    tax_id: z.string().nullish(),
    technical_identifiers: z.record(z.string(), z.any()).nullish(),
    total_deal_value: z.number().nullish(),
    trigger_enrichment: z.boolean().nullish(),
    updated_at: z.string().nullish(),
    uptime_monitoring_enabled: z.boolean().nullish(),
    website: z.string().nullish(),
    zip_code: z.string().nullish(),
  });

export const // @ts-nocheck
  App_UsersUpdateInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      App_UsersUpdateInput
    >
  > = z.object({
    available_hours: z.number().nullish(),
    config: z.record(z.string(), z.any()).nullish(),
    created_at: z.string().nullish(),
    email: z.string().nullish(),
    email_aliases: z.array(z.string().nullable()).nullish(),
    email_signature_title: z.string().nullish(),
    first_name: z.string().nullish(),
    hourly_rate: z.number().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    is_billable: z.boolean().nullish(),
    last_name: z.string().nullish(),
    meridian_default_email_connection_id: z.string().nullish(),
    meridian_default_email_provider: z.string().nullish(),
    meridian_google_calendar_use_second_account: z.boolean().nullish(),
    quickbooks_access_token: z.string().nullish(),
    quickbooks_active_realm_id: z.string().nullish(),
    quickbooks_connected_at: z.string().nullish(),
    quickbooks_connections: z.record(z.string(), z.any()).nullish(),
    quickbooks_employee_name: z.string().nullish(),
    quickbooks_employee_ref: z.string().nullish(),
    quickbooks_environment: z.string().nullish(),
    quickbooks_last_sync_at: z.string().nullish(),
    quickbooks_realm_id: z.string().nullish(),
    quickbooks_refresh_token: z.string().nullish(),
    quickbooks_token_expires_at: z.string().nullish(),
    role_id: z.string().nullish(),
    search_vector: z.any().nullish(),
    sensitive_feature_access: z.array(z.string().nullable()).nullish(),
    slack_user_id: z.string().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    updated_at: z.string().nullish(),
    user_prefs: z.record(z.string(), z.any()).nullish(),
  });

export const // @ts-nocheck
  App_UsersInsertInputSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      App_UsersInsertInput
    >
  > = z.object({
    available_hours: z.number().nullish(),
    config: z.record(z.string(), z.any()).nullish(),
    created_at: z.string().nullish(),
    email: z.string().nullish(),
    email_aliases: z.array(z.string().nullable()).nullish(),
    email_signature_title: z.string().nullish(),
    first_name: z.string().nullish(),
    hourly_rate: z.number().nullish(),
    id: z.string().nullish(),
    is_active: z.boolean().nullish(),
    is_billable: z.boolean().nullish(),
    last_name: z.string().nullish(),
    meridian_default_email_connection_id: z.string().nullish(),
    meridian_default_email_provider: z.string().nullish(),
    meridian_google_calendar_use_second_account: z.boolean().nullish(),
    quickbooks_access_token: z.string().nullish(),
    quickbooks_active_realm_id: z.string().nullish(),
    quickbooks_connected_at: z.string().nullish(),
    quickbooks_connections: z.record(z.string(), z.any()).nullish(),
    quickbooks_employee_name: z.string().nullish(),
    quickbooks_employee_ref: z.string().nullish(),
    quickbooks_environment: z.string().nullish(),
    quickbooks_last_sync_at: z.string().nullish(),
    quickbooks_realm_id: z.string().nullish(),
    quickbooks_refresh_token: z.string().nullish(),
    quickbooks_token_expires_at: z.string().nullish(),
    role_id: z.string().nullish(),
    search_vector: z.any().nullish(),
    sensitive_feature_access: z.array(z.string().nullable()).nullish(),
    slack_user_id: z.string().nullish(),
    tags: z.array(z.string().nullable()).nullish(),
    updated_at: z.string().nullish(),
    user_prefs: z.record(z.string(), z.any()).nullish(),
  });

export const // @ts-nocheck
  BigFloatListFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      BigFloatListFilter
    >
  > = z.object({
    containedBy: z.array(z.number()).nullish(),
    contains: z.array(z.number()).nullish(),
    eq: z.array(z.number()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    overlaps: z.array(z.number()).nullish(),
  });

export const // @ts-nocheck
  BigFloatFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      BigFloatFilter
    >
  > = z.object({
    eq: z.number().nullish(),
    gt: z.number().nullish(),
    gte: z.number().nullish(),
    in: z.array(z.number()).nullish(),
    // @ts-nocheck
    is: FilterIsSchema.nullish(),
    lt: z.number().nullish(),
    lte: z.number().nullish(),
    neq: z.number().nullish(),
  });

export const // @ts-nocheck
  Time_EntriesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Time_EntriesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Time_EntriesFilterSchema
        )
      )
      .nullish(),
    approved_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    approved_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    billable_rate: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    company_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    contact_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    date_worked: z.lazy(() =>
      // @ts-nocheck
      DateFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    end_time: z.lazy(() =>
      // @ts-nocheck
      TimeFilterSchema.nullish()
    ),
    entry_type: z.lazy(() =>
      // @ts-nocheck
      Time_Entry_TypeFilterSchema.nullish()
    ),
    hours: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_approved: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    is_software: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    last_follow_up_task_created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Time_EntriesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Time_EntriesFilterSchema
        )
      )
      .nullish(),
    quickbooks_customer_ref: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    quickbooks_employee_ref: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    quickbooks_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    start_time: z.lazy(() =>
      // @ts-nocheck
      TimeFilterSchema.nullish()
    ),
    sync_status: z.lazy(() =>
      // @ts-nocheck
      Sync_StatusFilterSchema.nullish()
    ),
    synced_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    ticket_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    ticket_number: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    ticket_title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    user_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  TicketsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      TicketsFilter
    >
  > = z.object({
    actual_hours: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            TicketsFilterSchema
        )
      )
      .nullish(),
    assigned_to: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    auto_assign: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    auto_escalate: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    billable_hours: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    category: z.lazy(() =>
      // @ts-nocheck
      Ticket_CategoryFilterSchema.nullish()
    ),
    closed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    company_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    contact_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    customer_visible_notes: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    description_byte_size: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    description_content_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    description_preview: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    description_s3_key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    discount_amount: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    discount_percentage: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    discount_type: z.lazy(() =>
      // @ts-nocheck
      Discount_TypeFilterSchema.nullish()
    ),
    due_date: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    escalation_level: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    estimated_hours: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    has_time_entries: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    hourly_rate: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    internal_notes: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    is_internal: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    is_software: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    last_activity_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    last_escalation_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    last_follow_up_task_created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    non_billable_hours: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      TicketsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            TicketsFilterSchema
        )
      )
      .nullish(),
    priority: z.lazy(() =>
      // @ts-nocheck
      Ticket_PriorityFilterSchema.nullish()
    ),
    reminder_sent: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    reminder_sent_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    resolved_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    sla_hours: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      Ticket_StatusFilterSchema.nullish()
    ),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    ticket_number: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    total_billed: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    total_cost: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Ticket_TemplatesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Ticket_TemplatesFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Ticket_TemplatesFilterSchema
        )
      )
      .nullish(),
    category: z.lazy(() =>
      // @ts-nocheck
      Ticket_CategoryFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    description_template: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    estimated_hours: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_active: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Ticket_TemplatesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Ticket_TemplatesFilterSchema
        )
      )
      .nullish(),
    sla_hours: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    title_template: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Revenue_TargetsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Revenue_TargetsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Revenue_TargetsFilterSchema
        )
      )
      .nullish(),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    currency: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Revenue_TargetsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Revenue_TargetsFilterSchema
        )
      )
      .nullish(),
    period_end: z.lazy(() =>
      // @ts-nocheck
      DateFilterSchema.nullish()
    ),
    period_start: z.lazy(() =>
      // @ts-nocheck
      DateFilterSchema.nullish()
    ),
    target_amount: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Recurring_TransactionsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Recurring_TransactionsFilter
    >
  > = z.object({
    amount: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Recurring_TransactionsFilterSchema
        )
      )
      .nullish(),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    company_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    contact_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    customer_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    item: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    last_error: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    last_error_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    last_synced_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    last_synced_month: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    next_retry_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Recurring_TransactionsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Recurring_TransactionsFilterSchema
        )
      )
      .nullish(),
    quantity: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    quickbooks_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    quickbooks_realm_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    retry_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    sync_status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    updated_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Post_Audit_InvoicesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Post_Audit_InvoicesFilter
    >
  > = z.object({
    amount_source: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Post_Audit_InvoicesFilterSchema
        )
      )
      .nullish(),
    approved_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    approved_by_slack_user_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    audit_month: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    category: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    environment: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    final_amount: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    ho_reference: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    line_description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Post_Audit_InvoicesFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Post_Audit_InvoicesFilterSchema
        )
      )
      .nullish(),
    post_audit_document_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    post_audit_number: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    proposed_amount: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    qb_customer_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    qb_customer_ref: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    qb_invoice_doc_number: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    qb_invoice_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    qb_item_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    qb_item_ref: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    qb_sync_token: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    realm_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    savings_figure: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    searched_company_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    send_method: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    sent_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Plaid_TransactionsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_TransactionsFilter
    >
  > = z.object({
    account_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    amount: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Plaid_TransactionsFilterSchema
        )
      )
      .nullish(),
    counterparty_entity_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    counterparty_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    date: z.lazy(() =>
      // @ts-nocheck
      DateFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    iso_currency_code: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    merchant_key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    merchant_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Plaid_TransactionsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Plaid_TransactionsFilterSchema
        )
      )
      .nullish(),
    pending: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    pfc_confidence: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    pfc_detailed: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    pfc_primary: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    plaid_transaction_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    raw_s3_key: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Plaid_AccountsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Plaid_AccountsFilter
    >
  > = z.object({
    account_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Plaid_AccountsFilterSchema
        )
      )
      .nullish(),
    available_balance: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    balance_updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    current_balance: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    enabled: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    iso_currency_code: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    label: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    mask: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Plaid_AccountsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Plaid_AccountsFilterSchema
        )
      )
      .nullish(),
    plaid_item_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    spend_profile: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    spend_profile_set_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    spend_profile_set_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    spend_profile_source: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    statements_drive_folder_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    subtype: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  OfferingsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      OfferingsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            OfferingsFilterSchema
        )
      )
      .nullish(),
    base_price: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    cta_href: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    cta_text: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    delivery_kit: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    executive_summary: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    image_url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    linked_project_slug: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      OfferingsFilterSchema.nullish()
    ),
    one_pager_pdf_url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            OfferingsFilterSchema
        )
      )
      .nullish(),
    pricing_display: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    pricing_model: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    total_cost: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    total_hard_costs: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    total_hours: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    website_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Mrr_SnapshotsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Mrr_SnapshotsFilter
    >
  > = z.object({
    account_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    amount: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Mrr_SnapshotsFilterSchema
        )
      )
      .nullish(),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    month: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Mrr_SnapshotsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Mrr_SnapshotsFilterSchema
        )
      )
      .nullish(),
    source: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Meridian_Usage_EventsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Meridian_Usage_EventsFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Usage_EventsFilterSchema
        )
      )
      .nullish(),
    cache_creation_input_tokens: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    cache_read_cost_usd: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    cache_read_input_tokens: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    cache_write_cost_usd: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    canonical_model_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    chat_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    duration_ms: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    feature: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    finish_reason: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    input_cost_usd: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    input_tokens: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    model_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Meridian_Usage_EventsFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Meridian_Usage_EventsFilterSchema
        )
      )
      .nullish(),
    output_cost_usd: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    output_tokens: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    pricing_unknown: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    provider: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    step_index: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    surface: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    total_cost_usd: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    total_tokens: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Invoice_Dunning_LogFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Invoice_Dunning_LogFilter
    >
  > = z.object({
    action: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    amount: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Invoice_Dunning_LogFilterSchema
        )
      )
      .nullish(),
    channel: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    customer_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    customer_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    cycle: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    days_overdue: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    doc_number: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    invoice_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Invoice_Dunning_LogFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Invoice_Dunning_LogFilterSchema
        )
      )
      .nullish(),
    realm_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    stage: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  DealsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      DealsFilter
    >
  > = z.object({
    alignment_status: z.lazy(() =>
      // @ts-nocheck
      Project_Health_StatusFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            DealsFilterSchema
        )
      )
      .nullish(),
    assigned_users: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    budget_status: z.lazy(() =>
      // @ts-nocheck
      Project_Health_StatusFilterSchema.nullish()
    ),
    chat_link_created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    chat_link_public_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    chat_link_secret_encrypted: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    close_date: z.lazy(() =>
      // @ts-nocheck
      DateFilterSchema.nullish()
    ),
    close_probability: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    company_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    company_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    company_search_text: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    contact_search_text: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    contract_term_months: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    cost: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    currency: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    engineer_ids: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    estimated_hours: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_committed: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    is_recurring: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    last_activity_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    last_communication_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    last_follow_up_task_created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    lost_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    margin_percentage: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    monthly_amount: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      DealsFilterSchema.nullish()
    ),
    notes: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            DealsFilterSchema
        )
      )
      .nullish(),
    revenue: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    schedule_status: z.lazy(() =>
      // @ts-nocheck
      Project_Health_StatusFilterSchema.nullish()
    ),
    scope_status: z.lazy(() =>
      // @ts-nocheck
      Project_Health_StatusFilterSchema.nullish()
    ),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    slack_channel_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    slack_chat_thread_ts: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    stage: z.lazy(() =>
      // @ts-nocheck
      Deal_StageFilterSchema.nullish()
    ),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    won_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  Contact_ProposalsFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      Contact_ProposalsFilter
    >
  > = z.object({
    amount: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_ProposalsFilterSchema
        )
      )
      .nullish(),
    contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    currency: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    expires_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    file_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    file_size: z.lazy(() =>
      // @ts-nocheck
      BigIntFilterSchema.nullish()
    ),
    file_url: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      Contact_ProposalsFilterSchema.nullish()
    ),
    notes: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            Contact_ProposalsFilterSchema
        )
      )
      .nullish(),
    responded_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    sent_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      Proposal_StatusFilterSchema.nullish()
    ),
    terms_and_conditions: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    user_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    viewed_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  CompaniesFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      CompaniesFilter
    >
  > = z.object({
    active_contact_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    active_deal_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    address: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    alignment_status: z.lazy(() =>
      // @ts-nocheck
      Project_Health_StatusFilterSchema.nullish()
    ),
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            CompaniesFilterSchema
        )
      )
      .nullish(),
    budget_status: z.lazy(() =>
      // @ts-nocheck
      Project_Health_StatusFilterSchema.nullish()
    ),
    city: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    contract_expires_at: z.lazy(() =>
      // @ts-nocheck
      DateFilterSchema.nullish()
    ),
    contract_type: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    country: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    created_by: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    created_by_backfilled_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    description: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    domain: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    email_aliases: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    google_drive_folder_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    google_drive_folder_provisioned_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    has_active_deals: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    has_open_tickets: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    has_signed_contract: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    hourly_rate: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    industry: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    last_contacted_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    last_enriched_at: z.lazy(() =>
      // @ts-nocheck
      DateFilterSchema.nullish()
    ),
    last_follow_up_task_created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    line_contact_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    monthly_rate: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    normalized_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      CompaniesFilterSchema.nullish()
    ),
    notes: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    open_ticket_count: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            CompaniesFilterSchema
        )
      )
      .nullish(),
    organization_email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    organization_phone: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    organization_revenue: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    payment_terms: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    phone_aliases: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    quickbooks_customer_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    quickbooks_customer_ref: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    quickbooks_sync_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    schedule_status: z.lazy(() =>
      // @ts-nocheck
      Project_Health_StatusFilterSchema.nullish()
    ),
    scope_status: z.lazy(() =>
      // @ts-nocheck
      Project_Health_StatusFilterSchema.nullish()
    ),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    slack_channel_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    state: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    status: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    support_link_created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    support_link_public_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    support_link_secret_encrypted: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    tax_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    total_deal_value: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    trigger_enrichment: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    uptime_monitoring_enabled: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    website: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    website_normalized: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    zip_code: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
  });

export const // @ts-nocheck
  App_UsersFilterSchema: z.ZodObject<
    Properties<
      // @ts-nocheck
      App_UsersFilter
    >
  > = z.object({
    and: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            App_UsersFilterSchema
        )
      )
      .nullish(),
    available_hours: z.lazy(() =>
      // @ts-nocheck
      IntFilterSchema.nullish()
    ),
    created_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    email: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    email_aliases: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    email_signature_title: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    first_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    hourly_rate: z.lazy(() =>
      // @ts-nocheck
      BigFloatFilterSchema.nullish()
    ),
    id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    is_active: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    is_billable: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    last_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    meridian_default_email_connection_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    meridian_default_email_provider: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    meridian_google_calendar_use_second_account: z.lazy(() =>
      // @ts-nocheck
      BooleanFilterSchema.nullish()
    ),
    nodeId: z.lazy(() =>
      // @ts-nocheck
      IdFilterSchema.nullish()
    ),
    not: z.lazy(() =>
      // @ts-nocheck
      App_UsersFilterSchema.nullish()
    ),
    or: z
      .array(
        z.lazy(
          () =>
            // @ts-nocheck
            App_UsersFilterSchema
        )
      )
      .nullish(),
    quickbooks_access_token: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    quickbooks_active_realm_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    quickbooks_connected_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    quickbooks_employee_name: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    quickbooks_employee_ref: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    quickbooks_environment: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    quickbooks_last_sync_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    quickbooks_realm_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    quickbooks_refresh_token: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    quickbooks_token_expires_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
    role_id: z.lazy(() =>
      // @ts-nocheck
      UuidFilterSchema.nullish()
    ),
    search_vector: z.lazy(() =>
      // @ts-nocheck
      OpaqueFilterSchema.nullish()
    ),
    sensitive_feature_access: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    slack_user_id: z.lazy(() =>
      // @ts-nocheck
      StringFilterSchema.nullish()
    ),
    tags: z.lazy(() =>
      // @ts-nocheck
      StringListFilterSchema.nullish()
    ),
    updated_at: z.lazy(() =>
      // @ts-nocheck
      DatetimeFilterSchema.nullish()
    ),
  });
